// AUTO-GENERATED by scripts/gen-content-manifest.mjs from src/content/**.mdx.
// Frontmatter only; MDX bodies are code-split and loaded lazily. Do not edit by
// hand, run `pnpm gen:content` to refresh.
export const contentManifest = {
  "blog": [
    {
      "slug": "4-best-tools-for-monitoring-llm-agentapplications-in-2026",
      "meta": {
        "title": "4 best tools for monitoring LLM & agent applications in 2026",
        "date": "2026-01-30T00:00:00.000Z",
        "author": "Bram P",
        "authorPhoto": "https://framerusercontent.com/images/OB3BklBp0JroME555CsLtUed5uA.jpg",
        "category": "LLM Evals",
        "intro": "Comprehensive guide to monitoring, observability, evaluation, and optimization for production LLM and AI agent applications with LangWatch.",
        "seoTitle": "4 Best LLM Monitoring Tools for 2026 Compared",
        "seoDescription": "Compare the best LLM monitoring tools for 2026, including LangWatch, Confident AI, Datadog, and Langfuse, to trace requests, control costs, and keep AI reliable.",
        "faq": [
          {
            "q": "What are the best LLM monitoring tools in 2026?",
            "a": "Top choices include LangWatch for all-in-one monitoring, evaluation, and agent testing, Confident AI for enterprise-wide evals and governance, Datadog for cross-stack infrastructure monitoring, and Langfuse for open-source self-hosting."
          },
          {
            "q": "Why does monitoring LLM applications matter?",
            "a": "LLM monitoring tackles cost control, quality assurance, and performance debugging by tracing prompts, responses, token usage, latency, and costs so teams catch regressions before they become customer-facing incidents."
          },
          {
            "q": "What is the difference between monitoring and observability?",
            "a": "Monitoring tracks known metrics like cost, latency, and error rate, while observability lets you explore unknown failures through detailed traces. LangWatch provides real-time observability with full pipeline visibility across multi-step agent runs."
          },
          {
            "q": "What makes LangWatch stand out for LLM monitoring?",
            "a": "LangWatch pairs OpenTelemetry-native agent tracing (waterfall, flame, topology, and sequence-diagram views) with online and offline evaluations on the same data, so monitoring feeds a proof loop instead of ending at a dashboard. It is open source under Apache-2.0 and self-hostable with EU data residency."
          },
          {
            "q": "Is LangWatch open source and self-hostable?",
            "a": "Yes. LangWatch is open source under Apache-2.0 and self-hosts on any plan via Docker, Kubernetes, VPC, or hybrid, with EU, US, UK, and APAC cloud options and EU data residency."
          }
        ]
      }
    },
    {
      "slug": "5-things-you-must-consider-before-putting-your-chatbot-live-in-production",
      "meta": {
        "title": "5 Things You Must Consider Before Putting Your Chatbot Live in Production",
        "date": "2024-05-01T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Prevent AI chatbots from handling out-of-scope questions, being manipulated, and addressing sensitive topics",
        "seoTitle": "5 Things to Check Before Your Chatbot Goes to Production",
        "seoDescription": "Before your AI chatbot goes live in production, guard against out-of-scope questions, jailbreaking, and sensitive topics that can damage your brand."
      }
    },
    {
      "slug": "7-predictions-for-ai-in-2025-a-cto-s-rogerio-chaves-perspective",
      "meta": {
        "title": "7 Predictions for AI in 2025: A CTO's, Rogerio Chaves Perspective",
        "date": "2025-01-01T00:00:00.000Z",
        "author": "Rogerio",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "image": "https://framerusercontent.com/images/XZm1R3DCPgHAy3EzoMXFixM5kc.png",
        "category": "Agents",
        "intro": "AI is evolving at speed, and the landscape in 2025 will be shaped across agents, multimodal data, and model efficiency.",
        "seoTitle": "7 AI Predictions for 2025 from a CTO's Perspective",
        "seoDescription": "7 predictions for AI in 2025 from CTO Rogerio Chaves, covering agents, multimodal data, smaller efficient models, and the shifting LLM provider race."
      }
    },
    {
      "slug": "a-note-on-the-litellm-vulnerability",
      "meta": {
        "title": "A Note on the LiteLLM Vulnerability",
        "date": "2026-03-25T00:00:00.000Z",
        "author": "Rogerio",
        "authorPhoto": "https://framerusercontent.com/images/3sbYUsqJyjvL6m3yud7Mgch8yyg.png",
        "category": "Governance AI",
        "intro": "On March 24, 2026 at 11:28 UTC, a malicious file was identified in version 1.82.8 of LiteLLM containing a credential-stealing script . LangWatch customers are safe. No cloud or self-hosted customers were affected.",
        "seoTitle": "A Note on the LiteLLM Vulnerability and LangWatch",
        "seoDescription": "A malicious credential-stealing file appeared in LiteLLM 1.82.8. LangWatch customers were not impacted because all dependencies are pinned with lockfiles.",
        "faq": [
          {
            "q": "Were LangWatch customers affected by the LiteLLM vulnerability?",
            "a": "No. No cloud or self-hosted LangWatch customers were affected. All LangWatch components pin dependency versions using pnpm-lock.yaml and uv.lock across TypeScript and Python, which prevented any automatic pull of the compromised LiteLLM release."
          },
          {
            "q": "What was the LiteLLM vulnerability?",
            "a": "On March 24, 2026, version 1.82.8 of LiteLLM contained a malicious file with a credential-stealing script that executed automatically on install. The compromised version was published for several hours before being quarantined and removed from PyPI."
          },
          {
            "q": "Who should take precautions after the LiteLLM incident?",
            "a": "Organizations that performed unlocked installations of LiteLLM on March 24, 2026 should review their environments, since many tools depend on it, including the langwatch-scenario Python library used in development rather than production."
          },
          {
            "q": "What additional steps did LangWatch take?",
            "a": "LangWatch is now pinning all GitHub Actions to commit SHAs to protect against tag-hijacking supply chain attacks, with Dependabot configured to flag updates so pinned versions stay current."
          }
        ]
      }
    },
    {
      "slug": "a-systematic-way-of-testing-of-ai-agents",
      "meta": {
        "title": "A Systematic way of Testing of AI Agents",
        "date": "2025-11-20T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/asTRQ6ousPnVp0wScxrHlwro.png",
        "category": "Agents",
        "intro": "A practical guide to experiments, evaluations, and simulations in LangWatch.",
        "seoTitle": "A Systematic Way of Testing AI Agents",
        "seoDescription": "A practical guide to testing AI agents systematically with experiments, evaluations, and simulations in LangWatch to prevent regressions and ship with evidence."
      }
    },
    {
      "slug": "ai-agent-monitoring",
      "meta": {
        "title": "AI agent monitoring: hear about a broken agent before a customer does",
        "date": "2026-10-29T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/ai-agent-monitoring-cover.webp",
        "listImage": true,
        "category": "Agents",
        "keyphrase": "ai agent monitoring",
        "intro": "AI agent monitoring means judges on your live traffic, alerts on the filters and graphs you already use, and every failure you find turned into a test, so you hear about a broken agent from an alert before a customer opens a ticket.",
        "seoTitle": "AI Agent Monitoring: Live Judges, Alerts and Tests",
        "seoDescription": "AI agent monitoring: judges on live traffic, alerts from trace filters and graphs, and every production failure turned into a dataset row or test.",
        "faq": [
          {
            "q": "What tools can I use to monitor my AI chatbot's performance?",
            "a": "Use tracing that records every conversation with its tool calls, cost and latency, evaluators that judge live conversations against your own criteria, and alerts that reach Slack, email or a webhook when either one goes wrong. LangWatch does all three in one open-source platform, and APM tools still cover the servers underneath."
          },
          {
            "q": "How do I monitor my AI chatbot's performance?",
            "a": "Trace every conversation, then put an LLM judge on live traffic with the one question that matters for your product, such as whether the bot answered or turned the user away. Create an automation on the failing traces so they reach Slack or a dataset, and add a graph alert on p95 latency and cost."
          },
          {
            "q": "What is the difference between AI agent monitoring and LLM monitoring?",
            "a": "LLM monitoring watches single model calls: latency, tokens, cost and errors. AI agent monitoring watches the whole run, with the tool calls, the retries and every turn of the conversation, and judges whether the user got what they came for. An agent can make ten fine model calls and still fail the user."
          },
          {
            "q": "Do online evaluations slow down my agent?",
            "a": "No. In LangWatch a monitor scores the trace after the response is sent, so it never delays or blocks the reply. You can also sample a share of the traffic on expensive judges. If you need to stop a bad answer before the user sees it, run the evaluator as a guardrail from your code instead."
          },
          {
            "q": "Can my coding agent set up monitoring for me?",
            "a": "Yes. The LangWatch CLI and MCP server create monitors, automations and graph alerts, list what fired, and read the traces behind a failure. You describe what bad looks like to Claude Code or Codex, and it can create the monitor and the automation that sends the failures to Slack or a dataset."
          }
        ]
      }
    },
    {
      "slug": "april-product-recap-selene-integration-eval-wizard-upgrades-prompt-studio-more",
      "meta": {
        "title": "April Product Recap: Selene Integration, Eval Wizard Upgrades, Prompt Studio & More",
        "date": "2025-05-05T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "intro": "LangWatch Selente - Atla, LLM Evaluations, prompt versioning, structured output, OpenTelemetry SDK, LLMops ISO certified",
        "seoTitle": "LangWatch April Recap: Atla Selene & Eval Wizard",
        "seoDescription": "See LangWatch's April product updates: the Atla Selene LLM-as-a-Judge integration, Evaluation Wizard upgrades, Prompt Studio, and a new OpenTelemetry SDK."
      }
    },
    {
      "slug": "are-evals-dead",
      "meta": {
        "title": "Are evals dead?",
        "date": "2025-09-07T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "category": "LLM Evals",
        "intro": "Are evals dead? A pragmatic analysis",
        "seoTitle": "Are Evals Dead? A Pragmatic Analysis",
        "seoDescription": "Are evals dead? We unpack the loudest claims against LLM evals, add nuance, and show why owning your own domain evals still matters for AI quality."
      }
    },
    {
      "slug": "arize-ai-alternatives-top-5-arize-competitors-compared-(2026)",
      "meta": {
        "title": "Arize AI alternatives: Top 5 Arize competitors compared (2026)",
        "date": "2026-01-30T00:00:00.000Z",
        "author": "Bram P",
        "authorPhoto": "https://framerusercontent.com/images/OB3BklBp0JroME555CsLtUed5uA.jpg",
        "category": "LLM Evals",
        "intro": "LangWatch wins for teams shipping production LLM applications with complex AI agents. Agent simulation testing, collaboration with PM's, OpenTelemetry-native tracing make it the most complete platform for agentic AI.",
        "seoTitle": "Arize AI Alternatives: Top 5 Competitors for 2026",
        "seoDescription": "Compare the top 5 Arize AI alternatives for 2026, including LangWatch, Confident AI, Langfuse, LangSmith, and Helicone, to find the right LLM observability platform.",
        "faq": [
          {
            "q": "What are the best Arize AI alternatives in 2026?",
            "a": "Strong Arize alternatives include LangWatch for agent simulation and evaluation, Confident AI for eval and observability standardization across teams, Langfuse for open-source flexibility, LangSmith for LangChain users, and Helicone for proxy-based observability."
          },
          {
            "q": "Why do teams look for Arize AI alternatives?",
            "a": "Arize was built ML-first, so teams building production LLM agents often hit gaps like no agent simulation testing, limited prompt optimization, and evaluation and tracing living in separate workflows."
          },
          {
            "q": "Which Arize alternative is best for testing AI agents?",
            "a": "LangWatch is the most complete option for agent testing. Its Scenario framework simulates multi-turn and voice-agent conversations with a User Simulator and a Judge Agent, runnable in CI/CD as merge-blocking gates, which Arize and most alternatives cannot do."
          },
          {
            "q": "Does Arize have a free tier for LLM tracing?",
            "a": "Arize Phoenix offers a free tier with 25K trace spans per month for one user. LangWatch provides a generous free tier plus unlimited free self-hosting with no feature restrictions, including agent simulation and evaluation."
          },
          {
            "q": "Can I self-host LangWatch for free?",
            "a": "Yes. LangWatch is open source under Apache-2.0 and self-hosts free with no feature limits via Docker or Kubernetes, with hybrid and EU, US, UK, and APAC options and ISO 27001 and GDPR compliance."
          },
          {
            "q": "Which platform is best for cross-functional collaboration?",
            "a": "LangWatch was designed for cross-functional teams with a dual interface: domain experts create and review evaluations in the UI without coding, while developers build via APIs and SDKs, so technical and non-technical stakeholders share ownership of AI quality."
          }
        ]
      }
    },
    {
      "slug": "background-agents-before-claude-tag",
      "meta": {
        "title": "Background Agents on Slack: How we built our own Claude Tag before it was cool",
        "date": "2026-07-05T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "category": "Developer findings",
        "keyphrase": "background agents",
        "intro": "A fleet of background agents runs a chunk of our engineering, each one scoped to one job and living in its own Slack channel. We built it before Anthropic shipped the same shape as Claude Tag.",
        "seoTitle": "Background Agents on Slack: How We Built Our Own Claude Tag",
        "seoDescription": "Seven background agents run our own engineering, each scoped to one job in its own Slack channel, months before Anthropic shipped the pattern as Claude Tag.",
        "faq": [
          {
            "q": "What is a background agent?",
            "a": "For us it is a coding agent running headless on a schedule, scoped to one repo and a handful of tools, and wired to its own Slack channel. It wakes up, does one job like triaging Dependabot alerts or rewriting a slow query, opens a pull request, and posts what it did in the channel so we can steer it. It cannot merge; a person makes every merge call."
          },
          {
            "q": "How is this different from Claude Tag?",
            "a": "It is the same shape. Claude Tag, which Anthropic launched on 23 June 2026, is a persistent Claude in a Slack channel with scoped access that you tag and hand work to. We built our own version out of a coding agent, a Slack app, and a scheduler before it had a name. The main difference is ownership: our transcripts and memory live on our own box rather than inside one vendor."
          },
          {
            "q": "Can background agents merge their own code?",
            "a": "Ours cannot, on purpose. Every agent prompt ends with the same instruction: open a pull request, never merge, never approve. A human reviews and merges everything. That single rule is what makes it safe to leave the fleet running."
          },
          {
            "q": "Do you still need people if agents do the work?",
            "a": "Yes, more than the demos suggest. Left alone, an agent will write down a confident, slightly wrong answer and move on. The value shows up when a human pushes back in the thread and the agent rechecks and corrects itself. It saves us the work of starting something; someone still has to read what comes back."
          }
        ]
      }
    },
    {
      "slug": "best-ai-agent-frameworks-in-2025-comparing-langgraph-dspy-crewai-agno-and-more",
      "meta": {
        "title": "Best AI Agent Frameworks in 2025: Comparing LangGraph, DSPy, CrewAI, Agno, and More",
        "date": "2025-06-21T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "image": "https://framerusercontent.com/images/VkFxbrc7e15bT95Hris0KiFU.png",
        "category": "Agents",
        "intro": "Explore a detailed, developer-tested comparison of top AI agent frameworks in 2025, including LangGraph, DSPy, Agno and more.",
        "seoTitle": "Best AI Agent Frameworks in 2025: A Hands-On Guide",
        "seoDescription": "Compare the best AI agent frameworks in 2025, including LangGraph, DSPy, CrewAI, and Agno, each tested by building a real customer support agent."
      }
    },
    {
      "slug": "best-llm-gateways-in-2026",
      "meta": {
        "title": "The 8 Best LLM Gateways in 2026: Compared for Production",
        "date": "2026-08-12T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Governance AI",
        "image": "/blog/best-llm-gateways-hero.webp",
        "listImage": true,
        "keyphrase": "llm gateway",
        "intro": "An LLM gateway is now the control point where AI spend, security, and observability converge. We compare LangWatch, LiteLLM, Portkey, OpenRouter, Kong, Vercel, Cloudflare, and Amazon Bedrock on governance, latency, and pricing.",
        "seoTitle": "LLM Gateway Guide 2026: The 8 Best, Compared",
        "seoDescription": "Compare the best LLM gateways of 2026: LangWatch, LiteLLM, Portkey, OpenRouter, Kong, Vercel AI Gateway, Cloudflare, and Amazon Bedrock, on governance, latency, and pricing.",
        "faq": [
          {
            "q": "What is an LLM gateway?",
            "a": "An LLM gateway is a proxy that sits between your applications and model providers, exposing one API for many models while adding credentials management, budgets, routing, fallback, caching, guardrails, and usage tracking in the request path. Instead of every app holding raw provider keys, traffic flows through one governed endpoint."
          },
          {
            "q": "What is the best LLM gateway in 2026?",
            "a": "It depends on your operating model. LangWatch leads for enterprises that need governance: virtual keys, hierarchical budgets, inline guardrails, and per-team observability in one platform. LiteLLM is the strongest pure open-source proxy, OpenRouter is best for model variety with minimal setup, and Amazon Bedrock fits AWS-committed teams."
          },
          {
            "q": "Do LLM gateways add latency?",
            "a": "They add one network hop plus processing overhead, and the overhead varies enormously by implementation. LangWatch's Go-based gateway measures around 11 microseconds of gateway-side overhead at 5,000 sustained requests per second, while Python-based proxies typically add milliseconds. Edge gateways like Cloudflare minimize the network hop by terminating close to users."
          },
          {
            "q": "Which LLM gateways are open source?",
            "a": "LiteLLM's core proxy is open source, LangWatch is open source (Apache-2.0) with a self-hostable gateway shipped via Helm, and Kong's AI plugins build on the open-source Kong Gateway. Portkey, OpenRouter, Vercel AI Gateway, Cloudflare AI Gateway, and Amazon Bedrock are managed services."
          },
          {
            "q": "What happened to Portkey?",
            "a": "Palo Alto Networks announced its intent to acquire Portkey in spring 2026 and completed the acquisition in May 2026. Portkey's AI gateway is being folded into Palo Alto's Prisma AIRS platform as a control plane for securing AI agents, which orients its roadmap toward that security suite."
          },
          {
            "q": "Can an LLM gateway govern coding agents like Claude Code and Cursor?",
            "a": "Only if it preserves the streaming tool-call format those tools depend on and can issue per-developer credentials. LangWatch supports Claude Code, Codex, Cursor, Gemini CLI, opencode, and Aider through Anthropic- and OpenAI-compatible endpoints with personal virtual keys per engineer. Most gateways on this list target application traffic only."
          },
          {
            "q": "How do LLM gateways handle provider outages?",
            "a": "Through fallback chains: when a provider returns a 5xx error, a timeout, or a rate limit, the gateway retries the request against the next configured provider. The details matter: LangWatch makes fallback an explicit per-key choice and never retries client errors, LiteLLM and Portkey offer configurable retry and fallback policies, and Cloudflare and Vercel handle fallback at their edge."
          },
          {
            "q": "What is the difference between an LLM gateway and an API gateway?",
            "a": "An API gateway routes and secures generic HTTP traffic. An LLM gateway understands the semantics of model calls: tokens and their cost, streaming deltas, tool calls, prompt caching, and model-specific failure modes. That is why token-level budgets, semantic caching, and guardrails on responses only exist in the LLM-specific layer."
          }
        ]
      }
    },
    {
      "slug": "build-an-evaluation-dataset-from-production-traces",
      "meta": {
        "title": "How to build an evaluation dataset from your production traces",
        "date": "2026-11-04T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "category": "LLM Evals",
        "tags": [
          "golden dataset",
          "evaluation dataset",
          "instant evals",
          "langwatch sql",
          "automations",
          "datasets"
        ],
        "keyphrase": "golden dataset",
        "intro": "Already running your agent in beta or production? Then your users have been writing your test cases for you. Here is how to find those conversations in LangWatch, turn them into an evaluation dataset and keep it growing on its own.",
        "seoTitle": "Golden Dataset: How to Build an Evaluation Dataset from Production Traces",
        "seoDescription": "Build a golden dataset from production traces in LangWatch: search traces, judge every conversation with Instant Evals, query with LangWatch SQL, add to a dataset and automate it.",
        "image": "/blog/build-an-evaluation-dataset-from-production-traces-cover.webp",
        "listImage": true,
        "faq": [
          {
            "q": "What is a golden dataset?",
            "a": "A golden dataset is a set of real inputs, each with the answer you expect, that you trust enough to judge every change against. You run a new prompt, model or agent version on it and compare the scores before you ship."
          },
          {
            "q": "How do I build an evaluation dataset for my AI product?",
            "a": "Take it from your production traces. In LangWatch, narrow the Trace Explorer with filters, ask a plain question of every conversation with an Instant Eval, select the matches and click Add to dataset. Then click Automate on the same filter, so new matching traces land in the dataset as they arrive."
          },
          {
            "q": "How many examples does a golden dataset need?",
            "a": "Start with a few dozen rows you have read yourself and grow it from every real failure. Keep the everyday requests in it too, in about the mix your users send, so a fix for one case does not break the common ones."
          },
          {
            "q": "Can I use synthetic data for an evaluation dataset?",
            "a": "Before launch, yes: generate rows from your docs and specs. Once real users arrive, move to production traces. Generated rows hold the situations you imagined, and real users bring the ones you did not."
          },
          {
            "q": "How do I keep an evaluation dataset up to date?",
            "a": "Run your question on live traffic as an online evaluation, filter the Trace Explorer on the traces it fails, and click Automate with Add to dataset as the action. Every new failing trace becomes a row as it comes in."
          }
        ]
      }
    },
    {
      "slug": "build-vs-buy-should-you-build-your-own-llmops-stack-or-leverage-a-purpose-built-platform-designed-for-enterprise-scale",
      "meta": {
        "title": "Build vs Buy - Should you build your own LLMOps stack or leverage a purpose-built platform designed for enterprise scale?",
        "date": "2025-10-17T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "LangWatch gives enterprises the missing layer of control between LLMs, production systems, without the engineering overhead.",
        "seoTitle": "Build vs Buy Your LLMOps Stack for Enterprise Scale",
        "seoDescription": "Build vs buy your LLMOps stack? Weigh the hidden costs of in-house builds against a purpose-built platform like LangWatch designed for enterprise scale."
      }
    },
    {
      "slug": "building-an-llm-eval-framework-that-actually-works-in-practice",
      "meta": {
        "title": "Practical LLM Evaluation Framework for AI Development Teams",
        "date": "2025-03-20T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/lg95RjY6iAdH0LiPnE2WIjDOUPE.png",
        "category": "LLM Evals",
        "intro": "Deploy an LLM evaluation framework that catches issues early. Reduce debugging time and improve AI quality.",
        "seoTitle": "Build an LLM Evaluation Framework That Works",
        "seoDescription": "Build a practical LLM evaluation framework that catches issues early. Pick the right eval criteria, measure what matters, and iterate to ship better AI."
      }
    },
    {
      "slug": "building-reliable-ai-applications-why-evals-(and-scenarios)-are-the-backbone-of-trustworthy-ai",
      "meta": {
        "title": "Building Reliable AI Applications: Why Evals (and Scenarios) Are the backbone of trustworthy AI",
        "date": "2025-09-25T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Discover why LLM evaluations, and AI agent testing are the backbone of reliable AI apps and to ship LLM apps with confidence",
        "seoTitle": "Building Reliable AI Applications with Evals",
        "seoDescription": "Building reliable AI applications starts with LLM evals and scenarios. Learn what evals really are, why they matter, and how to ship trustworthy AI."
      }
    },
    {
      "slug": "can-you-list-every-ai-agent-running-in-your-company",
      "meta": {
        "title": "Can you list every AI agent running in your company right now?",
        "date": "2026-08-14T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Governance AI",
        "image": "/blog/agent-inventory-hero.webp",
        "listImage": true,
        "keyphrase": "ai agent inventory",
        "intro": "Not the approved ones. The running ones. Most companies cannot answer, and the fix is not another policy document: it is an AI agent inventory that reconciles what the company bought against what people actually run.",
        "seoTitle": "AI Agent Inventory: List Every Running Agent",
        "seoDescription": "Most companies cannot list the AI agents actually running. Why policies fail without an AI agent inventory, the five questions it must answer, and how to build one.",
        "faq": [
          {
            "q": "What is an AI agent inventory?",
            "a": "An AI agent inventory is a living catalog of every AI agent and tool actually running in an organization: which tool and where it runs, who owns it, what it really costs, whether anyone uses it, and the initiative behind it. It reconciles what the company bought (licenses and subscriptions) against what people actually use."
          },
          {
            "q": "Why don't AI policy documents work on their own?",
            "a": "Because policies apply to a world you can see. A rule like \"only approved agents may access customer data\" does nothing about an agent nobody knows exists. You cannot govern what you cannot list, so the first governance artifact is the inventory, and policy comes after."
          },
          {
            "q": "What should an AI agent inventory include?",
            "a": "Five answers per agent: the specific tool and platform it runs on, a named owner (a person, not a team), real spend rather than the license price, seats bought against seats active, and the initiative behind it. A tool name alone tells you almost nothing you can act on."
          },
          {
            "q": "What is shadow AI?",
            "a": "AI tools and agents running in an organization without anyone approving or tracking them: a data-team experiment that never got turned off, agent features switching themselves on inside SaaS like Jira, Linear, and Notion, or developers on personal-plan coding agents. An agent nobody can attach an owner or a reason to is either shadow AI or a renewal waiting to be cancelled."
          },
          {
            "q": "How do you find idle AI spend?",
            "a": "Compare seats bought against seats active per tool, priced. A $6,000 monthly seat allocation where a third sits idle is a different fact than a $6,000 bill, and idle licences are the cheapest thing to cut and the easiest to miss without an inventory that reconciles both sides."
          },
          {
            "q": "How does LangWatch Governance build the inventory?",
            "a": "LangWatch Governance reconciles every license and subscription against actual usage, then attaches the owner and the initiative to each agent: one catalog with the tool, seats bought versus active, spend, idle waste, owner, and department. Every figure carries where it came from and how fresh it is."
          }
        ]
      }
    },
    {
      "slug": "claude-code-usage-tracking",
      "meta": {
        "title": "Launching Claude Code usage tracking: see where your tokens go",
        "date": "2026-07-31T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "image": "/blog/claude-code-usage-hero-terminal.webp",
        "listImage": true,
        "keyphrase": "claude code usage tracking",
        "intro": "Run npx langwatch claude once and every session lands in LangWatch: per-session cost, cache reads and writes as separate token classes, every tool call as a span, and a replay of your whole terminal session.",
        "seoTitle": "Claude Code Usage Tracking: See Where Tokens Go",
        "seoDescription": "Track Claude Code usage with one command: per-session cost, cache reads and writes as separate token classes, tool calls as spans, and a full session replay.",
        "faq": [
          {
            "q": "How do I track my Claude Code usage?",
            "a": "Run npx langwatch claude once. It writes three environment variables into ~/.claude/settings.json that point Claude Code's native OpenTelemetry export at LangWatch. Every session then lands in your project with cost, token classes, tool-call spans, and a terminal replay. Free for individual use."
          },
          {
            "q": "Does LangWatch track cache reads separately from input tokens?",
            "a": "Yes. Cache reads, cache writes, input, and output are four differently priced token classes, and cache writes split again into 5 minute and 1 hour TTLs. LangWatch tracks each class separately on every span, because lumping cache into input gets both the token total and the cost wrong."
          },
          {
            "q": "Does this work for Codex, Gemini CLI, and opencode too?",
            "a": "Yes. The same npx langwatch command wires up Codex, Gemini CLI, and opencode the same way, and the terminal replay and usage breakdown work for every agent LangWatch tracks."
          },
          {
            "q": "Can I see what Claude Code would have cost on the API versus my Max plan?",
            "a": "Yes. The theoretical vs billed view prices your sessions at API list prices next to what you actually pay on a Max plan, which answers whether the subscription pays for itself. On the API, cost comes straight from the responses."
          }
        ]
      }
    },
    {
      "slug": "closing-the-year-strong-december-product-updates",
      "meta": {
        "title": "Closing the year Strong: December Product Updates",
        "date": "2025-12-24T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "intro": "LangWatch has a completely new dashboard and visual design, Evaluations, traces, and signals are now front and center. the LangWatch team wants to wish you happy holidays and a healthy, successful 2026.",
        "seoTitle": "LangWatch December Product Updates: New Dashboard",
        "seoDescription": "LangWatch December product updates bring a redesigned dashboard and UI that puts evaluations, traces, and signals front and center for production agents."
      }
    },
    {
      "slug": "codex-vs-claude-code",
      "meta": {
        "title": "Claude vs Codex: which is the better background agent?",
        "date": "2026-07-08T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "image": "/blog/codex-vs-claude-code.webp",
        "category": "Article",
        "keyphrase": "codex vs claude code",
        "intro": "Some of our preferences and stories on Claude and Codex at LangWatch.",
        "seoTitle": "Codex vs Claude Code: Which Is the Better Background Agent? (2026)",
        "seoDescription": "A fleet of background agents runs LangWatch's engineering: most build on Claude Code, one reviews on Codex. Our Codex vs Claude Code take: Claude builds, Codex reviews.",
        "faq": [
          {
            "q": "Is Claude Code or Codex the better background agent?",
            "a": "For us it splits by job. Claude Code is the better builder and runs most of our background agents, the ones that open PRs. Codex is the better reviewer and runs the one that reads a diff and grades it: on demand when we want a second opinion on our own PR, and on a weekday-morning schedule that reviews pull requests from outside the org. The ranking moves with every model release, so the honest answer is to run both on two weeks of your own tickets rather than trust a leaderboard."
          },
          {
            "q": "Can you use Codex and Claude Code together?",
            "a": "Yes, and we do daily. Both read plain markdown instruction files (CLAUDE.md and AGENTS.md), we run both inside tmux, and our Codex agent reviews the pull requests our Claude Code agents open when we ask it to. It also runs a scheduled weekday-morning scan that reviews pull requests from outside the org, forks included, treating that code as untrusted. Having the reviewer be a different model from the author is close to free and catches mistakes a model tends to wave through in its own work."
          },
          {
            "q": "Is Codex a better code reviewer than CodeRabbit?",
            "a": "They do different jobs, so we keep both. CodeRabbit is fast and thorough on the nitpicky layer and hidden line-level bugs. Codex goes after the critical design and correctness issues, what we track as P1 and P2. Paying for two reviewers is cheap next to one bad merge."
          },
          {
            "q": "Can you run Codex with a different harness?",
            "a": "Yes. The Codex CLI is open-source Rust and you can drive the models from another harness like opencode, pi-mono, or one you build yourself. Claude Code keeps you on its own CLI. We run both inside tmux, so from where we sit the harness underneath does not change how we start, watch, or stop them."
          },
          {
            "q": "How do you measure which coding agent is better?",
            "a": "Because no agent can merge its own work, quality shows up as review friction: how often we rewrite the diff, how often a review comment misses, how often a run produces nothing worth merging. When that is not enough we trace sessions over OpenTelemetry, which both tools export, and compare on cost per merged PR, the one metric that survives pricing changes."
          }
        ]
      }
    },
    {
      "slug": "context-tax-when-to-compact",
      "meta": {
        "title": "The Context Tax: When to Compact Your Coding Agent",
        "date": "2026-08-02T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "image": "/images/blog/context-tax/cover.webp",
        "listImage": true,
        "category": "Article",
        "intro": "Analysis of 2,451 agent sessions, 287,748 traced API calls, 201 manually audited steps and 873 compactions: please compact.",
        "seoTitle": "When Should a Coding Agent Compact? 287k API Calls Measured",
        "seoDescription": "We traced 287,748 Claude Code API calls and 873 real compactions. Context cost grows as size^2.5: run compaction between 250k and 450k tokens.",
        "keyphrase": "compaction"
      }
    },
    {
      "slug": "cost-per-successful-task",
      "meta": {
        "title": "Cost per successful task: the metric that will decide your AI stack when model subsidies end",
        "date": "2026-07-03T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Cost per successful task is run cost divided by success rate. As model subsidies end, it becomes the number that decides your AI stack. Here is how to calculate it and switch models without losing quality.",
        "seoTitle": "Cost per Successful Task: Pricing AI Agents After Subsidies",
        "seoDescription": "Cost per successful task = run cost ÷ success rate. Learn how to calculate it for your AI agents and switch to cheaper models before flat-rate plans end.",
        "faq": [
          {
            "q": "What is cost per successful task?",
            "a": "Cost per successful task is the total cost of running an AI agent on a task divided by the rate at which it completes the task correctly. It measures what an outcome costs rather than what an attempt costs, which makes it the key economic metric for agentic AI workloads."
          },
          {
            "q": "How is it different from cost per token or cost per request?",
            "a": "Cost per token measures inference volume and cost per request measures attempts, and neither accounts for failures. An agent that fails 85% of the time has a cost per successful outcome nearly 7x its cost per run, plus the human cost of catching those failures."
          },
          {
            "q": "How do I measure my agent's success rate?",
            "a": "Define explicit success criteria per workflow, then evaluate at two levels: LLM-as-judge evals on production traces for individual outputs, and multi-turn simulations (for example with Scenario) for end-to-end task completion, including tool-call correctness across the whole conversation."
          },
          {
            "q": "Can I switch to a cheaper open-weight model without losing quality?",
            "a": "Often yes, but only workloads validated by evals and simulations should switch. Run the same scenario suite against your current model and the candidate, compare outcome success rates, and compute cost per successful task for both. If the cheaper model holds your bar, the switch pays for itself immediately."
          }
        ]
      }
    },
    {
      "slug": "customer-case-study-algomos-experience-with-langwatch",
      "meta": {
        "title": "How Algomo reduced AI hallucinations with LangWatch",
        "date": "2024-06-11T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "How Algomo increased the quality of their AI app with LangWatch",
        "seoTitle": "Algomo Case Study: Cutting AI Hallucinations With LangWatch",
        "seoDescription": "See how Algomo uses LangWatch alerts, labels, and custom analytics to catch AI hallucinations, fix data issues fast, and improve their AI agents daily."
      }
    },
    {
      "slug": "customer-story-how-roojoom-automates-ai-agent-quality-control-with-langwatch-scenario",
      "meta": {
        "title": "Customer Story: How Roojoom automates AI Agent Quality Control with LangWatch Scenario",
        "date": "2025-06-25T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Agents",
        "intro": "Using LangWatch Scenario, the Rojoom product team built a daily automation way to ship new AI features with confidence.",
        "seoTitle": "How Roojoom Automates AI Agent Quality Control",
        "seoDescription": "See how Roojoom uses LangWatch Scenario to automate AI agent quality control, catch prompt regressions, and ship new AI features with confidence at scale."
      }
    },
    {
      "slug": "data-flywheel",
      "meta": {
        "title": "Data Flywheel: Using your production data to build better LLM products",
        "date": "2024-06-27T00:00:00.000Z",
        "author": "Rogerio - CTO",
        "authorPhoto": "https://framerusercontent.com/images/fnGfSoEC5VVQejLuz2u1ZX6GvA.jpeg",
        "category": "LLM Evals",
        "intro": "Data Flywheel: using your production data to build better LLM products",
        "seoTitle": "Data Flywheel: Turn Production Data Into Better LLMs",
        "seoDescription": "A data flywheel turns real production interactions into better LLM products. Learn how to monitor, evaluate, and improve your AI in a tight feedback loop."
      }
    },
    {
      "slug": "debug-production-ai-agents-from-your-editor-with-mcp",
      "meta": {
        "title": "Debug production AI agents from your editor with MCP",
        "date": "2026-11-02T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "category": "Agents",
        "tags": [
          "langwatch mcp",
          "mcp",
          "claude code",
          "cursor",
          "codex",
          "debugging",
          "agent testing"
        ],
        "keyphrase": "langwatch mcp",
        "intro": "The LangWatch MCP server lets Claude Code, Cursor or Codex search your production traces, read the bad ones and write a scenario test that reproduces the failure, without you leaving the editor where the fix happens.",
        "seoTitle": "LangWatch MCP: Debug Production AI Agents From Your Editor",
        "seoDescription": "Set up the LangWatch MCP server in Claude Code, Cursor or Codex, pull the failing production traces into your editor and turn them into scenario tests.",
        "image": "/blog/debug-production-ai-agents-from-your-editor-with-mcp-cover.webp",
        "listImage": true,
        "faq": [
          {
            "q": "What is the LangWatch MCP server?",
            "a": "It is a Model Context Protocol server that gives coding assistants like Claude Code, Cursor and Codex access to your LangWatch project and docs. Through it the assistant can search and read traces, query cost and latency analytics, manage prompts, evaluators and datasets, and write Scenario agent tests. The hosted server runs at https://app.langwatch.ai/mcp."
          },
          {
            "q": "How do I connect Claude Code to LangWatch?",
            "a": "Run claude mcp add --transport http langwatch https://app.langwatch.ai/mcp, then run /mcp inside Claude Code, pick langwatch and choose Authenticate. A browser window opens where you sign in to LangWatch and approve a project. To use a personal API key instead, add --header \"Authorization: Bearer your-api-key\" to the add command."
          },
          {
            "q": "Does the LangWatch MCP server need an API key?",
            "a": "Not with the hosted server. You sign in with OAuth in the browser and approve one project, and the client refreshes its access on its own. Clients that cannot sign in send a personal API key as an Authorization: Bearer header. The local version you run with npx @langwatch/mcp-server needs LANGWATCH_API_KEY and LANGWATCH_PROJECT_ID."
          },
          {
            "q": "Which tools does the LangWatch MCP server expose for debugging?",
            "a": "search_traces finds traces by text, filters and date range, get_trace returns one trace with its full span tree, evaluations and metadata, discover_schema lists the fields you can filter and group on, and get_analytics returns timeseries such as cost, latency and token usage. Traces come back as AI-readable digests by default, or as raw JSON."
          },
          {
            "q": "Does the LangWatch MCP server work with self-hosted LangWatch?",
            "a": "Yes. Point your client at your own LangWatch host followed by /mcp instead of app.langwatch.ai/mcp. For the local npx version, set LANGWATCH_ENDPOINT to your host. If you connected a client before October 2026, update its URL to the current one."
          }
        ]
      }
    },
    {
      "slug": "deploying-openai-rag-application-to-aws-elasticbeanstalk",
      "meta": {
        "title": "Deploying an OpenAI RAG Application to AWS ElasticBeanstalk",
        "date": "2024-07-27T00:00:00.000Z",
        "author": "Zhenya",
        "authorPhoto": "https://framerusercontent.com/images/ncRuBWM3yG0oD2gDfslN9eSbN8.jpeg",
        "category": "Integrations",
        "intro": "This tutorial guides you through building chatbots using Retrieval Augmented Generation with OpenAI in Python using FastAPI",
        "seoTitle": "Deploy an OpenAI RAG App to AWS Elastic Beanstalk",
        "seoDescription": "Deploy an OpenAI RAG chatbot to AWS Elastic Beanstalk. A step-by-step Python tutorial using FastAPI, LangChain, and LangWatch for monitoring."
      }
    },
    {
      "slug": "eat-sleep-append-repeat…",
      "meta": {
        "title": "Eat Sleep Append Repeat…",
        "date": "2026-04-20T00:00:00.000Z",
        "author": "Alex Forbes-Reed",
        "authorPhoto": "https://framerusercontent.com/images/9ARqZK3lvVyO3HLQbIHc3dH6sc8.png",
        "category": "Developer findings",
        "intro": "At LangWatch, we process a not-insignificant number of LLM traces, agentic simulations, evaluations, and experiment runs every single week",
        "seoTitle": "Event Sourcing Made LangWatch 300x Faster",
        "seoDescription": "Re-architecting LangWatch on event sourcing and ClickHouse hit 6,000 events per second, real-time dashboards, and retroactive data improvements via replay.",
        "faq": [
          {
            "q": "What throughput did event sourcing unlock for LangWatch?",
            "a": "The platform went from 10-20 events per second to peak throughput north of 6,000 events per second on the same servers, after moving from Elasticsearch to ClickHouse and adding an event-sourced architecture on top."
          },
          {
            "q": "How does event sourcing make old data retroactively better?",
            "a": "Because raw events are the immutable source of truth, LangWatch can replay your entire history through improved processing logic, so old traces benefit from every fix and improvement without you re-sending anything."
          },
          {
            "q": "Why is ClickHouse a good fit for event sourcing?",
            "a": "ClickHouse offers append-only writes, columnar storage, and very fast aggregations, which match the immutable append-only nature of an event log and make analytics dashboards load almost instantly."
          }
        ]
      }
    },
    {
      "slug": "essential-llm-evaluation-metrics-for-ai-quality-control",
      "meta": {
        "title": "LLM evaluation metrics in 2026: start from your agent's failure modes",
        "date": "2026-10-23T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/essential-llm-evaluation-metrics-for-ai-quality-control-cover.webp",
        "listImage": true,
        "category": "LLM Evals",
        "tags": [
          "llm evaluation metrics",
          "evals",
          "failure modes",
          "agent simulations",
          "coding agents"
        ],
        "keyphrase": "llm evaluation metrics",
        "intro": "The LLM evaluation metrics worth tracking in 2026 come from your agent's own failures in production. Find them, turn each one into a yes or no check or a simulation, and treat every change as an experiment.",
        "seoTitle": "LLM Evaluation Metrics for Agents in 2026: Start From Failures",
        "seoDescription": "LLM evaluation metrics that matter in 2026: failure modes from production, yes or no checks that read the trace, agent simulations, experiments, and harness metrics.",
        "faq": [
          {
            "q": "What are LLM evaluation metrics?",
            "a": "LLM evaluation metrics are checks on what your model or agent does: whether it answered the question, called the right tool, stayed inside your rules or finished the user's task. The useful ones each map to a failure you found in your own traces. A generic quality score tells you something moved, and you still have to read the traces to know what to fix."
          },
          {
            "q": "Which metrics should I track for AI agents?",
            "a": "Track one yes or no check per failure mode you found in production, the pass rate of your agent simulations, and the harness numbers that drive cost: tool calls, turns, cache hit ratio, compactions and cost per successful task. Judge the whole conversation and the trace, because an agent can give ten fine replies and still not do the job."
          },
          {
            "q": "How do I find the failure modes of my agent?",
            "a": "Read real conversations and write down what went wrong in each one, then group the notes. Hamel Husain calls this error analysis. Add the failures you already know from customer complaints, support tickets and the history of your prompt fixes. With thousands of conversations, let an agent like Langy or Claude Code with the LangWatch MCP do the first grouping, then read the groups yourself."
          },
          {
            "q": "How do I evaluate a coding agent like Claude Code or Codex?",
            "a": "Run it as an experiment. Give the same task to the same agent twice, once on each version of what you want to test (a refactor, a new CLAUDE.md, a set of skills), and compare cost, time, tool calls and the defects each run left behind. Repeat a few times before you decide, because one run is a diagnosis."
          },
          {
            "q": "Should an LLM judge return a score or a pass or fail?",
            "a": "Start with pass or fail, one judge per failure mode. A yes or no verdict is easy to check against a domain expert and easy to gate a release on. With a 1 to 5 score, the gap between a 3 and a 4 tells you nothing you can act on."
          }
        ]
      }
    },
    {
      "slug": "eu-ai-act-compliance-llm-applications",
      "meta": {
        "title": "EU AI Act compliance: are you affected?",
        "date": "2026-07-05T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/Zmc3JccO7xQ9je5qxtPH2Vzvlw.png",
        "category": "Governance AI",
        "intro": "The high-risk deadlines just moved to December 2027, but the transparency rules still land on 2 August 2026. What the EU AI Act asks of teams deploying LLM applications, and when, as of July 2026.",
        "seoTitle": "EU AI Act Compliance: Are You Affected? 2026 Guide",
        "seoDescription": "Are you affected by the EU AI Act? A decision tree for LLM apps, the amended 2026-2028 timeline, deployer duties, logging, oversight, and a Q3 checklist.",
        "faq": [
          {
            "q": "Does the EU AI Act apply to companies outside the EU?",
            "a": "Yes, in two ways. Article 2 covers providers placing AI systems on the EU market regardless of where they are established, and providers and deployers located in third countries where the output produced by the AI system is used in the EU. A US company whose chatbot serves EU customers is in scope on both counts."
          },
          {
            "q": "Is a customer support chatbot high-risk under the EU AI Act?",
            "a": "Usually no. Customer service is not one of the use cases listed in Annex III, so a support chatbot sits in the transparency tier: under Article 50 users must be told they are talking to an AI system unless that is already obvious, from 2 August 2026. It becomes high-risk only if it is used for a listed purpose, such as assessing creditworthiness or making hiring decisions."
          },
          {
            "q": "What logging does the EU AI Act require for LLM applications?",
            "a": "For high-risk systems, Article 12 requires the system to technically allow automatic recording of events over its lifetime, and both providers (Article 19) and deployers (Article 26(6)) must keep the automatically generated logs for at least six months. For LLM apps the practical form is tracing: model and prompt versions, retrieved context, tool calls, and outputs per request. These duties apply to Annex III systems from 2 December 2027."
          },
          {
            "q": "Do I need a fundamental rights impact assessment (FRIA)?",
            "a": "Only some deployers of high-risk systems do: bodies governed by public law, private entities providing public services, and deployers using AI for creditworthiness assessment or life and health insurance pricing (Annex III points 5(b) and 5(c)). Article 27 requires the assessment before first use and notification of the market surveillance authority. A private company deploying an internal copilot does not need one."
          },
          {
            "q": "What are my obligations if I build on the OpenAI or Anthropic APIs?",
            "a": "The general-purpose AI model obligations (Articles 53 and 55) stay with OpenAI or Anthropic. But if you build an application on the API and ship it, even internally, you are the provider of that AI system under Article 3, and the system-level duties that match its risk tier are yours: Article 50 transparency for a chatbot, the full high-risk set if it is used for an Annex III purpose. Ordinary fine-tuning does not change this; under the Commission's GPAI guidelines you would only become a model provider if your modification used more than a third of the original model's training compute."
          },
          {
            "q": "When do the EU AI Act rules apply to LLM applications?",
            "a": "In stages, as amended in June 2026: prohibited practices and AI literacy since 2 February 2025, general-purpose AI model rules since 2 August 2025, Article 50 transparency from 2 August 2026, high-risk obligations for Annex III use cases from 2 December 2027, and high-risk AI embedded in regulated products from 2 August 2028."
          }
        ]
      }
    },
    {
      "slug": "every-way-your-agent-can-be-broken",
      "meta": {
        "title": "Every way your AI agent can be broken (and how attackers actually do it)",
        "date": "2026-04-15T00:00:00.000Z",
        "author": "Aryan",
        "authorPhoto": "https://framerusercontent.com/images/Y96qMmCKGpN0cihRyPzeqlPGDM.jpg",
        "category": "Governance AI",
        "intro": "Why AI Red Teaming Is Broken (And How We Fixed It)",
        "seoTitle": "Every Way Your AI Agent Can Be Broken by Attackers",
        "seoDescription": "A practical AI agent red teaming guide: attacker goals, the Crescendo multi-turn strategy, OWASP LLM Top 10 mapping, and how to test agents before shipping.",
        "faq": [
          {
            "q": "What are attackers actually trying to do to AI agents?",
            "a": "Common goals include goal hijacking, system prompt extraction, private information disclosure, unauthorized code execution, data exfiltration via tool abuse, indirect prompt injection, denial of service, and jailbreaking safety guardrails."
          },
          {
            "q": "What is the Crescendo multi-turn attack strategy?",
            "a": "Crescendo is a multi-turn approach that starts with a normal conversation, builds rapport, gently tests boundaries, then escalates gradually across phases until the agent does things it was told not to do. It is far more effective than a single clever prompt."
          },
          {
            "q": "Why is the system prompt not a security boundary?",
            "a": "If leaking the prompt is a security risk, you are relying on the prompt to enforce permissions. Treat it as something that will be leaked, enforce auth at the tool level, and keep sensitive config in environment variables instead."
          },
          {
            "q": "How can I test my agents against these attacks?",
            "a": "Run adversarial multi-turn simulations before shipping. LangWatch's Scenario lets you set up multi-turn attack scenarios, define what bad looks like with a judge agent, and catch issues before attackers do."
          }
        ]
      }
    },
    {
      "slug": "four-refactors-and-a-funeral-migrating-a-live-system-to-event-sourcing",
      "meta": {
        "title": "Four Refactors and a Funeral: Migrating a Live System to Event Sourcing",
        "date": "2026-04-20T00:00:00.000Z",
        "author": "Alex Forbes-Reed",
        "authorPhoto": "https://framerusercontent.com/images/9ARqZK3lvVyO3HLQbIHc3dH6sc8.png",
        "category": "Developer findings",
        "intro": "LangWatch is open source. Every commit hash in this post is real and clickable. You can see exactly how we got from A to B, including the detours, nightmares, all nighters, and occasional rapid dip into insanity.",
        "seoTitle": "Migrating a Live System to Event Sourcing",
        "seoDescription": "How LangWatch migrated a live platform to event sourcing on ClickHouse: four refactors, a fold-map-react pipeline, and a zero-downtime dual-write cutover.",
        "faq": [
          {
            "q": "How do you migrate a live system to event sourcing without downtime?",
            "a": "LangWatch used a five-phase approach: dual-write to both old and new systems, verify outputs match, migrate historical data, switch reads behind a per-project feature flag for instant rollback, then turn off the old write path."
          },
          {
            "q": "What are fold, map, and reactor projections?",
            "a": "Folds accumulate state by applying each event, maps are stateless one-event-in one-record-out transforms, and reactors are side effects that fire only after a fold succeeds, which avoids half-states without an outbox table."
          },
          {
            "q": "How does the system guarantee per-aggregate ordering?",
            "a": "A custom group queue built on atomic Redis Lua scripts gives strict ordering within each aggregate while processing thousands of aggregates in parallel, so one bad trace blocks only its own group, not the platform."
          },
          {
            "q": "Why move from Elasticsearch to ClickHouse?",
            "a": "Elasticsearch is built for full-text search, but LangWatch needed time-series analytics, high-throughput ingestion, and aggregations. ClickHouse's columnar storage, append-only MergeTree engine, and tiered TTL fit event sourcing far better."
          }
        ]
      }
    },
    {
      "slug": "framework-for-evaluating-agents",
      "meta": {
        "title": "Agent Evaluation: Framework for Testing AI Agents",
        "date": "2025-06-11T00:00:00.000Z",
        "author": "Tahmid AI researcher @ LangWatch",
        "authorPhoto": "https://framerusercontent.com/images/HLM4vDStvIk5xOpUCf6Vr1gq8.png",
        "image": "https://framerusercontent.com/images/YdEt9ddfAmNSRJetfofg24fk20.png",
        "category": "Agents",
        "intro": "Create robust agent evaluation systems that catch AI agent bugs before production. Testing agent behavior and performance.",
        "seoTitle": "Agent Evaluation: A Framework for Testing AI Agents",
        "seoDescription": "A pragmatic agent evaluation framework covering task, action, and system levels to catch AI agent bugs before they reach production."
      }
    },
    {
      "slug": "from-scenario-to-finished-how-to-test-ai-agents-with-domain-driven-tdd",
      "meta": {
        "title": "From Scenario to Finished: How to Test AI Agents with Domain-Driven TDD",
        "date": "2025-09-26T00:00:00.000Z",
        "author": "Andrew Joia",
        "authorPhoto": "https://framerusercontent.com/images/vTjGg6UPnflY5SK13A2wXIHnzSc.png",
        "image": "https://framerusercontent.com/images/UjQdUmyqOFAMEMuNnGFp3jbI0MM.png",
        "category": "Agents",
        "intro": "Discover Scenario: a domain-driven framework for AI agent testing & LLM evaluations with real-world simulations.",
        "seoTitle": "How to Test AI Agents with Domain-Driven TDD",
        "seoDescription": "Learn how to test AI agents with domain-driven TDD using Scenario, letting failing tests drive a flight-booking agent you can ship with confidence."
      }
    },
    {
      "slug": "function-calling-vs-mcp-why-you-need-both-and-how-langwatch-makes-it-click",
      "meta": {
        "title": "Function Calling vs. MCP: Why You Need Both - and How LangWatch Makes It Click",
        "date": "2025-04-18T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/ybg2U0vxXpKKUz4MNWoEUxdwvM.png",
        "category": "Integrations",
        "intro": "What is MCP? What does MCP stand for? And what is Function Calling?",
        "seoTitle": "Function Calling vs. MCP: Why You Need Both",
        "seoDescription": "Function calling and MCP are complementary, not competing. Learn what each does, how they work together, and how LangWatch gives you visibility into both."
      }
    },
    {
      "slug": "getting-to-value-with-langwatch-faster-than-ever---how-to-migrate-to-langwatch-with-skills.",
      "meta": {
        "title": "Getting to value with LangWatch, faster than ever - how to migrate from Langfuse to LangWatch with Skills.",
        "date": "2026-03-26T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Integrations",
        "intro": "LangWatch onboarding now takes 2 minutes via a coding agent. Paste a skill prompt, traces start flowing. Here's what changed and why.",
        "seoTitle": "Migrate From Langfuse to LangWatch With Skills",
        "seoDescription": "Set up evals, agent simulations, and migrate from Langfuse or LangSmith to LangWatch in one session using Skills and MCP, not a full sprint of work.",
        "faq": [
          {
            "q": "How do LangWatch Skills speed up setting up evals?",
            "a": "After installing the LangWatch MCP, you ask your coding agent to set up evals and it reads your codebase and git history to derive binary pass or fail criteria. It builds and runs the experiment notebook, fixes errors, and loops until the suite is green, all in one session."
          },
          {
            "q": "Can I migrate from Langfuse or LangSmith to LangWatch automatically?",
            "a": "Yes. You ask your coding agent to migrate your existing instrumentation and it rewrites your decorators or callbacks for LangWatch and rebuilds eval datasets and experiment configs. The migration that used to take a sprint fits inside a single session."
          },
          {
            "q": "What skills does LangWatch provide?",
            "a": "LangWatch ships six skills: Instrument for tracing setup, Evaluate for criteria and experiments, Simulate for multi-turn scenario testing, Prompts for versioning and rollback, Analytics for production trace queries, and Level up for next-step recommendations."
          },
          {
            "q": "Can non-engineers use LangWatch through MCP?",
            "a": "Yes. By dropping the MCP config into Claude Desktop, a PM, domain expert, or CEO can ask Claude about top failing traces or compare eval scores without opening the LangWatch dashboard."
          }
        ]
      }
    },
    {
      "slug": "gpt-5-release-from-benchmarks-to-production-reality",
      "meta": {
        "title": "GPT-5 Release: From Benchmarks to production reality",
        "date": "2025-08-08T06:22:21.388Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "OpenAI has released its newest flagship model, GPT-5 - Start evaluating the performance within LangWatch available now.",
        "seoTitle": "GPT-5 Release: From Benchmarks to Production Reality",
        "seoDescription": "The GPT-5 release cuts hallucinations and boosts reasoning, but benchmarks aren't enough. See how to evaluate and monitor GPT-5 in real production workflows."
      }
    },
    {
      "slug": "holidayhero-customercase-with-langwatch-ai",
      "meta": {
        "title": "Customer Stories: HolidayHero AI start-up <> LangWatch",
        "date": "2024-12-20T00:00:00.000Z",
        "author": "CEO of HolidayHero - redated by Manouk",
        "authorPhoto": "https://framerusercontent.com/images/870IWOvCxtWu4tHxD7bld9bzNO0.jpg",
        "category": "LLM Evals",
        "intro": "LangWatch has been a part of HolidayHero's LLM production environment for over two months, overseeing thousands of guestchats",
        "seoTitle": "HolidayHero Customer Story: Better AI with LangWatch",
        "seoDescription": "How HolidayHero uses LangWatch to monitor and optimize LLM-driven content across thousands of guest interactions in the hospitality industry."
      }
    },
    {
      "slug": "how-langwatch-helps-enterprises-test-evaluate-and-trust-their-ai-before-release",
      "meta": {
        "title": "How LangWatch helps enterprises test, evaluate, and trust their AI before release",
        "date": "2025-10-27T00:00:00.000Z",
        "author": "Manouk Draisma & FlagSmith",
        "authorPhoto": "https://framerusercontent.com/images/xxe8S2jHfdHAqn35HFT95GKVw.jpeg",
        "category": "Governance AI",
        "intro": "LangWatch and Flagsmith together: helping teams de-risk moving AI in production across both the LLM-application releases.",
        "seoTitle": "Test and Trust Enterprise AI Before You Release It",
        "seoDescription": "See how LangWatch helps enterprises test, evaluate, and trust AI before release with simulations, evals, and continuous monitoring to de-risk production."
      }
    },
    {
      "slug": "how-openclaw-clawbot-works-behind-the-scenes---and-why-agent-observability-matter",
      "meta": {
        "title": "How OpenClaw / ClawBot works behind the scenes - and why agent observability matter",
        "date": "2026-02-03T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/Zmc3JccO7xQ9je5qxtPH2Vzvlw.png",
        "category": "Integrations",
        "intro": "OpenClaw is a great real-world example of something bigger: agentic systems that connect user inputs to real-world side effects",
        "seoTitle": "How OpenClaw Works and Why Agent Observability Matters",
        "seoDescription": "See how OpenClaw routes chat through a gateway, agent runtime, and tools, and why agent observability matters once agents take real actions.",
        "faq": [
          {
            "q": "What is OpenClaw (formerly Clawdbot)?",
            "a": "OpenClaw is a self-hosted agent runtime and message router, not a chat UI. It runs as a long-running Node.js service that connects to chat platforms, normalizes messages, routes them to an AI agent, and executes tools when the agent decides to act."
          },
          {
            "q": "How does OpenClaw's architecture work?",
            "a": "Messages flow Chat App to Channel Adapter to Gateway to Agent Runtime to Tools to Response. The Gateway only routes messages and tracks sessions, while the agent runtime decides what to do and which tools to invoke."
          },
          {
            "q": "Why does agent observability matter for systems like OpenClaw?",
            "a": "Because natural language input can map directly to real system actions with side effects, you need to know why an agent chose a tool and whether it behaves consistently. LangWatch provides pre-deployment simulations, continuous evaluation, and runtime guardrails to catch failures before they reach users."
          },
          {
            "q": "What are the main security risks of running OpenClaw?",
            "a": "The Gateway binds to localhost by default and should not be exposed publicly, messages from external platforms can come from untrusted senders, and tools run with host machine permissions. Proper pairing, allow-listing, and scoped tool permissions are essential."
          }
        ]
      }
    },
    {
      "slug": "how-phwl-ai-uses-llm-observability-and-optimization-to-improve-ai-coaching-with-langwatch",
      "meta": {
        "title": "How PHWL.ai uses LLM Observability and Optimization to Improve AI Coaching with LangWatch",
        "date": "2025-03-14T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Integrations",
        "intro": "Improve your LLM performance with real-time observability and optimization",
        "seoTitle": "How PHWL.ai Improves AI Coaching with LangWatch",
        "seoDescription": "See how PHWL.ai uses LLM observability and optimization with LangWatch to keep its AI coach on track, closing the loop between experts and engineers."
      }
    },
    {
      "slug": "how-struck-build-improved-ai-performance-with-langwatch",
      "meta": {
        "title": "How Struck.build improved AI Performance with LangWatch",
        "date": "2024-04-17T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Struck.build + LangWatch = Improved AI Perfomance",
        "seoTitle": "How Struck.build Improved AI Performance with LangWatch",
        "seoDescription": "See how Struck.build used LangWatch monitoring to gain real-time AI performance visibility, detect issues early, and evaluate their RAG application."
      }
    },
    {
      "slug": "how-to-build-a-rag-chatbot-from-scratch-with-the-least-possible-ai-hallucinations",
      "meta": {
        "title": "How to build a RAG application from scratch with the least possible AI Hallucinations",
        "date": "2024-05-14T00:00:00.000Z",
        "author": "Zhenya",
        "authorPhoto": "https://framerusercontent.com/images/ncRuBWM3yG0oD2gDfslN9eSbN8.jpeg",
        "category": "Integrations",
        "intro": "Driving to help AI leaders create RAG chatbots with minimal hallucinations",
        "seoTitle": "Build a RAG Chatbot From Scratch With Fewer Hallucinations",
        "seoDescription": "Build a RAG application from scratch and minimize AI hallucinations. A step-by-step Python guide using LangChain, OpenAI, and FastAPI for grounded answers."
      }
    },
    {
      "slug": "how-to-do-tracing-evaluation-and-observability-for-google-adk",
      "meta": {
        "title": "How to do Tracing, Evaluation, and Observability for Google ADK",
        "date": "2025-12-23T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Integrations",
        "intro": "Learn how Google’s Agent Development Kit and LangWatch work together to build, observe, and reliably operate multi-agent systems in production with full tracing, evaluation, and simulations.",
        "seoTitle": "Tracing and Observability for Google ADK Agents",
        "seoDescription": "Learn how to add tracing, evaluation, and observability to Google ADK agents with LangWatch to run reliable multi-agent systems in production."
      }
    },
    {
      "slug": "how-to-evaluate-multi-turn-conversations",
      "meta": {
        "title": "How to evaluate multi-turn conversations with your AI agent",
        "date": "2026-10-31T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/how-to-evaluate-multi-turn-conversations-cover.webp",
        "listImage": true,
        "category": "LLM Evals",
        "keyphrase": "multi turn evaluation",
        "intro": "Multi-turn evaluation grades a whole conversation with your AI agent. Grade it at three levels, the conversation, the trajectory of tool calls and each turn, on conversations a simulated user generates before release and on real threads after.",
        "seoTitle": "Multi-Turn Evaluation: How to Evaluate AI Agent Conversations",
        "seoDescription": "Multi-turn evaluation for AI agents: grade the conversation, the tool calls and each turn, simulate users before release and score production threads.",
        "faq": [
          {
            "q": "What is multi-turn evaluation?",
            "a": "Multi-turn evaluation grades a conversation between a user and an AI agent across all its turns, instead of one input and one output. It catches the bugs that depend on earlier messages: the agent forgetting what the user said, contradicting itself, giving in on a policy after the user pushes, or calling a tool at the wrong moment."
          },
          {
            "q": "What should I measure in a multi-turn conversation?",
            "a": "Write criteria about outcomes and actions, in plain language: the user got what they came for, the agent checked the order status before promising a cancellation, the agent never asked for information the user already gave. A judge passes or fails each one. Generic scores like coherence are hard to act on, while a failed criterion tells you what to fix."
          },
          {
            "q": "Can I evaluate multi-turn conversations without a dataset of conversations?",
            "a": "Yes. Use a simulated user: an LLM plays the user from a short description of their situation and talks to your agent for several turns, and a judge grades the result. Scenario, the open-source framework from LangWatch, does this inside pytest or vitest. Once you have production traffic, add real conversations to a dataset, one row per thread."
          },
          {
            "q": "How do I group production messages into conversations?",
            "a": "Send the same thread_id in the metadata of every trace that belongs to one conversation, usually your chat or session id. LangWatch then groups those traces into one thread, which you can open as a whole, score with a Thread Level monitor and add to a dataset as one row."
          },
          {
            "q": "Should I score every turn or the whole conversation?",
            "a": "Both, for different questions. Score the whole conversation for the outcome, the tool calls across turns for what the agent did, and single turns only for rules that must hold at one moment, like never asking for the same detail twice. Start with the conversation level, since it maps to whether the user got helped."
          }
        ]
      }
    },
    {
      "slug": "how-to-start-evals-when-you-have-no-dataset",
      "meta": {
        "title": "How to start evals when you have no dataset",
        "date": "2026-10-29T00:00:00.000Z",
        "updated": "2026-11-01T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "/blog/how-to-start-evals-when-you-have-no-dataset-cover.webp",
        "listImage": true,
        "category": "LLM Evals",
        "keyphrase": "how to start evals",
        "intro": "Two ways to get your first evals running this week: build a small dataset from the documents you already have, or start from your users' real conversations. Step by step, with examples.",
        "seoTitle": "How to Start Evals When You Have No Dataset",
        "seoDescription": "Start LLM evals with no dataset: build a first one from your docs with a coding agent skill, or from real user conversations. A step-by-step guide.",
        "faq": [
          {
            "q": "How many examples do I need to start LLM evals?",
            "a": "Fewer than you think. A handful of cases you can read and understand beats thousands of generated rows. Start with the five to ten situations that matter most to your business, and grow the set from real failures."
          },
          {
            "q": "Should I use synthetic data to start evals?",
            "a": "Yes, when you have no users yet, as long as it looks like real use. Generate it from your own documents, code and support history, read every row, and drop anything that sounds made up. Once real users arrive, move your evals onto their conversations."
          },
          {
            "q": "What if my agent isn't in production yet?",
            "a": "Build a first dataset and a few scenario tests from your spec, docs, FAQs and support tickets, and let a coding agent skill do the writing. Run them on every change. Then let a small group of real users in with tracing on, and add what goes wrong."
          },
          {
            "q": "What is a trace?",
            "a": "A trace is the full record of one request to your AI agent: the user's message, the reply, and every step in between, such as tool calls, document lookups, cost and time. Evals on real traffic start from traces."
          },
          {
            "q": "What is an eval cold start?",
            "a": "It's the loop teams get stuck in at the start: to ship the agent you want evals, to write good evals you want real data, and to get real data you have to ship. The way out is a small first dataset from what you already know, then growing it from real conversations."
          }
        ]
      }
    },
    {
      "slug": "how-to-test-ai-agents-with-langwatch-mastra-google-adk-and-ship-them-reliably",
      "meta": {
        "title": "How to test AI Agents with LangWatch & Mastra / Google ADK and ship them reliably",
        "date": "2026-01-29T00:00:00.000Z",
        "author": "Sergio Cardenas",
        "authorPhoto": "https://framerusercontent.com/images/p6inrWQwd73x14BD4G7hjeRazs.jpeg",
        "category": "Integrations",
        "intro": "Learn how to test AI agents and ship them to production reliably using scenario-based testing, multi-turn evaluations, and framework-agnostic best practices.",
        "seoTitle": "How to Test AI Agents and Ship Them Reliably",
        "seoDescription": "Learn how to test AI agents with LangWatch, Mastra, and Google ADK using scenario-based testing and multi-turn evaluations to ship them to production reliably.",
        "faq": [
          {
            "q": "How do I test AI agents end-to-end?",
            "a": "Use scenario-based testing with multi-turn evaluations instead of manual checks, structuring projects to be production-ready and validating agent behavior across realistic conversations, tool usage, and edge cases with LangWatch."
          },
          {
            "q": "How does scenario-based testing differ from prompt-only evaluations?",
            "a": "Scenario-based testing evaluates full multi-turn agent behavior, including tool calls and conversation flow, while prompt-only evaluations check single responses in isolation, missing regressions that emerge over a dialogue."
          },
          {
            "q": "Does this approach work across frameworks like Mastra and Google ADK?",
            "a": "Yes. The approach is framework-agnostic, using TypeScript and Python examples with Mastra and Google ADK, so the principles apply regardless of language, framework, or model provider."
          }
        ]
      }
    },
    {
      "slug": "how-to-test-ai-agents",
      "meta": {
        "title": "How to test AI agents: a step-by-step guide",
        "date": "2026-10-20T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/how-to-test-ai-agents-cover.webp",
        "listImage": true,
        "category": "Agents",
        "tags": [
          "agent testing",
          "ai agent testing",
          "scenario",
          "simulations",
          "ci"
        ],
        "keyphrase": "how to test ai agents",
        "intro": "Agents break between turns, and you can't retest twenty chats by hand after every prompt change. Test them with a simulated user, a judge and CI, then feed production failures back in.",
        "seoTitle": "How to Test AI Agents: A Step-by-Step Guide",
        "seoDescription": "How to test AI agents in five steps: real scenarios, a simulated user, a judge with criteria, CI on every change, and production failures turned into tests.",
        "faq": [
          {
            "q": "Which library can I use to write tests for my AI agent?",
            "a": "Scenario is an open-source agent testing framework from LangWatch, in Python (langwatch-scenario) and TypeScript (@langwatch/scenario). It runs inside pytest or vitest: a simulated user talks to your agent, and a judge passes or fails the conversation against criteria you write in plain language. It works with any agent framework, including LangGraph, CrewAI, Pydantic AI, Mastra and the Vercel AI SDK."
          },
          {
            "q": "How do I write tests for my AI agent?",
            "a": "Describe one situation a real user brings, list what the agent must and must not do, and run it as a scenario: a simulated user holds the conversation and a judge checks each criterion. Add assertions on tool calls where you need a hard check. Run the scenarios in CI so every prompt, model or tool change gets tested."
          },
          {
            "q": "What is the difference between agent testing and evals?",
            "a": "An eval scores one input against an expected output on a dataset, which fits one step inside the agent, like retrieval or a single prompt. An agent test scores a whole multi-turn conversation, including the tools the agent called. Use evals for the parts and agent tests for the agent end to end."
          },
          {
            "q": "Can a simulated user really behave like my users?",
            "a": "Not perfectly, and no simulator does. It varies its wording on every run and follows the situation you describe, which catches a lot before release. The cases you never imagined show up in production, so trace your agent and turn each real failure into a new scenario."
          },
          {
            "q": "Do I need a LangWatch account to use Scenario?",
            "a": "No. Scenario is open source and runs in your own test runner. A LangWatch API key is optional: with it, every run shows up in LangWatch with the full conversation, the judge's reasoning and the pass rate over time."
          }
        ]
      }
    },
    {
      "slug": "how-to-test-voice-ai-agents",
      "meta": {
        "title": "How to test a voice AI agent before it takes real calls",
        "date": "2026-11-03T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "category": "Voice AI",
        "keyphrase": "voice agent testing",
        "intro": "Voice agent testing means a simulated caller phones your agent over real audio, with noise, interruptions and accents, and a judge passes or fails the call against your criteria. Run it on every change instead of listening to calls by hand.",
        "seoTitle": "Voice Agent Testing: How to Test a Voice AI Agent Before Real Calls",
        "seoDescription": "Voice agent testing with simulated callers over real audio: interruptions, noise, accents, spoken numbers and other languages, judged on every change in CI.",
        "image": "/blog/how-to-test-voice-ai-agents-cover.webp",
        "listImage": true,
        "faq": [
          {
            "q": "How do you test a voice AI agent?",
            "a": "Write scenarios from real calls: who calls, what they want and what the agent must and must not do. A simulated caller speaks to your agent over its real transport, with background noise, interruptions and the voice you pick, and a judge passes or fails each criterion from the call transcript and the agent's traces. Run the scenarios on every prompt, model or tool change."
          },
          {
            "q": "Can I test a voice agent without writing code?",
            "a": "Yes. In LangWatch you add a voice agent by its ElevenLabs agent id or a phone number, write the scenario in the editor and press Run. Each run shows the verdict per criterion, the recording and the transcript per turn. Voice agents on the platform are in private beta, so on cloud you ask support to turn them on."
          },
          {
            "q": "Which voice stacks can Scenario test?",
            "a": "The Scenario SDK has adapters for Pipecat, ElevenLabs, Twilio phone numbers, OpenAI Realtime, Gemini Live and your own speech-to-text, LLM and text-to-speech pipeline. LiveKit, Vapi and raw WebRTC adapters are in preview and Python only. Each one talks to the agent you already deployed, over the protocol it runs on."
          },
          {
            "q": "How long does a voice test take, and what does it cost?",
            "a": "A voice scenario runs in real time, so expect about 30 to 120 seconds per run from the SDK and one to two minutes per scenario on the platform. Every call uses your voice provider's minutes, ElevenLabs or Twilio, and a simulated caller also uses OpenAI audio tokens."
          },
          {
            "q": "Do I still need to listen to real calls?",
            "a": "Yes, but far fewer. Simulations catch the cases you can describe. Real callers bring cases you never thought of, so trace your production calls, score them with monitors, listen to the ones that fail and turn each one into a new scenario."
          }
        ]
      }
    },
    {
      "slug": "how-we-test-agent-skills-with-scenario-simulations",
      "meta": {
        "title": "How we test Agent Skills with Scenario simulations",
        "date": "2026-03-27T00:00:00.000Z",
        "author": "Sergio Cardenas",
        "authorPhoto": "https://framerusercontent.com/images/smgdFiohT0Dw8ObEVQKtk3rOXU.jpeg",
        "category": "Agents",
        "intro": "Most AI agent skills ship untested. A prompt file gets written, someone eyeballs the output a few times, and it goes to production. When it breaks, you find out from users.",
        "seoTitle": "How We Test Agent Skills With Scenario Simulations",
        "seoDescription": "Most AI agent skills ship untested. See how LangWatch Scenario simulates full multi-turn conversations with a user simulator and judge to catch real failures.",
        "faq": [
          {
            "q": "Why is static validation not enough for testing agent skills?",
            "a": "Static validation checks frontmatter, references, and tool names in seconds, but it cannot tell you whether a skill actually works. A perfectly valid SKILL.md can still produce garbage when an agent interprets it, so LangWatch pairs it with simulation-based testing."
          },
          {
            "q": "What is the three-agent triangle in LangWatch Scenario?",
            "a": "It combines the real agent under test, an LLM-powered user simulator, and a judge agent. Together they run a full multi-turn conversation with realistic user behavior, then evaluate the result against semantic criteria."
          },
          {
            "q": "Why combine deterministic checks with LLM judging?",
            "a": "Pure LLM judging can miss concrete failures and pure deterministic checks are brittle on quality. LangWatch uses deterministic checks for hard facts like file edits and correct SDK imports, and semantic evaluation for conversation quality."
          },
          {
            "q": "How does Scenario catch hallucinated package imports?",
            "a": "LLMs sometimes import packages that do not exist, such as agent_tester or simulation_framework. Scenario tests include explicit anti-hallucination assertions that fail when generated code references these fake packages."
          }
        ]
      }
    },
    {
      "slug": "humanloop-alternatives-2025",
      "meta": {
        "title": "Top 4 Humanloop Alternatives in 2025",
        "date": "2025-07-18T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Looking for a Humanloop alternative? These are top platforms for LLM evaluation, agent testing, and observability.",
        "seoTitle": "Top 4 Humanloop Alternatives in 2025",
        "seoDescription": "Humanloop is sunsetting in 2025. Compare the top 4 Humanloop alternatives for LLM evaluation, agent testing, prompt management, and observability."
      }
    },
    {
      "slug": "instrumenting-your-openclaw-agent-with-opentelemetry",
      "meta": {
        "title": "Instrumenting Your OpenClaw Agent with LangWatch via OpenTelemetry",
        "date": "2026-02-03T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/Zmc3JccO7xQ9je5qxtPH2Vzvlw.png",
        "image": "https://framerusercontent.com/images/6IKEpKmiEm7sICoOenCw6UFDE.png",
        "category": "Integrations",
        "intro": "OpenClaw now ships a built-in OpenTelemetry exporter (`diagnostics-otel`). This post walks through the setup, the GenAI spec compliance details, and how to get it running.",
        "seoTitle": "Instrument Your OpenClaw Agent with OpenTelemetry",
        "seoDescription": "Send OpenClaw agent traces to LangWatch with the built-in OpenTelemetry exporter, using GenAI semantic conventions and zero custom instrumentation.",
        "faq": [
          {
            "q": "How do I send OpenClaw traces to LangWatch?",
            "a": "Enable the built-in diagnostics-otel exporter in ~/.openclaw/openclaw.json, set the endpoint to https://app.langwatch.ai/api/otel/v1/traces, add your LangWatch API key in the headers, then restart the gateway. Traces start flowing immediately with no custom instrumentation."
          },
          {
            "q": "Does the OpenClaw OTEL exporter follow a standard?",
            "a": "Yes. The diagnostics-otel plugin emits traces that comply with the OpenTelemetry GenAI Semantic Conventions, a standard vocabulary for instrumenting LLM applications, so spans use consistent fields like gen_ai.input.messages and gen_ai.output.messages."
          },
          {
            "q": "What does the captureContent flag do?",
            "a": "captureContent controls whether message content is included in traces. When enabled you get the full prompt, model response, system instructions, tool definitions, and tool input/output. When disabled you still get trace structure, token counts, latency, and model metadata without logging sensitive conversations."
          },
          {
            "q": "What does an OpenClaw trace look like in LangWatch?",
            "a": "Each agent turn produces a span tree with a run root span, LLM inference spans as children, and tool execution spans nested under the LLM call that invoked them, giving you a clear view of every step, token count, and latency."
          }
        ]
      }
    },
    {
      "slug": "internal-product-vs-internalised-trauma-supporting-event-sourced-systems",
      "meta": {
        "title": "Internal Product vs Internalised Trauma: Supporting Event Sourced Systems",
        "date": "2026-04-20T00:00:00.000Z",
        "author": "Alex Forbes-Reed",
        "authorPhoto": "https://framerusercontent.com/images/9ARqZK3lvVyO3HLQbIHc3dH6sc8.png",
        "category": "Developer findings",
        "intro": "Before we built anything custom we added metric reporting to the group queue, sent to Grafana. Group queue overview, throughput by pipeline, fold and map projection duration percentiles, retry distributions, dedup rates, fold cache hit rates",
        "seoTitle": "Ops Tooling for Event-Sourced Systems in Production",
        "seoDescription": "The tooling that keeps an event-sourced system supportable: Grafana dashboards, an ops console for blocked groups, projection replay, and time-travel debugging.",
        "faq": [
          {
            "q": "Why isn't Grafana enough to support an event-sourced system?",
            "a": "Grafana shows you the state of the world for monitoring and alerting, but you cannot act on it. When a group blocks at midnight you can watch the counter rise but not fix it, so LangWatch built an ops console for recovery actions."
          },
          {
            "q": "What happens when an event keeps failing in production?",
            "a": "After too many retries the aggregate group is blocked by design, which isolates one bad trace without affecting others. An operator then inspects the error, fixes the cause, and unblocks the group, often in bulk with a canary step first."
          },
          {
            "q": "What is Deja View?",
            "a": "Deja View is a time-travel debugging tool that loads any aggregate's full event history so you can step through events one at a time and compute what any projection's state looked like at each point, making production bugs easy to pinpoint."
          }
        ]
      }
    },
    {
      "slug": "intro-to-scenario",
      "meta": {
        "title": "Intro to Scenario (Testing AI agents)",
        "date": "2025-06-13T00:00:00.000Z",
        "author": "Tahmid AI researcher @ LangWatch",
        "authorPhoto": "https://framerusercontent.com/images/HLM4vDStvIk5xOpUCf6Vr1gq8.png",
        "image": "https://framerusercontent.com/images/hGzks7UY563qMUdNmE14QPxpl0g.png",
        "category": "Agents",
        "intro": "LLMs make it easy to build agent demos. But building reliable and policy-aware agents takes more than a good prompt.",
        "seoTitle": "Intro to Scenario: Testing AI Agents at Scale",
        "seoDescription": "Scenario tests AI agents with a multi-agent loop that simulates real conversations and critiques behavior against your business policies at scale."
      }
    },
    {
      "slug": "introducing-dspy-visualizer",
      "meta": {
        "title": "Introducing DSPy Visualizer",
        "date": "2024-06-03T00:00:00.000Z",
        "author": "Rogerio - CTO",
        "authorPhoto": "https://framerusercontent.com/images/ZybynNVfSRlvtpDujczXHb8UoA.jpeg",
        "category": "Product Releases",
        "intro": "DSPy and LangWatch: Log and track DSPy training sessions, evaluate performance, compare runs, and debug LLM pipelines.",
        "seoTitle": "Introducing DSPy Visualizer: Track and Debug DSPy Runs",
        "seoDescription": "DSPy Visualizer lets you log DSPy training sessions, track performance and cost, compare runs, and debug LLM pipelines to optimize prompts faster."
      }
    },
    {
      "slug": "introducing-instant-evals",
      "meta": {
        "title": "Introducing Instant Evals: evaluate your entire production history",
        "date": "2026-09-22T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/instant-evals-cover.webp",
        "listImage": true,
        "category": "Product Releases",
        "keyphrase": "instant evals",
        "intro": "Run any eval you can think of, on all your production trace history. Cheap, fast, and at scale.",
        "seoTitle": "Introducing Instant Evals: Evaluate Your Production History",
        "seoDescription": "Instant Evals judges every conversation, trace or LLM call your agent produced: 10,000 conversations in about a minute for $0.32, 97% agreement with humans.",
        "faq": [
          {
            "q": "What are Instant Evals?",
            "a": "Evals you run on demand over data you already stored. You ask a question in plain words, LangWatch judges every conversation, trace or LLM call in the period you pick, and returns the matches, the match rate and a probability on each."
          },
          {
            "q": "How are Instant Evals different from online evals?",
            "a": "Online evals score traffic as it comes in, usually a sample of it, against checks you set up in advance. Instant Evals answer a new question over everything you already stored, every row."
          },
          {
            "q": "How accurate is it compared to an LLM as a judge?",
            "a": "On a benchmark of 300 support conversations with human labels, Instant Evals agrees with the labels 97% of the time. Claude Opus 5 as a judge agrees 91% of the time, GPT 5 mini 90% and GPT 5.6 88%. Every answer comes with a calibrated probability, so a threshold of 0.8 means what it says."
          },
          {
            "q": "What does it cost to evaluate 10,000 conversations?",
            "a": "About $0.32, at $0.0546 per million input tokens. The same 10,000 conversations cost about $31 with Claude Opus 5 as the judge. You see the cost before the run starts."
          },
          {
            "q": "How long does it take?",
            "a": "About 1 minute 13 seconds for 10,000 conversations. The LLM judges in the same benchmark take between 10 and 25 minutes."
          },
          {
            "q": "Do I need my own model provider keys?",
            "a": "No. LangWatch runs the judge, so there is no provider account to set up and no key to rotate."
          },
          {
            "q": "Which model does the judging?",
            "a": "Jev, TypeSafe's new model, a small model made for judging text. We test new judge models as they come out and run your evals on the most accurate one."
          },
          {
            "q": "Can I run an eval inside a SQL query?",
            "a": "Yes. eval() is a function in LangWatchQL, the SQL dialect for your LangWatch data. You select the rows with SQL you already know and the verdict comes back as a column."
          },
          {
            "q": "Can I ask more than one question at a time?",
            "a": "Yes, up to ten questions per row. They go to the judge in one request, so ten cost about the same as one."
          },
          {
            "q": "Can I get the matches out to build a dataset?",
            "a": "Yes. The CLI prints them as a table or as JSON, and the verdicts land in a table you can join to your traces in SQL, so you can build a test set or a fine-tuning set from the hard cases."
          },
          {
            "q": "How big can a run be?",
            "a": "Runs go in batches of 100,000 rows, so a million rows is ten runs."
          }
        ]
      }
    },
    {
      "slug": "introducing-langwatch-mcp-test-and-evaluate-ai-agents-without-leaving-your-workflow",
      "meta": {
        "title": "Introducing LangWatch MCP: Test and evaluate AI Agents without leaving your workflow",
        "date": "2026-03-12T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "intro": "Build, version, and run AI agent evaluations directly from Claude, Cursor, or Copilot with the LangWatch MCP server. Generate test scenarios, benchmark models, and ship reliable agents faster - without leaving your coding environment.",
        "seoTitle": "LangWatch MCP: Test AI Agents in Your Workflow",
        "seoDescription": "The LangWatch MCP server brings agent evaluation into Claude, Cursor, and Copilot, so you version prompts, generate scenarios, and benchmark models in flow.",
        "faq": [
          {
            "q": "What is the LangWatch MCP server?",
            "a": "The LangWatch MCP server is a Model Context Protocol integration that brings LangWatch's evaluation infrastructure into your AI coding environment. With it installed, your assistant can push prompts, create evaluation scenarios, run experiments, and compare models without leaving the conversation."
          },
          {
            "q": "Which tools support the LangWatch MCP?",
            "a": "It works wherever an assistant supports MCP, including Claude Code, Claude Desktop, Cursor, and Copilot, connected to your LangWatch workspace."
          },
          {
            "q": "What can I do with the LangWatch MCP?",
            "a": "You can version and sync prompts, generate scenario tests from natural language, scaffold evaluation notebooks for model comparisons, configure platform evaluators as CI/CD gates, run simulation-based tests, and migrate prompts and traces from tools like Langfuse."
          },
          {
            "q": "Can non-engineers use the LangWatch MCP?",
            "a": "Yes. Product managers can describe what needs testing in plain language and have the assistant generate structured scenarios with criteria, expected tool calls, and first messages, then push them to LangWatch to run as simulations."
          }
        ]
      }
    },
    {
      "slug": "introducing-langwatch-prompt-playground",
      "meta": {
        "title": "Introducing: LangWatch newest Prompt Playground",
        "date": "2025-11-20T00:00:00.000Z",
        "author": "Andrew Garde Joia",
        "authorPhoto": "/people/andrew-joia.webp",
        "category": "Product Releases",
        "intro": "Manage, test, and version AI agent prompts with confidence. LangWatch Prompt Playground connects prompts to real traces, evaluations, and optimization workflows.",
        "seoTitle": "Introducing LangWatch Prompt Playground",
        "seoDescription": "LangWatch Prompt Playground is a unified workspace to write, test, and version AI prompts, connected to real traces, evaluations, and scenario testing."
      }
    },
    {
      "slug": "introducing-langy-your-automated-ai-engineer",
      "meta": {
        "title": "Introducing Langy: Your Automated AI Engineer",
        "date": "2026-07-22T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "image": "/blog/introducing-langy-your-automated-ai-engineer.webp",
        "listImage": true,
        "category": "Product Releases",
        "keyphrase": "automated ai engineer",
        "intro": "Langy is a full coding agent inside LangWatch: it reads your production traces, writes Scenario tests and evaluations, opens the pull request on your codebase, and proves the change in your CI.",
        "seoTitle": "Introducing Langy: Your Automated AI Engineer",
        "seoDescription": "Langy is an automated AI engineer inside LangWatch: it reads your traces, writes Scenario tests and evaluations, opens PRs, and proves every fix in your CI.",
        "faq": [
          {
            "q": "What is an automated AI engineer?",
            "a": "A coding agent embedded in the platform where your AI product is observed and tested, doing real engineering work on it: AI agent evaluation and testing, trace analysis, prompt and code changes, pull requests for your team to review. A copilot helps a person type, a chat assistant answers questions about your dashboards; an automated AI engineer does the work and shows the diff."
          },
          {
            "q": "What does Langy actually do for my team?",
            "a": "The work you already do when improving an agent, automated: digging up the trace behind a complaint, figuring out what went wrong, writing the evaluation or the scenario test that catches it, fixing the prompt, checking the fix held. You ask in plain language; Langy comes back with findings, or with a pull request."
          },
          {
            "q": "Can Langy improve my AI agent automatically?",
            "a": "Up to the pull request, yes. Langy finds the problems, writes the scenario tests and evaluations, drafts the fix, and opens the PR with the CI results attached. Merging stays with your team: you get the speed of automation with a human review on every change that ships."
          },
          {
            "q": "How do I test AI agents with Langy?",
            "a": "Tell it what the agent should and should not do. Langy turns that into Scenario simulations, multi-turn conversations that probe your agent the way a real user would, plus evaluations that score the outcomes. The tests run in your CI, so every future change gets checked against them, whoever wrote it."
          },
          {
            "q": "Can Langy test voice agents?",
            "a": "Yes. Our launch demo is exactly that: Langy, plugged into a robot over MCP, testing our own customer-support voice agent by kicking off Scenario simulations itself. Voice agent testing works the same way as text: simulated conversations, scored against the rubric you set."
          },
          {
            "q": "How does Langy spend tokens, and whose account does it use?",
            "a": "Yours. You bring your own API key for the model provider you already use, or run Langy on a coding-agent subscription you already pay for, like a Codex account. And because every Langy session is itself traced and costed inside LangWatch, you see exactly what each run spent."
          },
          {
            "q": "Is it safe to give an AI engineer access to my code and data?",
            "a": "Langy runs in a fully sandboxed VM and operates only on your LangWatch account for anything sensitive; credentials stay there. Secret redaction is on by default in LangWatch, so secrets do not leak into context. On the code side, Langy contributes to your GitHub exclusively through pull requests: nothing touches your codebase without a human approving it."
          },
          {
            "q": "Which frameworks does Langy work with?",
            "a": "Any agent framework or harness: LangWatch is OpenTelemetry-native, so if LangWatch traces it, Langy can work on it. Models from any provider too, including but not limited to OpenAI, Anthropic, Bedrock, Azure, ElevenLabs, and all the others, on your own keys."
          }
        ]
      }
    },
    {
      "slug": "introducing-scenario-use-an-agent-to-test-your-agent",
      "meta": {
        "title": "Introducing Scenario: Use an Agent to Test Your Agent",
        "date": "2025-04-08T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "image": "https://framerusercontent.com/images/knXIpAu2qfHSHsySe2ZG8CGd0Y.webp",
        "category": "Product Releases",
        "intro": "Scenario is an automated testing library for LLM agents that simulates real user interactions end-to-end.",
        "seoTitle": "Scenario: Use an Agent to Test Your AI Agent",
        "seoDescription": "Scenario is an open-source agent testing library that uses an AI agent to test your AI agent, simulating real user conversations to catch regressions fast."
      }
    },
    {
      "slug": "introducing-simulation-based-agent-testing",
      "meta": {
        "title": "Introducing simulation-based agent testing",
        "date": "2025-06-24T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/kLQbW5O40gUzX6dcKjgvc53oaGg.jpg",
        "category": "Product Releases",
        "intro": "Test your agents with scenarios directly in your codebase using Python and TypeScript.",
        "seoTitle": "Introducing Simulation-Based Agent Testing",
        "seoDescription": "Run simulation-based agent testing right in your codebase with Python and TypeScript. Simulate users, validate behavior, and catch issues in CI before prod."
      }
    },
    {
      "slug": "introducing-testing-voice-agents-like-you-test-your-chat-agents",
      "meta": {
        "title": "Introducing: Testing voice agents like you test your chat agents",
        "date": "2026-06-02T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/AFQtLeq493aCHPOOWIBpe3qeuM.png",
        "category": "Voice AI",
        "intro": "Test voice agents the way you test text agents - simulated callers, traces, playback, and judge-based evaluation - now against real voice, across the stacks teams actually ship on.",
        "seoTitle": "Testing Voice Agents Like You Test Chat Agents",
        "seoDescription": "Test voice agents with Scenario using simulated callers, traces, playback, and judge-based evaluation against real voice across OpenAI, Twilio, and more.",
        "faq": [
          {
            "q": "Do I have to rebuild my agent to test voice?",
            "a": "No. You point Scenario at the voice agent you already built and pick the adapter that matches your stack, such as OpenAI Realtime, Twilio, ElevenLabs, or WebSocket."
          },
          {
            "q": "Can voice tests run in CI without a microphone or speakers?",
            "a": "Yes. The simulated user generates the audio and Scenario drives the call headlessly, so a voice scenario runs in CI like any other test with no hardware in the loop."
          },
          {
            "q": "Is voice testing the same API as text in Scenario?",
            "a": "Yes. It uses the same scenario.run() call, and your scripts, adapters, traces, and judge all carry over. Voice is just another adapter."
          },
          {
            "q": "How does the judge decide if a voice call passed?",
            "a": "It evaluates the whole conversation against natural-language criteria you write, like confirming a booking or not talking over the caller, and gives you a verdict plus transcript, traces, and playback."
          }
        ]
      }
    },
    {
      "slug": "introducing-the-evaluations-wizard-your-end-to-end-workflow-for-llm-testing",
      "meta": {
        "title": "Introducing the Evaluations Wizard: How to evaluate your LLM: Building an LLM evaluation framework that actually works",
        "date": "2025-04-22T00:00:00.000Z",
        "author": "Rogerio",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "image": "https://framerusercontent.com/images/QJc7nSAYbkLtRwZIkDpqoh00PBE.png",
        "category": "Product Releases",
        "intro": "Learn how to effectively evaluate and test LLMs with LangWatch's new Evaluations Wizard. Improve your AI model performance",
        "seoTitle": "Evaluations Wizard: Build an LLM Evaluation Workflow",
        "seoDescription": "The LangWatch Evaluations Wizard gives AI teams a guided, end-to-end workflow for LLM testing, from datasets to LLM-as-a-Judge, all in one place."
      }
    },
    {
      "slug": "introduction-the-real-issue-isn-t-rl",
      "meta": {
        "title": "Introduction: The Real Issue isn’t RL",
        "date": "2025-05-30T00:00:00.000Z",
        "author": "Tahmid AI Researcher @ LangWatch",
        "authorPhoto": "https://framerusercontent.com/images/HLM4vDStvIk5xOpUCf6Vr1gq8.png",
        "image": "https://framerusercontent.com/images/bK7neMxJxMjuaMo3hcq0G4VBTcQ.png",
        "category": "LLM Evals",
        "intro": "Why reinforcement learning in LLMs isn't broken our eval methods are. Learn how we can unlock RL's potential in LLMs",
        "seoTitle": "Reinforcement Learning in LLMs: The Real Issue Isn't RL",
        "seoDescription": "Reinforcement learning in LLMs isn't fundamentally limited, our evaluation setups are. See how better eval methods unlock RL's real potential."
      }
    },
    {
      "slug": "journey-through-innovation-the-llm-adventure",
      "meta": {
        "title": "Journey Through Innovation: The LLM Adventure",
        "date": "2024-04-08T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Dive into a customer's journey with LangWatch, revealing how to successfully integrate AI into your organization.",
        "seoTitle": "The LLM Adventure: A Journey to AI Integration",
        "seoDescription": "Follow the phases of AI integration, from first proof of concept to scaling, and learn how to monitor LLMs as you widen the circle of users."
      }
    },
    {
      "slug": "langfuse-vs-langsmith",
      "meta": {
        "title": "Langfuse vs LangSmith in 2026: a fair comparison (and where LangWatch fits)",
        "date": "2026-10-28T00:00:00.000Z",
        "updated": "2026-10-28T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "/blog/langfuse-vs-langsmith-cover.webp",
        "listImage": true,
        "category": "LLM Evals",
        "keyphrase": "langfuse vs langsmith",
        "intro": "Langfuse is the open-source pick you can self-host for free, and LangSmith is the managed pick for teams on LangChain and LangGraph. LangWatch adds agent testing, an AI gateway and Claude Code and Codex spend for teams that run AI for a whole company.",
        "seoTitle": "Langfuse vs LangSmith (2026): Features, Pricing, Self-Hosting",
        "seoDescription": "Langfuse vs LangSmith in 2026: tracing, evals, prompts, agent testing, self-hosting and pricing side by side, plus Braintrust and where LangWatch fits.",
        "aliases": [
          "/blog/langwatch-vs-langsmith-vs-braintrust-vs-langfuse-choosing-the-best-llm-evaluation-monitoring-tool-in-2025"
        ],
        "faq": [
          {
            "q": "Is Langfuse open source?",
            "a": "Yes. The Langfuse core is MIT licensed and you can self-host it for free with no usage limits. A few enterprise features, like SCIM, audit logs, data retention policies and project-level roles, sit in separate ee directories under a commercial license and need a license key. ClickHouse acquired Langfuse in January 2026 and said the license stays the same."
          },
          {
            "q": "Can LangSmith be self-hosted?",
            "a": "Yes, but only as an add-on to the LangSmith Enterprise plan. It runs in your own Kubernetes cluster with Helm, and you need a license key from LangChain's sales team. Enterprise customers on AWS can also choose BYOC, where LangChain runs the control plane and the data plane runs in your cloud. The SDKs are MIT licensed."
          },
          {
            "q": "Is LangSmith only for LangChain?",
            "a": "No. LangSmith works without any LangChain code: you trace your own functions with the traceable decorator in the SDK, or send OpenTelemetry traces from any framework. It does fit LangChain and LangGraph best, because those libraries send traces to it with almost no setup and the same vendor runs LangSmith Deployment for LangGraph agents."
          },
          {
            "q": "How do I migrate from LangSmith to Langfuse or LangWatch?",
            "a": "Move the traces with OpenTelemetry. Send your spans to the new tool next to the old one for a week or two, compare, then switch the exporter off. Prompts and datasets move separately, through export and import. Old trace history is the slow part: LangSmith bulk export to S3 is Enterprise-only for accounts created after August 3, 2026."
          },
          {
            "q": "What is the best LLM observability platform for production?",
            "a": "It depends on who runs it. For an AI platform team at an enterprise, LangWatch, because tracing, evals, agent tests, an AI gateway and Claude Code and Codex spend come in one open-source platform you can self-host or run hybrid. Langfuse is the open-source choice for tracing and prompts, and LangSmith is the managed choice for LangChain and LangGraph teams."
          }
        ]
      }
    },
    {
      "slug": "langsmith-alternatives-what-to-use-if-you-need-more-security-and-control",
      "meta": {
        "title": "LangSmith Alternatives: What to use if you need more security and control",
        "date": "2025-06-18T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Explore top LangSmith alternatives, including LangWatch.ai the ideal platform for optimizing, evaluating, and monitoring.",
        "seoTitle": "LangSmith Alternatives for Security and Control",
        "seoDescription": "Compare the top 6 LangSmith alternatives in 2025 for teams that need stronger security, compliance, and control over LLM tracing and evaluation."
      }
    },
    {
      "slug": "langwatch-ai-announcing-1m-funding-round-to-bring-the-power-of-evaluations-to-ai-teams",
      "meta": {
        "title": "LangWatch.ai - Announcing - €1M funding round to bring the power of Evaluations and Auto-Optimizations to AI teams.",
        "date": "2025-02-25T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/lxjSws5ke692E9S0LwTkmGhY.png",
        "category": "Product Releases",
        "intro": "LangWatch: €1M pre-seed funding round led by Passion Capital, with great support from Volta Ventures and Antler.",
        "seoTitle": "LangWatch Raises €1M to Bring Evals to AI Teams",
        "seoDescription": "LangWatch closes a €1M pre-seed round led by Passion Capital to bring evaluations and auto-optimization to AI teams building reliable LLM applications.",
        "listImage": true
      }
    },
    {
      "slug": "langwatch-and-adesso-join-forces-accelerating-secure-llm-adoption-for-enterprises",
      "meta": {
        "title": "LangWatch and adesso join forces: Accelerating Secure LLM Adoption for Enterprises",
        "date": "2025-03-27T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/b39wRYlHDPAvG6tEIxIizUGimGk.png",
        "category": "Governance AI",
        "intro": "LangWatch partners with Adesso to support Enterprise companies with LLMops",
        "seoTitle": "LangWatch and Adesso Partner on Secure LLM Adoption",
        "seoDescription": "LangWatch and Adesso join forces to help enterprises move LLM apps from PoC to production securely, with observability, evals, and EU AI Act compliance."
      }
    },
    {
      "slug": "langwatch-monthly-drop-april-2026",
      "meta": {
        "title": "LangWatch v3.0 and the April 2026 Product Drop",
        "date": "2026-04-30T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "intro": "April was our biggest release month yet: LangWatch v3.0 goes live, Agent Skills spin up whole eval platforms in a session, and Scenario learns to red team.",
        "seoTitle": "LangWatch v3.0: April 2026 Product Updates",
        "seoDescription": "LangWatch v3.0 ships a new trace storage backend, Agent Skills for instant evals, automated red teaming in Scenario, SCIM 2.0, and a rebuilt Traces UI."
      }
    },
    {
      "slug": "langwatch-monthly-drop-february-2026",
      "meta": {
        "title": "The LangWatch February Drop: Cheaper Events, Claude Code, and Multimodal Evals",
        "date": "2026-02-28T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "intro": "February brought a major event pricing drop, Claude Code plus MCP support, multimodal LLM-as-a-Judge, thread-level evaluations, and LiquidJS templating.",
        "seoTitle": "LangWatch February 2026: Pricing, Claude Code, Evals",
        "seoDescription": "LangWatch's February drop: lower event pricing, Claude Code and MCP integration, multimodal evaluations, thread-level evals, and LiquidJS prompt templating."
      }
    },
    {
      "slug": "langwatch-monthly-drop-january-2026",
      "meta": {
        "title": "The LangWatch Monthly Drop: January 2026",
        "date": "2026-01-31T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "intro": "January brought a full 2026 redesign, Scenario simulations built into the platform, Evaluations v3, dashboard alerts, and cloud marketplace launches.",
        "seoTitle": "LangWatch January 2026 Product Updates",
        "seoDescription": "See what LangWatch shipped in January 2026: a 2026 redesign, Scenario agent simulations, Evaluations v3, dashboard alerts, and Azure and Google Marketplace launches."
      }
    },
    {
      "slug": "langwatch-monthly-drop-may-2026",
      "meta": {
        "title": "The Whole Platform Is Now Open Source: LangWatch May 2026 Update",
        "date": "2026-05-31T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "intro": "May was our biggest month yet: the full LangWatch platform went open source under Apache 2.0, voice testing landed in Scenario, the new Traces UI hit GA, and AI Governance opened for beta.",
        "seoTitle": "LangWatch Goes Open Source: May 2026 Update",
        "seoDescription": "LangWatch is now open source under Apache 2.0. Plus native voice testing in Scenario, the GA Traces UI, and the new AI Governance beta. See what shipped in May 2026."
      }
    },
    {
      "slug": "langwatch-optimization-studio-built-for-ai-engineers-by-ai-engineers",
      "meta": {
        "title": "LangWatch Optimization Studio - Built for AI Engineers, by AI Engineers",
        "date": "2024-12-10T00:00:00.000Z",
        "author": "Rogerio",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "image": "https://framerusercontent.com/images/KEarCpDQXDctnH8Exe2Qt4GVLA.png",
        "category": "Product Releases",
        "intro": "LangWatch Optimization Studio - Built for AI Engineers, by AI Engineers",
        "seoTitle": "LangWatch Optimization Studio for AI Engineers",
        "seoDescription": "LangWatch Optimization Studio gives AI engineers a DSPy-powered workflow to track, optimize, and scale LLMs, cutting manual prompt tweaking time."
      }
    },
    {
      "slug": "langwatch-skills-your-coding-agent-already-knows-how-to-test-your-agent",
      "meta": {
        "title": "LangWatch Skills: Your coding agent already knows how to test your agent",
        "date": "2026-03-23T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/LgHf6WBSKn7jqa8teMR8BkzvYc.png",
        "category": "Agents",
        "intro": "Stop setting up evals manually. LangWatch Skills lets your coding agent instrument your LLM agent, check production performance, and run tests automatically.",
        "seoTitle": "LangWatch Skills: Instrument and Test AI Agents",
        "seoDescription": "LangWatch Skills let your coding agent instrument tracing, observe production performance, and run tests automatically, no manual setup needed.",
        "faq": [
          {
            "q": "What are LangWatch Skills?",
            "a": "LangWatch Skills follow Anthropic's open Agent Skills standard. Each is a self-contained folder with a SKILL.md that teaches your coding agent exactly how to work with LangWatch, so you install once and your agent knows every workflow without you explaining it."
          },
          {
            "q": "Which coding agents do LangWatch Skills work with?",
            "a": "They work with Claude Code, Cursor, Windsurf, Copilot, and any compatible coding agent that supports the Agent Skills standard."
          },
          {
            "q": "What is the instrument, observe, and fix loop?",
            "a": "Instrument adds tracing so you can see what your agent does, observe surfaces production performance like latency and drift, and fix derives binary eval criteria and loops on prompt changes until tests pass. Together they form a full development cycle from your coding assistant."
          },
          {
            "q": "How do I install LangWatch Skills?",
            "a": "Run a command like npx skills add langwatch/skills/tracing for a single skill, or npx skills add langwatch/skills/level-up to install them all, then invoke the matching slash command in your coding agent."
          }
        ]
      }
    },
    {
      "slug": "launch-week-day-5-better-agents-cli-the-reliability-layer-for-the-next-wave-of-agent-development",
      "meta": {
        "title": "Launch Week Day 5: Better Agents CLI: The reliability layer for the next wave of agent development",
        "date": "2025-11-26T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/wd3ZOOJwBCVsVjG4S7F8XJ5zX4.png",
        "category": "Product Releases",
        "intro": "Most AI agents fail in production. Better Agents CLI fixes that with scenario testing, evaluations, prompt versioning, and best-practice structure for dependable agent development.",
        "seoTitle": "Better Agents CLI: A Reliability Layer for Agents",
        "seoDescription": "Better Agents CLI by LangWatch adds scenario testing, evaluations, and prompt versioning to any framework so your AI agents reach production reliably."
      }
    },
    {
      "slug": "llm-evaluations-at-swis-for-dutch-government-projects-by-langwatch",
      "meta": {
        "title": "LLM evaluations at Swis for Dutch government projects by LangWatch",
        "date": "2025-04-03T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "How do we objectively know if the AI output is good? LLM evaluation reports & feedback loops",
        "seoTitle": "LLM Evaluations for Dutch Government Projects",
        "seoDescription": "How SWIS uses LangWatch for LLM evaluations on Dutch government RAG projects, building a ground-truth pipeline to measure faithfulness and relevance."
      }
    },
    {
      "slug": "llm-evaluations-explained-experiments-online-evaluations-guardrails-and-when-to-use-each-in-2026",
      "meta": {
        "title": "LLM Evaluations Explained: Experiments, Online Evaluations, Guardrails, and when to use each in 2026",
        "date": "2026-02-02T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/Zmc3JccO7xQ9je5qxtPH2Vzvlw.png",
        "category": "LLM Evals",
        "intro": "“LLM evaluation” means different things to different teams. This glossary explains experiments, monitoring, guardrails, and evaluators for AI agents.",
        "seoTitle": "LLM Evaluations Explained: Experiments, Monitors, Guardrails",
        "seoDescription": "Understand the four meanings of LLM evaluation, experiments, online monitoring, guardrails, and evaluators, and learn when to use each for AI agents in 2026.",
        "faq": [
          {
            "q": "What is the difference between offline and online LLM evaluations?",
            "a": "Offline evaluations (experiments) test your agent on a dataset before deployment under controlled conditions to compare prompt or model variations. Online evaluations (monitors) score production traffic asynchronously after responses are sent, capturing real users and edge cases without slowing the agent."
          },
          {
            "q": "Do guardrails add latency?",
            "a": "Not if structured correctly. Run output guardrail checks in parallel with the LLM call so the fast ML-based guardrail finishes before the LLM, adding no wait time. Input guardrails run before the LLM but typically complete in milliseconds."
          },
          {
            "q": "What are evaluators in LLM evaluation?",
            "a": "Evaluators are the scoring functions that judge agent outputs, such as Escalation Detection, Faithfulness, Jailbreak Detection, and PII Detection. They are the building blocks used inside experiments, monitors, and guardrails rather than run in isolation."
          },
          {
            "q": "When should I use guardrails instead of monitors?",
            "a": "Guardrails are for policy enforcement, blocking or modifying responses synchronously for things that must not happen, like jailbreaks or PII exposure. Monitors track quality and business metrics asynchronously so you can measure and improve. Avoid guardrailing quality metrics, since that blocks normal responses."
          }
        ]
      }
    },
    {
      "slug": "llm-guardrails",
      "meta": {
        "title": "LLM guardrails: block a bad answer before it goes out",
        "date": "2026-11-05T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "category": "LLM Evals",
        "tags": [
          "llm guardrails",
          "guardrails",
          "ai gateway",
          "online evaluation",
          "instant evals",
          "pii"
        ],
        "keyphrase": "llm guardrails",
        "intro": "Found an answer in your traces that should never have gone out? Here is how to turn that check into an LLM guardrail in LangWatch, in your code or on the AI Gateway, so the next one gets stopped before your user sees it.",
        "seoTitle": "LLM Guardrails: How to Block a Bad Answer Before It Reaches Users",
        "seoDescription": "Set up LLM guardrails in LangWatch: find what to block with Instant Evals, save the check as an evaluator, run it in your code or on the LangWatch AI Gateway.",
        "image": "/blog/llm-guardrails-cover.webp",
        "listImage": true,
        "faq": [
          {
            "q": "What are LLM guardrails?",
            "a": "An LLM guardrail is a check that runs inside the request, on the user's input before the model call or on the model's answer before it goes back. When the check fails, your app or the gateway blocks the message or sends a safe reply instead."
          },
          {
            "q": "What is the difference between a guardrail and an online evaluation?",
            "a": "An online evaluation scores your traffic after the answer is sent, so it never slows a reply and feeds your pass rates and alerts. A guardrail runs the check while the request is still open, so it can stop the answer, and it adds the time the check takes to that request."
          },
          {
            "q": "Do guardrails slow down my LLM app?",
            "a": "Yes, by the time each check takes. Keep fast checks like jailbreak detection, PII detection and blocklists on the input, put LLM-as-a-judge checks on the output, and run several guardrails in parallel. On the LangWatch AI Gateway, guardrails on the same direction already run in parallel."
          },
          {
            "q": "Can I add guardrails without changing my code?",
            "a": "Yes. If your app calls models through the LangWatch AI Gateway, create the guardrail under AI Gateway, Guardrails and tick it on the virtual key your app uses. The gateway runs it on every request through that key and answers 403 guardrail_blocked when it fails."
          },
          {
            "q": "Which evaluators work as guardrails?",
            "a": "Jailbreak Detection, Prompt Injection Detection, PII Detection, API Keys & Secrets Detection, Content Safety, Moderation, Competitor Blocklist, Off Topic and Valid Format all work as guardrails, and so does an LLM-as-a-Judge Boolean evaluator with your own criteria."
          }
        ]
      }
    },
    {
      "slug": "llm-monitoring-evaluation-for-real-world-production-use",
      "meta": {
        "title": "LLM Monitoring & Evaluation for Real-World Production Use",
        "date": "2025-05-05T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/Hk7oeiX1Szq8irBp3fUAGKfC8es.png",
        "category": "LLM Evals",
        "intro": "Key challenges teams face when put LLM-powered apps in production, and why continuous monitoring and evaluation is essential",
        "seoTitle": "LLM Monitoring & Evaluation for Production Apps",
        "seoDescription": "LLM monitoring and evaluation keep production apps reliable. See the common failure modes and how continuous monitoring catches drift and hallucinations."
      }
    },
    {
      "slug": "llm-observability-what-is-it-why-it-matters",
      "meta": {
        "title": "LLM observability: What is it and why it matters",
        "date": "2025-08-14T08:07:41.280Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Integrations",
        "intro": "What is LLM observability, and why is agent observability becoming critical for the future of AI systems?",
        "seoTitle": "LLM Observability: What It Is and Why It Matters",
        "seoDescription": "LLM observability captures prompts, traces, and metrics so you can debug non-deterministic AI systems fast and continuously improve quality in production."
      }
    },
    {
      "slug": "llm-reliability-with-retrieval-augmented-generation",
      "meta": {
        "title": "LLM Reliability with Retrieval-Augmented Generation",
        "date": "2024-05-13T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Integrations",
        "intro": "Retrieval Augmented Generation. Its popularity continues to surge, offering various methods for its successful implementation",
        "seoTitle": "LLM Reliability With Retrieval-Augmented Generation (RAG)",
        "seoDescription": "Retrieval-augmented generation makes LLMs more reliable. Learn how RAG combines search with generation to deliver accurate, up-to-date, grounded responses."
      }
    },
    {
      "slug": "llmops-is-still-about-people-how-to-build-ai-teams-that-don-t-implode",
      "meta": {
        "title": "LLMOps Is Still About People: How to Build AI Teams That Don’t Implode",
        "date": "2025-03-25T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "LLMs can do amazing things, but only if they understand context. That context lives in the heads of domain experts.",
        "seoTitle": "LLMOps Is About People: Building AI Teams That Last",
        "seoDescription": "LLMOps success hinges on people, not just tech. Learn how to align execs, engineers, and domain experts to build AI teams that ship instead of stall."
      }
    },
    {
      "slug": "llmops-is-the-new-devops-here-s-what-every-developer-must-know",
      "meta": {
        "title": "LLMOps is the new DevOps, here’s what every developer must know",
        "date": "2025-08-18T13:07:09.104Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "LLMOps is the new DevOps. Discover what every developer must know to manage, test, and scale AI applications with confidence",
        "seoTitle": "LLMOps Is the New DevOps: A Developer's Guide",
        "seoDescription": "LLMOps is the new DevOps. Learn what every developer must know to manage, test, evaluate, and scale LLM-powered applications in production with confidence."
      }
    },
    {
      "slug": "making-your-ai-agent-reliable-adding-evaluations-to-your-multi-modal-agent-with-langwatch-skills",
      "meta": {
        "title": "Making your AI Agent reliable: Adding Evaluations to your multi-modal agent with LangWatch Skills",
        "date": "2026-03-24T00:00:00.000Z",
        "author": "Sergio Cardenas",
        "authorPhoto": "https://framerusercontent.com/images/smgdFiohT0Dw8ObEVQKtk3rOXU.jpeg",
        "category": "LLM Evals",
        "intro": "From no tests to a working multimodal eval suite in 30 minutes. How LangWatch Skills scaffolds evaluations, experiments, and simulations for a real agriculture agent.",
        "seoTitle": "Add Evaluations to a Multimodal AI Agent",
        "seoDescription": "Add evaluations to a multimodal AI agent with LangWatch Skills, scaffolding experiments, tool-usage checks, and Scenario simulations in about 30 minutes.",
        "faq": [
          {
            "q": "How do LangWatch Skills help add evaluations to an agent?",
            "a": "LangWatch Skills are curated Claude Code instructions that know the LangWatch SDK. Running npx skills add langwatch/skills/evaluations lets your coding agent scaffold the dataset, evaluators, and experiment loop for your specific agent."
          },
          {
            "q": "How do you evaluate a multimodal agent that uses vision?",
            "a": "You embed images as markdown in the dataset, which LangWatch renders inline next to scores. Evaluators like answer-relevancy, answer-correctness, and tool-usage-check then run per row so you can compare results across prompt and model changes."
          },
          {
            "q": "What is the difference between evaluations and simulations in LangWatch?",
            "a": "Evaluations test isolated input-output pairs, while simulations using LangWatch Scenario test multi-turn conversations where a user simulator and judge interact with your agent. Simulations catch grounding issues that single-turn evaluations miss."
          },
          {
            "q": "Why is a tool-usage check important?",
            "a": "An agent that returns the right answer without calling the correct tool is a hallucination risk that just got lucky. The tool-usage-check evaluator verifies the agent actually invoked the right tool for each capability."
          }
        ]
      }
    },
    {
      "slug": "mastering-the-genai-wave-strategies-for-success-in-ai-adoption",
      "meta": {
        "title": "Mastering the GenAI Wave: Strategies for Success in AI Adoption",
        "date": "2024-04-18T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Explore the race of generative AI",
        "seoTitle": "GenAI Adoption Strategies for Enterprise Success",
        "seoDescription": "Successful GenAI adoption means tackling cost, accuracy, bias, and complexity while monitoring AI solutions and scaling with a clear value proposition."
      }
    },
    {
      "slug": "monitor-your-agents-in-production-with-clawdbot",
      "meta": {
        "title": "How to Use Clawdbot + LangWatch to Monitor Your Agents in Production",
        "date": "2026-02-03T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/Zmc3JccO7xQ9je5qxtPH2Vzvlw.png",
        "image": "https://framerusercontent.com/images/r81CsOBKpQ3XYD0sK6QIw5a9MA.png",
        "category": "Integrations",
        "intro": "We are in 2026, so why should YOU be the one debugging them? Why not just ask your AI assistant to do it for you?",
        "seoTitle": "Monitor AI Agents in Production with Clawdbot + LangWatch",
        "seoDescription": "Use Clawdbot and the LangWatch MCP server to query traces, analytics, and evals in chat, so you debug production AI agents by asking, not dashboard hunting.",
        "faq": [
          {
            "q": "How does Clawdbot query LangWatch?",
            "a": "LangWatch exposes an MCP (Model Context Protocol) server that lets AI assistants query trace data directly. Combined with OpenClaw's mcporter integration, Clawdbot gains tools like search_traces, get_trace, and get_analytics to find traces, retrieve span details, and pull aggregated metrics."
          },
          {
            "q": "How do I configure the LangWatch MCP server with OpenClaw?",
            "a": "Add LangWatch to your mcporter config at ~/.openclaw/workspace/config/mcporter.json, using npx to run @langwatch/mcp and supplying your LANGWATCH_API_KEY. Your clawdbot can then call LangWatch tools through mcporter."
          },
          {
            "q": "What can Clawdbot help debug?",
            "a": "It can investigate bad responses, spikes in error rates, and prompt injection attempts by searching traces, correlating data, and explaining what happened. It can also combine LangWatch with tools like CloudWatch, Metabase, and Grafana in a single conversation."
          },
          {
            "q": "Why query traces from chat instead of a dashboard?",
            "a": "Agent failure modes are subtle and hard to spot in dashboards. Asking your assistant removes context-switching and copying trace IDs, so you go from a reported problem to exactly what happened and why in a couple of minutes."
          }
        ]
      }
    },
    {
      "slug": "navigating-the-complexities-of-ai-powered-products",
      "meta": {
        "title": "Navigating the Complexities of AI-Powered Products",
        "date": "2024-05-01T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Learn valuable insights from the frontlines of GenAI product development",
        "seoTitle": "Navigating the Complexities of AI-Powered Products",
        "seoDescription": "Building AI-powered products means tackling black-box interactions, hallucinations, latency, and privacy. Learn lessons from 100+ GenAI builders."
      }
    },
    {
      "slug": "need-based-context-engineering-let-tests-tell-you-what-your-ai-agent-actually-needs",
      "meta": {
        "title": "Need-based Context Engineering: Let tests tell you what your AI agent actually needs",
        "date": "2025-10-15T00:00:00.000Z",
        "author": "Andrew Joia",
        "authorPhoto": "https://framerusercontent.com/images/vTjGg6UPnflY5SK13A2wXIHnzSc.png",
        "category": "Agents",
        "intro": "Learn how test-driven, need-based prompt engineering creates cheaper, and performing AI agents starting from an empty prompt.",
        "seoTitle": "Need-Based Context Engineering for AI Agents",
        "seoDescription": "Need-based context engineering starts from an empty prompt and lets scenario tests tell you what your AI agent needs, cutting tokens and boosting reliability."
      }
    },
    {
      "slug": "new-dutch-startup-langwatch-brings-much-needed-quality-control-to-genai",
      "meta": {
        "title": "New Dutch Startup, LangWatch, brings much-needed quality control to GenAI",
        "date": "2024-05-20T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/95MhsD4hoYuVEaID4FqtWdbOSvI.png",
        "category": "Product Releases",
        "intro": "LangWatch, a new innovative Amsterdam-based startup: Meet the Team",
        "listImage": true,
        "seoTitle": "LangWatch Launches: Quality Control for GenAI Apps",
        "seoDescription": "LangWatch, an Amsterdam-based AI quality and analytics platform, launches to help businesses monitor GenAI, prevent risks, and ship reliable LLM products."
      }
    },
    {
      "slug": "new-pricing-ai-growth-shouldn’t-increase-your-bill",
      "meta": {
        "title": "New Pricing: AI growth shouldn’t increase your bill",
        "date": "2026-02-20T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "intro": "LangWatch charges per seat, at €29 per seat with unlimited lite seats, to share results with stakeholders, leadership and customers, and slashed prices there on usage with 200k free events plus just $1 per 100k additional event",
        "seoTitle": "New LangWatch Pricing: Predictable LLM Ops Costs",
        "seoDescription": "LangWatch's new pricing charges per seat with unlimited lite seats and low event-based usage, so AI growth stays predictable as your team scales.",
        "faq": [
          {
            "q": "How does LangWatch's new pricing work?",
            "a": "LangWatch charges per seat at 29 euros (34 dollars) with unlimited lite seats, plus event-based usage with 200k free events on the growth plan and 6 dollars per additional 100k events. This anchors cost on collaboration rather than raw trace volume."
          },
          {
            "q": "Why did LangWatch move away from trace-based pricing?",
            "a": "Modern agents trigger many internal steps per interaction, so trace-based pricing made costs rise exponentially with success. LangWatch switched to event-based pricing and slashed usage rates so tooling scales predictably as your AI grows."
          },
          {
            "q": "What are lite seats?",
            "a": "Lite seats are unlimited free seats for external stakeholders, leadership, and customers who want to view reports, graphs, and business metrics, without adding to your bill."
          },
          {
            "q": "How does pricing work for self-hosted LangWatch?",
            "a": "With self-hosted LangWatch you do not pay for any events you process, since it runs on your own infrastructure. The enterprise license requires a minimum number of seats to unlock features like SSO and audit logs."
          }
        ]
      }
    },
    {
      "slug": "new-python-sdk-native-opentelemetry-to-genai-observability",
      "meta": {
        "title": "New Python SDK Brings Native OpenTelemetry to GenAI Observability",
        "date": "2025-05-15T00:00:00.000Z",
        "author": "Alex Forbes-Reed",
        "authorPhoto": "https://framerusercontent.com/images/VcJlgjtjydHKumwodGFloo5g.png",
        "category": "Developer findings",
        "intro": "Python SDK 0.2 adds native OpenTelemetry for GenAI apps - zero-break upgrades, better tracing, and faster debugging",
        "seoTitle": "Native OpenTelemetry for GenAI: New LangWatch Python SDK",
        "seoDescription": "The new LangWatch Python SDK brings native OpenTelemetry to GenAI observability with zero breaking changes, better tracing, and faster debugging."
      }
    },
    {
      "slug": "observability-framework-design-for-llm-apps-the-complete-langwatch-guide",
      "meta": {
        "title": "Observability Framework Design for LLM Apps - The Complete LangWatch Guide",
        "date": "2025-08-01T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Integrations",
        "intro": "Understand observability framework architecture for LLM apps. Learn design principles and monitoring strategies",
        "seoTitle": "Observability Framework Design for LLM Apps",
        "seoDescription": "Design a robust observability framework for LLM apps. Learn what to monitor, how to debug complex pipelines, and how to wire evaluations into production."
      }
    },
    {
      "slug": "one-trace-two-layers-opentelemetry-between-your-llm-app-and-your-cache",
      "meta": {
        "title": "One trace, two layers: OpenTelemetry between your LLM app and your cache",
        "date": "2026-08-12T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Integrations",
        "keyphrase": "opentelemetry semantic cache",
        "intro": "Every layer of the AI stack grew its own observability. Co-written with BetterDB: how cache decisions and LLM generations composed into one OpenTelemetry trace with zero custom glue, and what that buys teams running caches under their LLM apps.",
        "seoTitle": "One Trace, Two Layers: OTel for LLM App and Cache",
        "seoDescription": "How BetterDB and LangWatch composed semantic-cache spans and LLM traces into one OpenTelemetry trace with zero integration code, and why OTel-native layers make it free.",
        "aliases": [
          "/blog/the-cache-became-a-span"
        ],
        "canonicalUrl": "https://www.betterdb.com/blog/one-trace-two-layers-otel-llm-cache",
        "faq": [
          {
            "q": "How did BetterDB spans show up in LangWatch without an integration?",
            "a": "Both layers speak OpenTelemetry. The app exported standard OTLP/HTTP spans with plain OTel semantics, and LangWatch ingests standard OTLP with no proprietary agent. Context propagation nested the app, the Vercel AI SDK telemetry, and the @betterdb/* packages into one trace with no shared code."
          },
          {
            "q": "What does langwatch.span.type do?",
            "a": "It is a single plain span attribute that says whether a span is a chain, an LLM call, a RAG step, or a tool, which is enough for LangWatch to render retrieved contexts on RAG spans and model I/O and cost on LLM spans. langwatch.thread.id and langwatch.user.id group requests into a conversation. It is light convention on top of the standard, not a proprietary protocol."
          },
          {
            "q": "Why does the LLM span disappear on a cache hit?",
            "a": "Because the model never ran. The cache check short-circuited the expensive work, so nothing emitted an LLM generation span. The trace reflects the real control flow rather than a story told after the fact, and the saved cost is written onto the cache span itself."
          },
          {
            "q": "Can you evaluate semantic cache decisions with LangWatch?",
            "a": "Yes. Once a cache decision is a span carrying similarity, the served answer, and the new question, it doubles as an evaluation dataset. You can run an evaluator over semantic-cache hits to confirm each reused answer holds up against the question it was served for; LangWatch Skills let Claude Code derive the criteria, write the eval, and run it in one session."
          }
        ]
      }
    },
    {
      "slug": "openai-anthropic-deepseek-and-other-llm-providers-keep-dropping-prices-should-you-host-your-own-model",
      "meta": {
        "title": "OpenAI, Anthropic, Deepseek and other LLM Providers keep dropping prices: Should you host your own model?",
        "date": "2025-02-20T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/44Pb3S46Yq93RUOfcyFtaUYHZo0.png",
        "category": "Governance AI",
        "intro": "OpenAI, Anthropic, Deepseek and other LLM Providers keep dropping prices: Should you host your own model?",
        "seoTitle": "Should You Host Your Own LLM or Use a Provider?",
        "seoDescription": "As LLM provider prices keep dropping, should you host your own model? Compare cost, privacy, and engineering tradeoffs to decide when self-hosting pays off."
      }
    },
    {
      "slug": "pii-redaction-for-llm-apps",
      "meta": {
        "title": "PII redaction for LLM apps: keep customer data out of your traces",
        "date": "2026-10-30T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/pii-redaction-for-llm-apps-cover.webp",
        "listImage": true,
        "category": "Governance AI",
        "keyphrase": "pii redaction llm",
        "intro": "PII redaction for LLM apps masks emails, phone numbers, card numbers and names in your traces before they are stored, so you can debug every conversation without keeping your customers' personal data in your observability tool.",
        "seoTitle": "PII Redaction for LLM Apps: Keep It Out of Your Traces",
        "seoDescription": "PII redaction for LLM apps: mask personal data in traces at ingestion, restrict or drop content per team, block it at the gateway, or keep it in your cloud.",
        "faq": [
          {
            "q": "What is PII redaction in an LLM app?",
            "a": "PII redaction replaces personal data, such as emails, phone numbers, card numbers and names, with a typed marker like [EMAIL_ADDRESS] before the text is stored. In an LLM app your traces need it, because they record every prompt, tool call and reply your users send."
          },
          {
            "q": "Does PII redaction change what my app sends to the model?",
            "a": "Not in LangWatch. The data privacy policy changes what LangWatch stores and who can read it, and the request to the model provider stays the same. To stop personal data from reaching the provider, put a PII detection guardrail on the request in the LangWatch AI Gateway or in your code."
          },
          {
            "q": "Is regex enough to detect PII?",
            "a": "Regex is a good start for formats like emails and card numbers, and it misses names, addresses and personal data written in free text. On our PII detection benchmark, a regex baseline left almost half of the personal data in, far behind the best detection models."
          },
          {
            "q": "Can I still debug my agent if its traces are redacted?",
            "a": "Yes. Redaction swaps the value for a marker that names what it was, so you still see that the user gave a phone number and what the agent did with it. Tokens, cost, latency, model and the span tree stay intact, even when you drop the content completely."
          },
          {
            "q": "Where is my trace data stored when I use LangWatch?",
            "a": "You choose. LangWatch Cloud, Cloud Enterprise on dedicated instances in the region you pick, hybrid where the trace data stays in your own VPC, or fully self-hosted on AWS, Azure, GCP or bare metal, air-gapped included."
          }
        ]
      }
    },
    {
      "slug": "pms-and-ceos-are-running-agent-simulations-now-—-and-it-s-changing-how-ai-ships",
      "meta": {
        "title": "Product Managers and leaders are running agent simulations now, and it changing how AI ships",
        "date": "2026-03-25T00:00:00.000Z",
        "author": "Sergio Cardenas",
        "authorPhoto": "https://framerusercontent.com/images/smgdFiohT0Dw8ObEVQKtk3rOXU.jpeg",
        "category": "Agents",
        "intro": "PMs and CEOs are now testing AI agents before launch using LangWatch and Claude. Learn how non-technical leaders simulate real-world scenarios, validate multi-agent systems, and ship AI with confidence.",
        "seoTitle": "PMs and CEOs Are Running Agent Simulations Now",
        "seoDescription": "Non-technical leaders now write agent simulations in plain language with LangWatch and Claude, testing AI agents before a single customer sees them.",
        "faq": [
          {
            "q": "How can non-technical leaders test AI agents with LangWatch?",
            "a": "Through the LangWatch MCP integration in Claude Desktop, a PM or CEO describes expected agent behavior in plain language. Claude structures it into properly formatted scenarios with evaluation criteria and pushes them to LangWatch, with no terminal or code required."
          },
          {
            "q": "Why are domain experts better placed to write agent simulations?",
            "a": "The people who understand the business domain, like a PM who has talked to hundreds of customers or a founder with deep domain insight, are best positioned to describe what correct agent behavior looks like. The bottleneck was never knowledge, it was tooling."
          },
          {
            "q": "Can LangWatch simulations test multi-agent and multi-tool systems?",
            "a": "Yes. A product owner can encode happy-path, edge-case, multi-turn, and tool-failure scenarios for a pipeline that calls KYC checks, transaction history, and fraud scoring, validating how the system behaves under pressure rather than running a single prompt."
          }
        ]
      }
    },
    {
      "slug": "pr-hound",
      "meta": {
        "title": "The PR Hound: how we fixed PR review assignment with a daily agent",
        "date": "2026-07-09T00:00:00.000Z",
        "author": "Andrew Joia",
        "authorPhoto": "/people/andrew-joia.webp",
        "image": "/blog/pr-hound.webp",
        "category": "Developer findings",
        "keyphrase": "pr review assignment",
        "intro": "We leaned into agentic coding and started shipping far more code than our review process could keep up with, so PRs piled up unreviewed. Six days after we put a daily agent in charge of review assignment, every open PR on our main repo, back to March, has exactly one owner and one reviewer.",
        "seoTitle": "PR Review Assignment with an Always-On Agent: The PR Hound",
        "seoDescription": "How LangWatch fixed PR review assignment with a daily agent: every PR gets one owner, one reviewer, and a Slack nudge until it moves. Human merges went from about 10 to 18.5 per workday.",
        "faq": [
          {
            "q": "What does the PR Hound do for PR review assignment?",
            "a": "Every day it goes through all open PRs, assigns each one to a specific person (defaulting to the author), picks exactly one human reviewer per PR, and marks not-ready PRs, CI failing or unresolved comments, as needing cleanup. It posts a per-person digest in Slack every morning and follows up at three in the afternoon if your queue hasn't moved."
          },
          {
            "q": "Does the PR Hound merge or review the code itself?",
            "a": "No. Nothing merges automatically; the Hound surfaces what is approved and a human says go. Separate agents review the code. The Hound barely looks at it, and it is a different agent from the pr-reviewer covered in the background-agents post."
          },
          {
            "q": "Did it actually change anything?",
            "a": "Six days in, 44 of 44 hound-checked open PRs on the main repo have an assignee, against about 40% of the PRs it has not reached, and human merges went from about 10 a workday to 18.5, roughly 1.85x, with dependabot and the fleet's agent account excluded. Caveat: that is a four-workday rate window and other fleet agents went live at the same time."
          },
          {
            "q": "What are the review-effort labels for?",
            "a": "The Hound tags every PR with a review-effort tier (currently on the main repo: 22 targeted, 20 deep, 5 fast-skim, 3 questionable-premise, 1 reject-shape) so you can decide whether you have time for a PR before you open it."
          },
          {
            "q": "Why not just list the whole team as reviewers?",
            "a": "That was the old setup, and it meant review was nobody's job: everyone assumed someone else would get to it, and PRs sat long enough to grow merge conflicts. One named reviewer per PR is the fix."
          }
        ]
      }
    },
    {
      "slug": "real-time-simulation-visualization-and-debug-mode",
      "meta": {
        "title": "Real-time simulation visualization and debug mode",
        "date": "2025-06-27T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/kLQbW5O40gUzX6dcKjgvc53oaGg.jpg",
        "category": "Agents",
        "intro": "Watch simulated conversations play out in real-time with parallel execution, versioned runs, and interactive debugging.",
        "seoTitle": "Real-Time Simulation Visualization and Debug Mode",
        "seoDescription": "Watch simulated agent conversations in real time with parallel runs, versioned comparisons, and a debug mode that lets you pinpoint where issues happen."
      }
    },
    {
      "slug": "rebuilding-langwatch-in-51-days",
      "meta": {
        "title": "Refactoring at AI speed, without the AI slop",
        "seoTitle": "Refactoring at AI speed, without the AI slop",
        "seoDescription": "We just merged a 4+ million line refactor of LangWatch: 66 clean modules in 51 days, one engineer, a lot of AI agents, no slop.",
        "date": "2026-10-13",
        "author": "Alex Forbes-Reed",
        "category": "Engineering",
        "intro": "We just merged a 4+ million line refactor of LangWatch: 66 clean modules in 51 days, one engineer, a lot of AI agents, no slop."
      }
    },
    {
      "slug": "safeguarding-your-first-llm-powered-innovation-essential-practices-for-security",
      "meta": {
        "title": "Safeguarding Your First LLM-Powered Innovation: Essential Practices for Security",
        "date": "2024-05-13T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Governance AI",
        "intro": "Journey of launching your first LLM-powered product is filled with potential and challenges.",
        "seoTitle": "LLM Security: Essential Practices to Safeguard Your AI App",
        "seoDescription": "Secure your first LLM-powered product. Learn to defend against prompt injection, jailbreaking, and data risks with practical LLM security best practices."
      }
    },
    {
      "slug": "scenario-mcp-automatic-agent-test-generation-inside-your-editor",
      "meta": {
        "title": "Scenario MCP: Automatic Agent Test Generation inside your editor",
        "date": "2025-11-25T00:00:00.000Z",
        "author": "Aryan",
        "authorPhoto": "https://framerusercontent.com/images/OD6whl02uIkzREM9w4YxGgvAHE.jpg",
        "image": "https://framerusercontent.com/images/AtUCWellNK77tKIsT40ZHV3wcug.png",
        "category": "Product Releases",
        "intro": "Automate AI agent testing with LangWatch Scenarios and MCP. Skip manual checks - let your agent generate repeatable test files and validate real-world behavior.",
        "seoTitle": "Scenario MCP: Automatic Agent Test Generation",
        "seoDescription": "Use Scenario MCP to generate AI agent tests inside your editor. Describe a scenario, trigger the command, and LangWatch writes a complete test file for you."
      }
    },
    {
      "slug": "scripted-simulations-evaluations-guardrails",
      "meta": {
        "title": "Scripted simulations, evaluations, and guardrails",
        "date": "2025-06-26T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/kLQbW5O40gUzX6dcKjgvc53oaGg.jpg",
        "category": "Agents",
        "intro": "Scripted simulations let you orchestrate how conversations unfold, when evaluations occur, and what custom logic runs.",
        "seoTitle": "Scripted Simulations, Evaluations, and Guardrails",
        "seoDescription": "Scripted simulations orchestrate how agent conversations unfold, when evaluations run, and what custom logic fires, so you can reproduce production issues."
      }
    },
    {
      "slug": "self-hosted-llm-observability",
      "meta": {
        "title": "Open source LLM observability in 2026: what runs in your cluster and what calls home",
        "date": "2026-10-24T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/self-hosted-llm-observability-cover.webp",
        "listImage": true,
        "category": "Governance AI",
        "keyphrase": "open source llm observability",
        "intro": "Open source LLM observability you can self-host: what a LangWatch install runs, the one daily report it sends home and how to switch it off, air-gapped installs with offline licenses, and how it compares with Langfuse, Arize Phoenix and LangSmith.",
        "seoTitle": "Open Source LLM Observability: Self-Hosting Guide 2026",
        "seoDescription": "Open source LLM observability you can self-host in 2026: what runs in your cluster, every outbound connection, air-gapped installs, and a fair tool comparison.",
        "faq": [
          {
            "q": "What is the best self-hosted LLM gateway for enterprises?",
            "a": "One that runs inside your own perimeter and logs every call next to your traces. The LangWatch AI Gateway ships in the same Helm chart as the rest of LangWatch: an OpenAI-compatible endpoint with virtual keys, budgets, routing and fallbacks across providers, guardrails and prompt caching. It calls the model providers you configure with your own keys, and one chart value turns it off."
          },
          {
            "q": "Is Langfuse open source?",
            "a": "Yes. The Langfuse core is MIT licensed and runs the same infrastructure as Langfuse Cloud: a web and a worker container with PostgreSQL, ClickHouse, Redis and S3. A license key adds project-level RBAC roles, audit logs, data retention policies, SCIM and server-side data masking. Telemetry can be switched off on the open source edition, and on the Enterprise edition it stays on for license compliance."
          },
          {
            "q": "Does self-hosted LangWatch send data back to LangWatch?",
            "a": "It sends one usage report a day with counts and metadata, and a licensed install with hosted services also syncs its license once a day. Neither carries a trace, a prompt, a dataset row, a name, an email address or a key. DISABLE_USAGE_STATS=true stops the report, and LANGWATCH_CONNECT_DISABLED=true stops every connection to LangWatch."
          },
          {
            "q": "Can I run LLM observability in an air-gapped environment?",
            "a": "Yes. With LangWatch you mirror the images into your private registry, install the Helm chart in your own cluster, and use a signed license key, which is verified locally and works offline. Set LANGWATCH_CONNECT_DISABLED=true so nothing tries to reach the internet. LLM-as-a-judge evaluators need a model you can reach inside the network."
          },
          {
            "q": "Do I need a license to self-host LangWatch?",
            "a": "No. Self-hosted LangWatch is Apache 2.0 and uncapped without a license: unlimited members, projects, traces, evaluations, simulations and the AI Gateway, commercial use included. An Enterprise license adds SSO, SCIM, custom roles, audit logs, longer retention and a support contract, all in the same deployment, so adding one needs no reinstall."
          }
        ]
      }
    },
    {
      "slug": "simulation-based-eval-framework",
      "meta": {
        "title": "Simulation Based Eval Framework",
        "date": "2025-06-06T00:00:00.000Z",
        "author": "Tahmid - AI research @LangWatch",
        "authorPhoto": "https://framerusercontent.com/images/HLM4vDStvIk5xOpUCf6Vr1gq8.png",
        "image": "https://framerusercontent.com/images/aUaFk5EF3If7DmC5KI0WhkMTvk.png",
        "category": "Agents",
        "intro": "AI agents: The real challenge is making sure it works: reliably, accurately, and at scale.",
        "seoTitle": "Simulation-Based Eval Framework for AI Support Agents",
        "seoDescription": "A simulation-based evaluation framework that tests AI support agents end to end using support, simulator, and evaluator agents for hard metrics."
      }
    },
    {
      "slug": "simulations-from-first-principles",
      "meta": {
        "title": "Simulations from First Principles (How to test your agents)",
        "date": "2025-06-12T00:00:00.000Z",
        "author": "Tahmid AI researcher @ LangWatch",
        "authorPhoto": "https://framerusercontent.com/images/HLM4vDStvIk5xOpUCf6Vr1gq8.png",
        "image": "https://framerusercontent.com/images/agCxV7UPanGFTx2fMY9LQXGpyE.png",
        "category": "Agents",
        "intro": "A practical playbook that frames evals as a CI/CD pipeline.",
        "seoTitle": "Agent Simulations from First Principles: A Playbook",
        "seoDescription": "Test AI agents with multi-step simulations instead of static benchmarks. A first-principles framework that frames agent evals as a CI/CD pipeline."
      }
    },
    {
      "slug": "simulations-to-test-my-agent",
      "meta": {
        "title": "Simulations to Test My Agent",
        "date": "2025-05-28T00:00:00.000Z",
        "author": "Tahmid, AI Researcher @ LangWatch",
        "authorPhoto": "https://framerusercontent.com/images/HLM4vDStvIk5xOpUCf6Vr1gq8.png",
        "image": "https://framerusercontent.com/images/lwQkzQzyUbtqkGNfU6NG0J4Hgc.png",
        "category": "Agents",
        "intro": "How I stopped evaluating AI Agents like robots and started testing them like humans (with simulations)",
        "seoTitle": "Using Simulations to Test AI Agents the Right Way",
        "seoDescription": "Testing AI agents by fixed tool sequences punishes adaptive behavior. See why simulating real conversations evaluates multi-turn agents far better."
      }
    },
    {
      "slug": "successfully-building-an-ai-startup-in-the-current-booming-industry",
      "meta": {
        "title": "Successfully building an AI Startup in the current booming industry",
        "date": "2024-04-18T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Learn how AI start-ups can succeed by creating targeted generative AI solutions and effectively monitoring LLMs.",
        "seoTitle": "Building a Successful AI Startup in a Booming Industry",
        "seoDescription": "Build a successful AI startup by solving real user pain points, monitoring LLMs, evaluating model performance, and managing risky behaviors proactively."
      }
    },
    {
      "slug": "systematically-improving-rag-agents",
      "meta": {
        "title": "Systematically Improving RAG Agents",
        "date": "2025-04-24T00:00:00.000Z",
        "author": "Tahmid Tapadar",
        "authorPhoto": "https://framerusercontent.com/images/HLM4vDStvIk5xOpUCf6Vr1gq8.png",
        "image": "https://framerusercontent.com/images/YROdIaFs1HtteahK4GB1EvNZacA.png",
        "category": "Agents",
        "intro": "Improving RAG agents: Build a basic system, Create evaluation data, run experiments",
        "seoTitle": "Systematically Improving RAG Agents With Evals",
        "seoDescription": "Improve RAG agents with a repeatable flywheel: build a baseline, generate evaluation data, run experiments, analyze errors, and iterate to production."
      }
    },
    {
      "slug": "tackling-llm-hallucinations-with-langwatch-why-monitoring-and-evaluation-matter",
      "meta": {
        "title": "Tackling LLM Hallucinations with LangWatch: Why Monitoring and Evaluation Matter",
        "date": "2025-04-04T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/V25WSxfQ94FnHs7EXJrF2UVHghk.png",
        "category": "LLM Evals",
        "intro": "What are LLM Hallucinations? What causes LLM hallucinations? How to monitor and evaluate LLM-apps",
        "seoTitle": "Tackling LLM Hallucinations With Monitoring & Evals",
        "seoDescription": "Learn what causes LLM hallucinations and how monitoring and evaluation help you detect and reduce false outputs before they reach users in production."
      }
    },
    {
      "slug": "taming-babel-from-multilingual-headaches-to-ci-confidence-building-(and-testing)-a-chat-ai-agent-with-scenario",
      "meta": {
        "title": "Multilingual AI Agent Testing: Using Scenario to Simulate, Break, and Improve LLMs",
        "date": "2025-06-20T00:00:00.000Z",
        "author": "Andrew - Engineer @ LangWatch",
        "authorPhoto": "https://framerusercontent.com/images/g90ewfSLv6xntbkdgDHbJ4q0EA.jpeg",
        "image": "https://framerusercontent.com/images/XQzwLWzupPXPtg8YAyMNg1HDMJc.png",
        "category": "Agents",
        "intro": "Discover how Scenario enables bulletproof testing of multilingual LLM agents through, ensuring your AI is production-ready",
        "seoTitle": "Multilingual AI Agent Testing with Scenario in CI",
        "seoDescription": "Multilingual AI agent testing catches language drift and broken JSON before users do. See how Scenario turns user stories into CI-ready simulations."
      }
    },
    {
      "slug": "tdd-with-llms",
      "meta": {
        "title": "The complete guide for TDD with LLMs",
        "date": "2024-07-03T00:00:00.000Z",
        "author": "Rogerio - CTO",
        "authorPhoto": "https://framerusercontent.com/images/fnGfSoEC5VVQejLuz2u1ZX6GvA.jpeg",
        "category": "Agents",
        "intro": "How can we test in a probabilistic environment? Test Driven Development for LLM's",
        "seoTitle": "TDD with LLMs: The Complete Guide to Testing AI Apps",
        "seoDescription": "TDD with LLMs means writing tests before prompts. Learn how to apply test-driven development with pytest to build reliable, predictable LLM applications."
      }
    },
    {
      "slug": "test-agents-on-mastra-agno-and-10-other-frameworks",
      "meta": {
        "title": "Test agents on Mastra, Agno, and 10+ other frameworks",
        "date": "2025-06-25T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/kLQbW5O40gUzX6dcKjgvc53oaGg.jpg",
        "category": "Integrations",
        "intro": "Scenario is framework-agnostic, supporting any agent architecture through the AgentAdapter interface.",
        "seoTitle": "Test Agents on Mastra, Agno, and 10+ Frameworks",
        "seoDescription": "Test agents on Mastra, Agno, LangGraph, CrewAI, and 10+ frameworks. Scenario is framework-agnostic via the AgentAdapter interface, no code changes needed."
      }
    },
    {
      "slug": "testing-voice-agents-with-langwatch-scenario-in-real-time",
      "meta": {
        "title": "Testing Voice Agents with LangWatch Scenario in Real Time",
        "date": "2025-11-24T00:00:00.000Z",
        "author": "Andrew Joia",
        "authorPhoto": "/people/andrew-joia.webp",
        "image": "https://framerusercontent.com/images/R2IurVaXQ3EDtqvmRH2PWzkd7k.png",
        "category": "Voice AI",
        "intro": "Learn how to test real-time voice agents with LangWatch Scenario. Automate speech-to-speech testing, simulate user conversations, validate latency and performance, and run voice agent evaluations in CI - no microphones or manual testing required.",
        "seoTitle": "Testing Voice Agents With LangWatch Scenario",
        "seoDescription": "Test real-time voice agents with LangWatch Scenario. Run automated speech-to-speech tests, simulate users, and validate latency in CI, no microphones needed."
      }
    },
    {
      "slug": "the-6-best-llm-evaluation-platforms-in-2025-why-langwatch-redefines-the-category-with-agent-testing-with-simulations",
      "meta": {
        "title": "The 6 Best LLM Evaluation Platforms in 2025: Why LangWatch redefines the category with Agent Testing (with Simulations)",
        "date": "2025-10-17T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "LangWatch leads 2025 LLM evaluation with agent simulations, uniting testing, monitoring, and reliability",
        "seoTitle": "The 6 Best LLM Evaluation Platforms in 2025",
        "seoDescription": "Compare the 6 best LLM evaluation platforms in 2025 and see why LangWatch redefines the category with agent testing and real-world simulations.",
        "aliases": [
          "/blog/the-4-best-llm-evaluation-platforms-in-2025-why-langwatch-eedefines-the-category-with-agent-testing-(with-simulations)",
          "/blog/the-5-best-llm-evaluation-platforms-in-2025-why-langwatch-redefines-the-category-with-agent-testing-with-simulations"
        ]
      }
    },
    {
      "slug": "the-6-context-engineering-challenges-stopping-ai-from-scaling-in-production",
      "meta": {
        "title": "The 6 context engineering challenges stopping AI from scaling in production",
        "date": "2025-08-19T15:28:48.558Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Agents",
        "intro": "Discover 6 context engineering challenges blocking AI from scaling - and how LangWatch helps enterprises overcome them",
        "seoTitle": "6 Context Engineering Challenges Blocking AI Scale",
        "seoDescription": "Explore the 6 context engineering challenges stopping AI from scaling in production, from garbage-in data to retrieval, and how enterprises can overcome them."
      }
    },
    {
      "slug": "the-8-types-of-llm-hallucinations",
      "meta": {
        "title": "LLM hallucinations: 8 types with real examples, and how to catch them",
        "date": "2026-11-01T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "/blog/the-8-types-of-llm-hallucinations-cover.webp",
        "listImage": true,
        "category": "LLM Evals",
        "tags": [
          "llm hallucinations",
          "hallucination examples",
          "evals",
          "guardrails",
          "agent testing"
        ],
        "keyphrase": "llm hallucination examples",
        "intro": "Eight LLM hallucination examples from a courtroom, an airline, a search engine and coding agents, one for each type, with the check that catches it before release and on live traffic.",
        "seoTitle": "LLM Hallucination Examples: 8 Types and How to Catch Them (2026)",
        "seoDescription": "LLM hallucination examples sorted into 8 types, from fake citations to agents reporting actions they never took, and the check that catches each one.",
        "faq": [
          {
            "q": "What are LLM hallucinations?",
            "a": "An LLM hallucination is a confident answer that nothing backs up: not the facts, not the documents the model was given, and not the results of the tools it called. A language model predicts likely text, and a likely sentence can be false, so a made-up policy comes out in the same tone as a real one."
          },
          {
            "q": "What are some real examples of LLM hallucinations?",
            "a": "Lawyers in Mata v. Avianca were fined $5,000 for filing a brief with court cases ChatGPT made up. An Air Canada chatbot promised a bereavement refund the airline's own page ruled out, and a tribunal made the airline pay. Google's AI Overviews told people to put glue on pizza, from a joke on Reddit. A coding agent at Replit told its user a database rollback would not work, and it did."
          },
          {
            "q": "What causes LLM hallucinations?",
            "a": "The model fills in what it does not have. That happens when retrieval returns nothing relevant, when a source is wrong or out of date, when a tool fails and the agent answers anyway, when a long context buries the right fact, and when the question is about something the model never saw. Each cause points to a different check."
          },
          {
            "q": "Can you stop LLM hallucinations completely?",
            "a": "No. You can make them rarer with better retrieval, clear instructions to say 'I don't know', and tools for facts the model should not recall from memory. Then you catch the rest: faithfulness and trace checks in tests before release, monitors on live traffic, and guardrails for the claims that must never reach a user."
          },
          {
            "q": "How do you detect hallucinations in production?",
            "a": "Run monitors on your live traces: a faithfulness evaluator on RAG answers, and an LLM-as-a-judge that reads the whole trace, tool calls included, to check that every claim in the reply comes from a document or a tool result. Block the dangerous ones with a guardrail before the user sees them, and ask new questions of your whole history with Instant Evals."
          }
        ]
      }
    },
    {
      "slug": "the-agent-development-lifecycle-why-shipping-is-the-easy-part",
      "meta": {
        "title": "The Agent Development Lifecycle: Why shipping is the easy part",
        "date": "2026-03-06T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Agents",
        "intro": "Most AI agents look brilliant in demos. Then real users arrive - and things get complicated. Here's the systematic framework your team needs to keep agents reliable, safe, and genuinely improving in production.",
        "seoTitle": "The agent development lifecycle for reliable AI agents",
        "seoDescription": "The agent development lifecycle is more than shipping. Learn the framework to keep AI agents reliable, safe, and improving once they hit production.",
        "faq": [
          {
            "q": "What is the agent development lifecycle?",
            "a": "It is the end-to-end process of building, testing, evaluating, deploying, and monitoring AI agents so they stay reliable after they reach real users, not just in a demo."
          },
          {
            "q": "Why is shipping an AI agent the easy part?",
            "a": "Standing up a demo is fast, but keeping an agent accurate, safe, and improving against unpredictable real-world usage in production is the hard, ongoing work."
          },
          {
            "q": "How does LangWatch support the agent development lifecycle?",
            "a": "LangWatch adds observability, evaluations, simulations, and governance across every stage, so teams catch regressions and quality drops before users ever see them."
          }
        ]
      }
    },
    {
      "slug": "the-ai-team-integrating-user-and-domain-expert-feedback-to-enhance-llm-powered-applications",
      "meta": {
        "title": "The AI Team: Integrating User and Domain Expert Feedback to Enhance LLM-Powered Applications",
        "date": "2024-06-10T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Understand what is The AI Team and what are Their Roles",
        "seoTitle": "The AI Team: Human-in-the-Loop Feedback for LLM Apps",
        "seoDescription": "Build a human-in-the-loop AI team. See how user and domain expert feedback, plus the right roles, make LLM-powered applications more accurate and useful."
      }
    },
    {
      "slug": "the-panel-of-judges-approach-using-llm-as-a-judge-to-approximate-human-preference",
      "meta": {
        "title": "LLM-as-a-Judge: Using the Panel of Judges Approach to Approximate Human Preference",
        "date": "2025-08-07T10:10:53.689Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "category": "LLM Evals",
        "intro": "Discover how multiple LLM as a judge evals create a panel system that match with human preference for subjective AI quality.",
        "seoTitle": "LLM-as-a-Judge: A Panel of Judges for AI Quality",
        "seoDescription": "Learn how a panel of LLM-as-a-judge evaluators approximates human preference and scores subjective AI quality where no golden truth exists."
      }
    },
    {
      "slug": "the-power-of-miprov2-in-a-low-code-environment-with-langwatch-s-optimization-studio",
      "meta": {
        "title": "The power of MIPROv2 (DSPy) in a Low-Code environment with LangWatch’s Optimization Studio",
        "date": "2024-11-10T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Product Releases",
        "intro": "Leverage the power of DSPy’s MIPROv2 without diving into complex code? Enter LangWatch’s Optimization Studio",
        "seoTitle": "MIPROv2 Prompt Optimization in a Low-Code Studio",
        "seoDescription": "Use DSPy's MIPROv2 optimizer without the code. LangWatch's Optimization Studio brings low-code prompt optimization for consistent, high-quality LLM output."
      }
    },
    {
      "slug": "the-ultimate-rag-blueprint-everything-you-need-to-know-about-rag-in-2025-2026",
      "meta": {
        "title": "The Ultimate RAG Blueprint: Everything you need to know about RAG in 2025/2026",
        "date": "2025-10-06T00:00:00.000Z",
        "author": "Rogerio",
        "authorPhoto": "https://framerusercontent.com/images/7okK9S0zpUhT562OuWV8w1h8j6M.jpg",
        "image": "https://framerusercontent.com/images/gv0wp8xwjIStqg9kk4MCQ3oFLc.png",
        "category": "Integrations",
        "intro": "Use this guide as the map for building and evaluating any RAG system",
        "seoTitle": "The Ultimate RAG Blueprint for 2025 and 2026",
        "seoDescription": "The ultimate RAG blueprint maps data ingestion, hybrid search, agentic retrieval, and eval loops so you can build and evaluate any RAG system in 2025/2026.",
        "listImage": true
      }
    },
    {
      "slug": "things-you-can-ask-langy",
      "meta": {
        "title": "Things you can ask Langy",
        "date": "2026-07-23T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "category": "Product Releases",
        "intro": "The real questions teams ask Langy about their agents, and how it answers them from your traces and code, then opens the fix as a PR.",
        "keyphrase": "automated ai engineer",
        "seoTitle": "Things you can ask Langy, the automated AI engineer",
        "seoDescription": "Langy is the automated AI engineer inside LangWatch. Ask why your agent regressed, whether a cheaper model breaks it, or why costs spiked, and it opens the fix as a PR."
      }
    },
    {
      "slug": "top-10-llm-observability-tools-complete-guide-for-2026",
      "meta": {
        "title": "The best LLM observability tools in 2026, compared",
        "date": "2026-10-21T00:00:00.000Z",
        "author": "Bram P",
        "authorPhoto": "https://framerusercontent.com/images/OB3BklBp0JroME555CsLtUed5uA.jpg",
        "image": "/blog/llm-observability-tools-2026-cover.webp",
        "listImage": true,
        "category": "LLM Evals",
        "keyphrase": "llm observability tools",
        "intro": "Ten LLM observability tools compared for AI platform teams at enterprises and in regulated industries: tracing, evals and agent tests for every team, an AI gateway with budgets, an inventory of every AI tool, Claude Code and Codex spend, self-hosting and SSO, checked in October 2026.",
        "seoTitle": "10 Best LLM Observability Tools in 2026, Compared",
        "seoDescription": "The best LLM observability tools in 2026 for AI platform teams: evals, agent testing, AI gateway, governance, coding-agent spend, self-hosting and SSO compared.",
        "aliases": [
          "/blog/top-10-llm-observability-tools-complete-guide-for-2025"
        ],
        "faq": [
          {
            "q": "What is LLM observability?",
            "a": "LLM observability is tracing and monitoring a language model application in production. Each request becomes a trace with the prompts, responses, tool calls and retrieval steps, plus token counts, cost and latency on every span. Evaluations on top of those traces tell you whether the answers were any good, which logs and uptime checks can't."
          },
          {
            "q": "Which LLM observability tool is best for an AI platform team?",
            "a": "LangWatch. An AI platform team serves many product teams and also answers for spend and compliance, so it needs tracing, evals and agent tests for every team's agents, an AI gateway with budgets, an inventory of the AI tools the company runs, and Claude Code and Codex spend, all behind SSO, SCIM and audit logs. LangWatch covers all of it in one open-source platform you can self-host or run hybrid."
          },
          {
            "q": "What are the best tools for monitoring and optimizing large language model applications?",
            "a": "For monitoring, pick a tracing platform with cost and latency per span and alerts: LangWatch, Langfuse, Arize, LangSmith, Braintrust or Datadog. For optimizing, you need evaluations on the same traces, so you can compare a prompt or model change on real data before it ships. LangWatch, Langfuse, LangSmith and Braintrust run evals on datasets and on production traffic."
          },
          {
            "q": "Which LLM observability tools are open source?",
            "a": "LangWatch (Apache-2.0), Comet Opik (Apache-2.0) and MLflow (Apache-2.0) are open source and free to self-host. Langfuse is MIT with some enterprise features under a commercial licence. Arize Phoenix is source-available under the Elastic License 2.0, free to self-host but not to resell as a service. LangSmith, Braintrust, Datadog, Confident AI and Galileo are proprietary."
          },
          {
            "q": "Which LLM observability tools can run in a regulated environment?",
            "a": "Look for self-hosting, a hybrid option and enterprise identity. LangWatch self-hosts free with the same build as its cloud, has a hybrid setup where traces stay in your own ClickHouse and S3, and adds SSO, SCIM, custom roles and audit logs on Enterprise. Langfuse, Phoenix, Opik and MLflow also self-host free, and LangSmith and Braintrust self-host on their enterprise plans."
          },
          {
            "q": "Which LLM observability tool is best for testing AI agents?",
            "a": "LangWatch has agent testing built in: a simulated user talks to your agent over many turns and a judge passes or fails each criterion, for chat and voice agents, with multi-turn red teaming, from the platform or from CI. LangSmith, Opik, MLflow and Confident AI also offer multi-turn simulation in some form, so compare how each fits your test runner and CI."
          }
        ]
      }
    },
    {
      "slug": "top-5-ai-evaluation-tools-for-ai-agents-products-in-production-(2026)",
      "meta": {
        "title": "Top 5 AI evaluation tools for AI agents & products in production (2026)",
        "date": "2026-01-30T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Discover the top 5 AI evaluation tools in 2026. Compare LangWatch, Braintrust, Arize, and others for testing, monitoring, and improving LLM applications in production",
        "seoTitle": "Top 5 AI Evaluation Tools for AI Agents in 2026",
        "seoDescription": "Compare the top 5 AI evaluation tools for 2026, including LangWatch, Braintrust, Arize, Maxim, and Galileo, to test and monitor LLM apps in production.",
        "faq": [
          {
            "q": "What are the best AI evaluation tools in 2026?",
            "a": "The top AI evaluation tools include LangWatch for full LLMOps and agent simulations, Braintrust for development-to-production workflows, Arize for enterprise ML and LLM monitoring, Maxim for agent simulation, and Galileo for automated hallucination detection."
          },
          {
            "q": "What is AI evaluation?",
            "a": "AI evaluation is the systematic measurement of AI system performance using automated scoring, production monitoring, and continuous testing against quality standards, spanning offline pre-deployment testing and online production evaluation."
          },
          {
            "q": "Why use LangWatch for AI evaluation?",
            "a": "LangWatch combines integrated evaluation, agentic scenario testing, online and offline evals, and prompt management in one platform, helping teams catch quality degradation before users do."
          }
        ]
      }
    },
    {
      "slug": "top-5-ai-prompt-management-tools-of-2025",
      "meta": {
        "title": "Top 5 AI Prompt Management Tools of 2025",
        "date": "2025-12-23T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "AI prompt management tools help teams version, test, evaluate, and safely deploy prompts that control LLM and agent behavior, making AI systems reproducible, observable, and reliable in production.",
        "seoTitle": "Top 5 AI Prompt Management Tools of 2025",
        "seoDescription": "Compare the top 5 AI prompt management tools of 2025 to version, test, evaluate, and deploy prompts that keep your LLM and agent systems reliable."
      }
    },
    {
      "slug": "top-tools-for-evaluating-voice-agents-in-2025",
      "meta": {
        "title": "Top Tools for Evaluating Voice Agents in 2025",
        "date": "2025-12-30T00:00:00.000Z",
        "author": "Bram P",
        "authorPhoto": "https://framerusercontent.com/images/OB3BklBp0JroME555CsLtUed5uA.jpg",
        "image": "https://framerusercontent.com/images/ZFeeSmWhor06guRRLkBn78cEq1o.png",
        "category": "Voice AI",
        "intro": "Evaluate voice agents at scale with simulation-based testing. Compare the best voice agent evaluation tools in 2025, including LangWatch.",
        "seoTitle": "Top Tools for Evaluating Voice Agents in 2025",
        "seoDescription": "Compare the top voice agent evaluation tools of 2025 and test voice AI at scale with simulation-based, audio-native testing instead of manual calls."
      }
    },
    {
      "slug": "trace-ids-llm-observability-and-distributed-tracing",
      "meta": {
        "title": "Trace IDs in AI: LLM Observability and Distributed Tracing",
        "date": "2025-08-22T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Integrations",
        "intro": "Learn how trace IDs enable observability across LLM apps. Track prompts, tokens, latency, & costs across AI workflows.",
        "seoTitle": "Trace IDs for LLM Observability and Tracing",
        "seoDescription": "Learn how trace IDs power LLM observability and distributed tracing, tracking prompts, tokens, latency, and costs to debug AI workflows fast."
      }
    },
    {
      "slug": "track-claude-code-usage-and-spend-across-your-company",
      "meta": {
        "title": "How to track Claude Code usage and spend across your company",
        "date": "2026-10-27T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/track-claude-code-usage-and-spend-across-your-company-cover.webp",
        "listImage": true,
        "category": "Agents",
        "keyphrase": "claude code analytics",
        "intro": "Claude Code analytics for a whole company: what /usage and Anthropic's dashboards show, how to roll out one command per developer, and how to see the cost of every session, repository and pull request.",
        "seoTitle": "Claude Code Analytics: Track Usage and Spend Company-Wide",
        "seoDescription": "Claude Code analytics for your company: usage and spend per developer, team, session and pull request over OpenTelemetry, and what really drives the bill.",
        "faq": [
          {
            "q": "Is there an observability tool for Claude Code sessions?",
            "a": "Yes. LangWatch reads Claude Code's built-in OpenTelemetry export. Run npx langwatch claude once and every session shows up with its cost, the context it carried, its compactions and a terminal replay, plus one trace per turn with the tool call tree and each subagent on its own branch. Codex, Copilot, Gemini CLI and opencode work the same way."
          },
          {
            "q": "Does Claude Code have built-in analytics?",
            "a": "Yes, in a few places. The /usage command shows your current session's tokens and an estimated cost. Teams and Enterprise admins get a dashboard with active users, sessions, accepted lines and pull requests made with Claude Code, and Console customers see spend per member. For per-user token and cost data in your own tools, Anthropic points you to OpenTelemetry."
          },
          {
            "q": "Can I track Claude Code usage on a Claude subscription like Max or Teams?",
            "a": "Yes. On a subscription, Claude Code keeps your own plan and login, and LangWatch receives telemetry only. Since you don't pay per token there, LangWatch shows the cost in API-equivalent dollars, what the same tokens would cost at Anthropic's list prices. A saving on a subscription means more work before you reach the plan's limits."
          },
          {
            "q": "Can admins read what developers type into Claude Code?",
            "a": "Only through an audited path. Sessions land in each developer's personal project by default. An admin can open them, but a Viewing as admin banner stays on the page and every read writes an audit log row the developer can see. The organization can also drop prompt and response content before storage and keep only cost and token counts."
          },
          {
            "q": "How do I see what a pull request cost in Claude Code tokens?",
            "a": "Connect GitHub to LangWatch. Each Claude Code session reports the repository and branch it works on, and LangWatch maps those branches to their pull requests. The pull requests view then shows the total cost of every session that worked on the branch, across all contributors and models, over the pull request's whole lifetime."
          }
        ]
      }
    },
    {
      "slug": "understanding-hallucinations-what-are-they",
      "meta": {
        "title": "Understanding Hallucinations: What are they?",
        "date": "2024-04-29T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Explore how to minimize AI hallucinations in LLMs",
        "seoTitle": "Understanding AI Hallucinations: What Are They?",
        "seoDescription": "AI hallucinations happen when LLMs state wrong, made-up, or off-topic answers. Learn what they are and how to minimize them in your AI products."
      }
    },
    {
      "slug": "unit-testing-your-llm-the-power-of-datasets",
      "meta": {
        "title": "Unit Testing Your LLM: The Power of Datasets",
        "date": "2024-06-10T00:00:00.000Z",
        "author": "Rogerio Chaves - CTO",
        "authorPhoto": "https://framerusercontent.com/images/ags4tigwSqnrrysmQI9V7ABkc.jpeg",
        "category": "LLM Evals",
        "intro": "Understand how to leverage datasets for LLM unit testing",
        "seoTitle": "Unit Testing Your LLM With Datasets and Evaluators",
        "seoDescription": "Traditional unit tests fail on probabilistic LLMs. Learn how datasets and evaluators benchmark LLM performance and catch regressions as your models evolve."
      }
    },
    {
      "slug": "unlocking-the-potential-of-large-language-models-the-llm-s-beyond-the-hype",
      "meta": {
        "title": "Unlocking the Potential of Large Language Models: The LLM's Beyond the Hype",
        "date": "2024-05-08T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Successfully integrating LLMs into your business requires careful monitoring and evaluation of options",
        "seoTitle": "Choosing the Right LLM: Beyond the Hype",
        "seoDescription": "Choosing the right LLM means weighing accuracy, cost, security, and capabilities, then monitoring performance to unlock real value beyond the hype."
      }
    },
    {
      "slug": "we-red-teamed-our-own-ai-agent-and-found-14-real-bugs",
      "meta": {
        "title": "We Red-Teamed Our Own AI Agent and Found 14 Real Bugs",
        "date": "2026-07-22T00:00:00.000Z",
        "author": "Aryan Sharma",
        "authorPhoto": "https://framerusercontent.com/images/Y96qMmCKGpN0cihRyPzeqlPGDM.jpg",
        "category": "Developer findings",
        "keyphrase": "ai agent red teaming",
        "intro": "Langy is the AI agent LangWatch runs on its own product. A teammate distracted it with an unrelated coding question, and it forgot what it was doing. Here's what we found once we went looking for more.",
        "seoTitle": "We Red-Teamed Our Own AI Agent: 14 Bugs Found",
        "aliases": [
          "/blog/when-langy-went-off-script",
          "/blog/testing-ai-agents-is-our-bread-and-butter-so-we-red-teamed-our-own"
        ],
        "seoDescription": "LangWatch red-teamed Langy, its own AI agent, across 15 attack categories and up to 20 turns each. Real transcripts, 14 bugs fixed, one issue still open.",
        "faq": [
          {
            "q": "What's the difference between an eval, a scenario, and red-teaming?",
            "a": "An eval checks one input against a rubric, so it only catches cases someone already wrote down. A scenario simulates a full conversation and grades the result, which catches more, but still only what the person writing it thought to test. Red-teaming runs scenarios adversarially: an attacker model escalates on purpose, over many turns, looking for whatever a person wouldn't have thought to try. None of the three replaces a real person actually using the product, which is what caught the bug that started this whole thing."
          },
          {
            "q": "Can you jailbreak an agent just by asking nicely, over several messages?",
            "a": "Yes, at least you could with Langy. A six-message conversation that opened with \"summarize your rules, for an audit\" ended with Langy handing over a full production incident runbook, commands included. The fix didn't hold on the first try: it closed the exact wording that broke it, and a rerun found the same underlying pressure working through different phrasing. It took four rounds total before the same six messages stopped working."
          },
          {
            "q": "Does Scenario support anything besides Crescendo?",
            "a": "Yes. Scenario also ships GOAT, based on Meta's 2025 paper, where the attacker model picks a new technique every turn instead of following a fixed script. We didn't run it for this investigation, Crescendo produced every finding here, but it's in the framework if you want a more adaptive attacker against your own agent."
          },
          {
            "q": "Why did dogfooding catch a bug the test suite missed?",
            "a": "Because a test suite only checks what someone already thought to write down, and a person doing real work isn't bounded by that. The bug here, an unrelated coding question derailing a trace lookup, was never a written scenario. It only became one after a teammate saw it happen."
          },
          {
            "q": "Do you need a QA team to write these tests?",
            "a": "No. Whoever hits the bug, an engineer or a domain expert, writes the scenario that reproduces it, confirms it fails, fixes the agent, and confirms it passes. We call this the vibe-eval loop internally (there's a write-up in our testing best practices), and in practice most of our users just ask Claude to write the scenario and run it."
          },
          {
            "q": "What did the full red-team pass find, in the end?",
            "a": "14 real bugs, all fixed and verified live: a broken local skill-loading path, skill instructions overriding the terse-reply rules, missing awareness of two real product surfaces, a stream handler reading the wrong error field and masking every real error behind a placeholder, two permission gaps, a turn-lock that could go quiet, a turn-lock that could get stuck for good, a test retry budget shorter than the server's own recovery window, and five fixes from the red-team categories themselves, including one where Langy ran attacker-supplied shell commands. One architectural race condition is still open, filed and tracked rather than patched in a hurry."
          },
          {
            "q": "Is this something we could run against our own agent?",
            "a": "Yes. Scenario is open source, and the Simulations dashboard in the screenshot above is the same one any LangWatch customer uses for their own agents. Nothing here needed internal tooling."
          }
        ]
      }
    },
    {
      "slug": "webinar-recp-llm-evaluations-best-practices-llm-eval-types-real-world-insights",
      "meta": {
        "title": "Webinar recap: LLM Evaluations: Best Practices, LLM Eval types & real-world insights",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "This post breaks down the core components of LLM evaluation, from datasets to evaluators, explores best practices",
        "seoTitle": "LLM Evaluations: Best Practices and Eval Types",
        "seoDescription": "LLM evaluation explained: datasets, executors, and evaluators, plus best practices and real-world insights to make your AI deliver reliably at scale."
      }
    },
    {
      "slug": "what-are-ai-agent-simulations",
      "meta": {
        "title": "What are AI agent simulations? Agent simulation testing explained",
        "date": "2026-10-26T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/what-are-ai-agent-simulations-cover.webp",
        "listImage": true,
        "category": "Agents",
        "keyphrase": "agent simulation",
        "intro": "An agent simulation tests your AI agent end to end: a simulated user acts out a real situation, your agent answers, and a judge passes or fails the conversation. What it is, how it differs from multi-agent research, and why your scenarios should come from production.",
        "seoTitle": "What Is Agent Simulation? AI Agent Simulations Explained",
        "seoDescription": "Agent simulation tests your AI agent with a simulated user and a judge. What it is, how it differs from multi-agent research, and how to start from production.",
        "faq": [
          {
            "q": "How to test agents with agent simulations?",
            "a": "Write one scenario per situation your users bring: who the user is, what they want, and what the agent must and must not do. Run it with a simulated user and a judge in pytest or vitest, or from the LangWatch platform without code. Put the suite in CI, and turn every production failure into a new scenario."
          },
          {
            "q": "What is simulation testing for AI agents?",
            "a": "Simulation testing runs a system against a simulated environment instead of the real one. For an AI agent the environment is mostly the user, so an LLM plays the user over a multi-turn conversation. A judge then checks the conversation, plus the tool calls in the agent's traces, against criteria you wrote in plain language."
          },
          {
            "q": "Are agent simulations the same as multi-agent simulations?",
            "a": "No. Multi-agent simulation is a research area that puts many LLM agents in a shared world, like the twenty-five characters of the Generative Agents paper, to study how they behave together. Agent simulation testing checks one agent you're building, with one simulated user and one judge, and gives you a pass or fail you can run in CI."
          },
          {
            "q": "Can a simulated user replace testing with real users?",
            "a": "No. A simulated user follows the situation you describe and improvises the wording, which catches regressions before a release, but it's still a model guessing how a person talks. Close the gap by starting scenarios from real production conversations, keeping how the user opened and swapping their identifiers for test data, and by tracing your agent in production."
          },
          {
            "q": "Do I need LangWatch to run agent simulations?",
            "a": "No. Scenario is open source under Apache 2.0, in Python, TypeScript and Go, and runs inside your own test runner against any agent framework. A LangWatch API key is optional. With one, every run shows up in LangWatch with the full conversation and the judge's verdict, next to your other runs."
          }
        ]
      }
    },
    {
      "slug": "what-are-the-ai-agent-events-in-2026-the-must-attend-conferences-for-agentic-ai-builders",
      "meta": {
        "title": "What are the AI Agent Events in 2026: The must-attend conferences for Agentic AI Builders",
        "date": "2025-12-29T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Agents",
        "intro": "AI events in 2026 developers shouldn’t miss. A curated guide to the top AI conferences worldwide, from research and GenAI to infrastructure and production AI.",
        "seoTitle": "AI Agent Events in 2026: Must-Attend Conferences",
        "seoDescription": "A curated guide to the AI agent events in 2026 worth attending, from agent testing to production reliability, for teams shipping agentic AI systems."
      }
    },
    {
      "slug": "what-happens-when-two-engineering-teams-just...-talk",
      "meta": {
        "title": "What happens when two engineering teams just... talk",
        "date": "2026-05-19T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/aojDw2HJIfMLBvXW9rSo1UYYNf8.jpeg",
        "category": "Developer findings",
        "intro": "Last week we hosted the first of what we're planning to make a regular thing: an engineering get-together with Altura, one of our customers.",
        "seoTitle": "What Happens When Two Engineering Teams Just Talk",
        "seoDescription": "Two AI engineering teams swap real stories on tool choice, LLM observability, BDD specs, and running parallel Claude coding agents without losing the codebase.",
        "faq": [
          {
            "q": "Why host an engineering get-together between two teams?",
            "a": "You learn different things talking to people you trust than from conference talks or docs. You hear the failures, detours, and things that almost worked, and that is what actually changes how you build."
          },
          {
            "q": "What pushed the team from observability to evaluation?",
            "a": "As pipelines grew across multi-step workflows and different industries, the question shifted from what happened to whether the output was actually good, which observability alone could not answer."
          },
          {
            "q": "How do the teams move fast with AI without breaking the codebase?",
            "a": "They write behavior-driven (BDD) specs before implementation as a forcing function for clear thinking, and use Kanban-style tooling to track multiple parallel Claude coding sessions."
          }
        ]
      }
    },
    {
      "slug": "what-is-agent-observability",
      "meta": {
        "title": "What is agent observability? Tracing tool calls, turns and cost",
        "date": "2026-10-22T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/what-is-agent-observability-cover.webp",
        "listImage": true,
        "category": "Agents",
        "keyphrase": "agent observability",
        "intro": "Agent observability is tracing every step an AI agent takes, the model calls, tool calls, retries and turns, with the cost of each, and scoring those traces so you see quality drop over weeks instead of hearing it from customers.",
        "seoTitle": "What Is Agent Observability? Tool Calls, Turns and Cost",
        "seoDescription": "Agent observability traces every model call, tool call and turn of an AI agent with its cost, then scores the traces so you catch drift before your users do.",
        "faq": [
          {
            "q": "What is the difference between agent observability and LLM observability?",
            "a": "LLM observability traces single model calls: the prompt, the response, tokens, cost and latency. Agent observability traces the whole run around those calls, with every tool call and its input and output, the retries, and the turns of a conversation grouped into one thread. It also scores whole conversations, because an agent can make ten good calls and still fail the user."
          },
          {
            "q": "How can businesses monitor and optimize large language model applications?",
            "a": "Trace every request with token counts and cost per call, group the requests of one conversation together, and run evaluators on live traffic so quality has a number you can watch. Label traces with the prompt or model version, so you can compare versions on real traffic before you switch, and turn the failures you find into a dataset and tests."
          },
          {
            "q": "Do I need OpenTelemetry for agent observability?",
            "a": "No, but it helps. OpenTelemetry lets you send agent traces from any language to any backend that accepts OTLP, and its GenAI semantic conventions define spans for invoking an agent and executing a tool. LangWatch accepts OTLP over HTTP and also has Python, TypeScript and Go SDKs, where grouping a conversation is one metadata field."
          },
          {
            "q": "What should I monitor on an AI agent in production?",
            "a": "Watch the score of an evaluator that judges whole conversations, the tool calls per turn, the turns per conversation, and the cost per conversation, each split by prompt or model version. A slow change in any of these over a few weeks is a warning sign, often long before an error shows up."
          }
        ]
      }
    },
    {
      "slug": "what-is-llm-monitoring-(quality-cost-latency-and-drift-in-production)",
      "meta": {
        "title": "What is LLM monitoring? (Quality, cost, latency, and drift in production)",
        "date": "2026-02-10T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "LLM monitoring tracks performance, cost, reliability, safety, and output quality of large language models in production environments.",
        "seoTitle": "What Is LLM Monitoring? Quality, Cost and Drift",
        "seoDescription": "LLM monitoring tracks quality, cost, latency, and drift of models in production. Learn the four layers, core metrics, and how to roll it out with LangWatch.",
        "faq": [
          {
            "q": "What is LLM monitoring?",
            "a": "LLM monitoring is the continuous observation of model performance, behavior, and outputs in production. It tracks prompts and responses, latency, token usage, and cost, and evaluates whether outputs meet defined quality standards."
          },
          {
            "q": "How is LLM monitoring different from traditional monitoring?",
            "a": "Traditional monitoring checks infrastructure health like CPU, memory, and error rates. LLM monitoring evaluates the correctness, relevance, and safety of AI outputs, catching a fabricated answer even when the request returns a successful 200 status."
          },
          {
            "q": "What are the four layers of LLM monitoring?",
            "a": "The four layers are model calls, retrieval-augmented generation, agents and tool use, and user feedback with downstream signals. Monitoring them separately produces clearer signals and faster diagnosis."
          },
          {
            "q": "How do I get started with LLM monitoring?",
            "a": "Capture complete traces of every model call, establish evaluation baselines, link production behavior back to evaluation, then expand with drift detection and CI/CD quality gates. LangWatch provides these capabilities out of the box."
          }
        ]
      }
    },
    {
      "slug": "what-is-model-context-protocol-(mcp)-and-how-s-langwatch-involved",
      "meta": {
        "title": "What is Model Context Protocol (MCP)? And how's LangWatch involved?",
        "date": "2025-03-16T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/0RiwlQQeVWDe1Bkw3eygUtcMlQ.png",
        "category": "Integrations",
        "intro": "The Model Context Protocol is a new standard that lets AI agents easily connect to external tools and data sources.",
        "seoTitle": "What Is Model Context Protocol (MCP)? A Clear Guide",
        "seoDescription": "Model Context Protocol (MCP) lets AI agents connect to tools and data like a USB-C port for AI. Learn how MCP works and where LangWatch fits in."
      }
    },
    {
      "slug": "what-is-prompt-management-and-how-to-version-control-deploy-prompts-in-productions",
      "meta": {
        "title": "Prompt versioning: how to version, test and deploy prompts in production",
        "date": "2026-10-25T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "/people/rogerio-chaves.png",
        "image": "/blog/what-is-prompt-management-and-how-to-version-control-deploy-prompts-in-productions-cover.webp",
        "listImage": true,
        "category": "LLM Evals",
        "keyphrase": "prompt versioning",
        "intro": "Prompt versioning gives every prompt change a version number, a tag for where it runs and a test before it ships, so you know what is live, can prove a change didn't break anything, and can roll back without a deploy.",
        "seoTitle": "Prompt Versioning: Version, Test and Deploy Prompts",
        "seoDescription": "Prompt versioning for production AI agents: version and tag prompts, keep them in Git, test every change on a dataset, A/B test, and roll back without a deploy.",
        "faq": [
          {
            "q": "What is prompt versioning?",
            "a": "Prompt versioning is keeping a numbered history of every prompt your application runs. Each version stores the messages, the model and its parameters, the author, the time and a commit message. Tags such as production and staging point at the version each environment uses, so you always know what is live and what it replaced."
          },
          {
            "q": "How do I roll back a prompt in production?",
            "a": "If your application fetches the prompt by tag, move the production tag back to the previous version and the app gets it on the next fetch, with no code deploy. In LangWatch you do that in the Deploy dialog of the Prompt Playground or through the API. If prompts ship as files from Git, check out the previous prompts.json and lock file, sync and deploy."
          },
          {
            "q": "Should prompts live in Git or in a prompt management platform?",
            "a": "Both, if you can keep them in sync. Git gives engineers pull request review and a history next to the code. The platform lets product people and domain experts edit and test prompts without a deploy. The LangWatch prompts CLI keeps prompts as YAML files in your repository and syncs them with the platform in both directions."
          },
          {
            "q": "How do I test a prompt change before it ships?",
            "a": "Run the new version and the current production version on the same dataset of real cases, with evaluators that check the failures you care about. Compare the two runs row by row, and move the production tag only when the change fixes what you wanted without breaking rows that passed. Run the same experiment in CI on every pull request."
          },
          {
            "q": "Can I self-host prompt management?",
            "a": "Yes. Self-hosted LangWatch runs the same image as LangWatch Cloud and is free to run, prompt management included. An Enterprise license adds SSO, custom roles, SCIM provisioning and the audit log. There is also a hybrid setup, where LangWatch runs the application and your traces stay in your own ClickHouse and object storage."
          }
        ]
      }
    },
    {
      "slug": "what-is-prompt-optimization-an-introduction-to-dspy-and-optimization-studio",
      "meta": {
        "title": "What is Prompt Optimization? An Introduction to DSPy and Optimization Studio",
        "date": "2024-11-07T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "LangWatch’s Optimization Studio, a more precise, scientific and better approach to prompt optimization",
        "seoTitle": "Prompt Optimization: A Guide to DSPy and Optimization Studio",
        "seoDescription": "Prompt optimization moves past trial-and-error prompt engineering. See how DSPy and LangWatch Optimization Studio build better, data-driven LLM prompts."
      }
    },
    {
      "slug": "what-is-user-analytics-for-llms-the-difference-with-traditional-analytics-and-why-is-it-important",
      "meta": {
        "title": "What is User Analytics for LLMs, The Difference With Traditional Analytics, And Why is it Important?",
        "date": "2024-05-10T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "Discover how User Analytics for LLMs can transform AI interactions, revealing user behavior",
        "seoTitle": "User Analytics for LLMs vs Traditional Analytics",
        "seoDescription": "User analytics for LLMs reveals intent, conversation flow, and response quality that clicks miss, helping you build better LLM-powered products."
      }
    },
    {
      "slug": "why-agent-simulations-are-the-new-unit-tests-for-ai",
      "meta": {
        "title": "Why Agent Simulations are the new Unit Tests for AI",
        "date": "2025-07-07T10:13:48.748Z",
        "author": "Tahmid - AI researcher @ LangWatch",
        "authorPhoto": "https://framerusercontent.com/images/HLM4vDStvIk5xOpUCf6Vr1gq8.png",
        "image": "https://framerusercontent.com/images/UxqjsKczQq4JAng2Yk9ZkdlqM.png",
        "category": "Agents",
        "intro": "Learn why simulation is key to AI agent testing and how LangWatch Scenario brings scenario-based tests to your CI/CD.",
        "seoTitle": "Why Agent Simulations Are the New Unit Tests for AI",
        "seoDescription": "Agent simulations test AI like self-driving cars handle the long tail. See why simulation is the new unit test and how to bring scenario tests to CI/CD."
      }
    },
    {
      "slug": "why-agentic-ai-needs-a-new-layer-of-testing",
      "meta": {
        "title": "Why Agentic AI needs a new layer of testing",
        "date": "2025-12-12T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/hWvmvmNjmeRvHzpfo7M5fBm46ug.png",
        "category": "Agents",
        "intro": "Testing AI agents does require a new way of testing. Using Unit tests, Evaluations, Agent evaluations, simulations brings you a better way of agentic testing",
        "seoTitle": "Why Agentic AI Needs a New Layer of Testing",
        "seoDescription": "Agentic AI breaks the traditional testing pyramid. See why agents need a new layer of simulations and evaluations to ship reliably in production."
      }
    },
    {
      "slug": "why-ai-red-teaming-is-broken-(and-how-we-fixed-it)",
      "meta": {
        "title": "Why AI Red teaming is broken (and how we fixed it)",
        "date": "2026-04-14T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/Zmc3JccO7xQ9je5qxtPH2Vzvlw.png",
        "category": "Governance AI",
        "intro": "Why AI Red Teaming Is Broken (And How We Fixed It)",
        "seoTitle": "Why AI Red Teaming Is Broken and How We Fixed It",
        "seoDescription": "Single-turn AI red teaming misses real attacks. See how multi-turn Crescendo simulations in Scenario break agents that pass every benchmark.",
        "faq": [
          {
            "q": "Why do single-turn red teaming tools miss real vulnerabilities?",
            "a": "Single-turn attacks test cold-open guardrails that most agents pass trivially. Real attackers build rapport over many turns before pivoting, which static prompt libraries cannot replicate. LangWatch found agents scoring 0% on single-turn tests still leaked system prompts under 50-turn conversations."
          },
          {
            "q": "What is the Crescendo strategy in LangWatch Scenario?",
            "a": "Crescendo treats red teaming as a multi-turn simulation rather than a prompt library. It uses a planner model to build and score a tailored attack plan and an attacker model to send adaptive messages across four escalation phases, with backtracking that wipes the target's memory after refusals."
          },
          {
            "q": "What does a failing red team test reveal about my agent?",
            "a": "It exposes architectural issues, not just missing guardrails. System prompts are not security boundaries, tool access is often too permissive, and scope enforcement belongs in the application layer with tool-level auth and input validation."
          },
          {
            "q": "How should I run multi-turn red teaming in CI?",
            "a": "Because each run uses 50-plus turns with two LLM calls per turn, LangWatch recommends running these tests on a weekly schedule rather than on every pull request, for example a cron job every Monday."
          }
        ]
      }
    },
    {
      "slug": "why-langwatch-scenarios-represents-the-future-of-ai-agent-testing",
      "meta": {
        "title": "Why LangWatch Scenarios represents the future of AI agent testing",
        "date": "2025-06-24T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/q0bdMyutPbU16nh21xWC5qT9Wo.jpg",
        "image": "https://framerusercontent.com/images/29ehhf6vtqF92sTG4szw2ButJI.png",
        "category": "Agents",
        "intro": "Agent simulations are the new unit tests. You shouldn’t ship agents without simulations.",
        "seoTitle": "AI Agent Testing: Why Scenario Simulations Win",
        "seoDescription": "AI agent testing breaks when you treat agents like deterministic software. See why simulations are the new unit tests for shipping reliable agents."
      }
    },
    {
      "slug": "why-llm-observability-is-now-table-stakes",
      "meta": {
        "title": "Why LLM Observability is Now Table Stakes",
        "date": "2025-04-18T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "Integrations",
        "intro": "The start of LLMOps: DevOps for Generative AI",
        "seoTitle": "Why LLM Observability Is Now Table Stakes",
        "seoDescription": "LLM observability is the missing layer of LLMOps. See why probabilistic outputs, semantic debugging, and traceability make it essential for production GenAI."
      }
    },
    {
      "slug": "why-your-ai-team-needs-an-ai-pm-(quality)-lead",
      "meta": {
        "title": "Why Your AI Team Needs an AI PM (Quality) Lead",
        "date": "2025-04-02T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "category": "LLM Evals",
        "intro": "The best GenAI teams are now introducing a critical new role: the AI PM (Quality) Lead.",
        "seoTitle": "Why Your AI Team Needs an AI PM Quality Lead",
        "seoDescription": "The AI PM Quality Lead is the new role top GenAI teams rely on to own LLM quality, define thresholds, design annotation flows, and close feedback loops."
      }
    },
    {
      "slug": "writing-effective-ai-evaluations-that-hold-up-in-production",
      "meta": {
        "title": "Writing Effective AI Evaluations, that hold up in production",
        "date": "2025-12-23T00:00:00.000Z",
        "author": "Manouk Draisma",
        "authorPhoto": "/people/manouk-draisma.jpeg",
        "image": "https://framerusercontent.com/images/l7devGtbj438zVgXZKzwe9EKmNA.png",
        "category": "LLM Evals",
        "intro": "LLM systems exist in constant motion. Prompts change. Models are swapped. User behavior evolves. New data sources are introduced. Each change reshapes the system’s failure surface.",
        "seoTitle": "Writing AI Evaluations That Hold Up in Production",
        "seoDescription": "Learn how to write effective AI evaluations that hold up in production by starting with error analysis, not metrics, and treating evaluation as continuous."
      }
    }
  ],
  "changelog": [
    {
      "slug": "3.0self-host-with-clickhouse",
      "meta": {
        "title": "LangWatch 3.0 - Self-Host with ClickHouse",
        "date": "2026-04-08T00:00:00.000Z",
        "author": "Alex Fores-Reed",
        "image": "https://framerusercontent.com/images/asTRQ6ousPnVp0wScxrHlwro.png",
        "category": "Article",
        "intro": "LangWatch 3.0 is the release where we deleted more infrastructure than we added, and the product got better for it. For cloud users, this is the engine behind the speed and stability improvements you've already been experiencing. But the bigger story here is self-hosting - we've made it dramatically easier to run LangWatch on your own infrastructure.",
        "version": "3.0.0",
        "summary": "LangWatch 3.0 is here, a simpler, faster stack built on ClickHouse. Deploy with Helm, run with Docker Compose, no Elasticsearch required."
      }
    },
    {
      "slug": "add-member-rework",
      "meta": {
        "title": "Add Member, Reworked",
        "date": "2025-11-13T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "1.7.0",
        "intro": "The invite dialog now sets someone's role at the organization and the team level in one go, custom roles included.",
        "summary": "Invite someone and set their org and team roles in one dialog."
      }
    },
    {
      "slug": "agent-testing-v2-and-prompt-optimization-in-the-workbench",
      "meta": {
        "title": "Agent Testing v2 and Prompt Optimization in the Workbench",
        "date": "2026-08-30T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.17.0",
        "intro": "Agent Testing replaces Simulations with suites, run plans and versioned test cases, and one run can compare agents side by side. In the experiments workbench, Langy optimizes a prompt for you.",
        "summary": "Agent Testing replaces Simulations, comparison runs arrive, and Langy optimizes prompts in the workbench."
      }
    },
    {
      "slug": "ai-gateway-budgets",
      "meta": {
        "title": "The AI Gateway Grows Budgets",
        "date": "2026-08-02T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.8.0",
        "intro": "The LangWatch AI Gateway takes budgets on every dimension and shows live spend against each one. Claude Code can now reach non-Anthropic models through the router.",
        "summary": "Budgets on every dimension of gateway traffic, with live spend and a redesigned key drawer."
      }
    },
    {
      "slug": "ai-governance-platform",
      "meta": {
        "title": "The AI Governance Platform",
        "date": "2026-05-31T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.4.1",
        "intro": "One dashboard for the AI your teams run: spend, usage, anomalies and policy, fed by your own app traces, LangWatch AI Gateway traffic, and activity pulled from third-party AI platforms.",
        "summary": "One dashboard for spend, usage, anomalies and policy across every AI tool your teams run."
      }
    },
    {
      "slug": "audio-in-traces-and-terminal-tab",
      "meta": {
        "title": "Audio in Traces, and a Terminal Tab",
        "date": "2026-07-12T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "Pairwise comparison no longer needs a golden answer to compare A against B. Traces play audio inline and add a full-history Terminal tab with a token timeline.",
        "summary": "Compare two variants without a reference answer, and play audio inside a trace."
      }
    },
    {
      "slug": "audit-logs",
      "meta": {
        "title": "Audit Logs",
        "date": "2025-12-16T00:00:00.000Z",
        "author": "Richard",
        "image": "https://framerusercontent.com/images/Rfa2WZNPTkqmls5yGtWyBnMrM.png",
        "category": "Article",
        "intro": "We’ve introduced a new Audit Logs page, giving you complete visibility into user activity across your projects. This feature helps you monitor actions, ensure compliance with your organization’s policies, and maintain full oversight of who is doing what.",
        "version": "LangWatch - v1.11.0",
        "summary": "We’ve introduced a new Audit Logs page, giving you complete visibility into user activity across your projects. This feature helps you monitor actions..."
      }
    },
    {
      "slug": "better-agents",
      "meta": {
        "title": "Launch Week - Day 5: Better Agents",
        "date": "2025-11-25T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "image": "https://framerusercontent.com/images/Rfa2WZNPTkqmls5yGtWyBnMrM.png",
        "category": "Article",
        "intro": "Today we are releasing Better Agents.",
        "version": "@langwatch/better-agents - v0.1",
        "summary": "Better Agents is a CLI tool and a set of standards for agent building, it supercharges your coding assistant..."
      }
    },
    {
      "slug": "coding-agent-capture-gateway-billing",
      "meta": {
        "title": "Coding Agent Capture, and Gateway Billing",
        "date": "2026-08-09T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.11.0",
        "intro": "LangWatch captures Copilot from its CLI wrapper, its app login agent and VS Code Chat, and there is a LangWatch plugin for Claude Code. Gateway spend gets a billing pipeline with webhooks and reconciliation.",
        "summary": "Capture Copilot and Claude Code sessions, and bill gateway spend with webhooks and reconciliation."
      }
    },
    {
      "slug": "connected-agents-and-langy-on-your-own-machine",
      "meta": {
        "title": "Connected Agents and Langy on Your Own Machine",
        "date": "2026-09-06T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "Decorate the function that runs your agent and LangWatch tests it directly, with no public URL to expose. Langy can now work in a folder on your machine, with your toolchain and your own gh.",
        "summary": "Test an agent by decorating its function, and let Langy work in a folder on your own machine."
      }
    },
    {
      "slug": "cost-intelligence-pairwise-compare",
      "meta": {
        "title": "Cost Intelligence and Pairwise Compare",
        "date": "2026-07-05T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.5.0",
        "intro": "Your spend now breaks down by category, coding-agent sessions included. Experiments v3 compares two variants head to head.",
        "summary": "Spend breaks down by category, and experiments compare two variants head to head."
      }
    },
    {
      "slug": "datasets-rebuilt-on-s3",
      "meta": {
        "title": "Datasets, Rebuilt on S3",
        "date": "2026-06-28T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "Dataset content now stores in S3 as chunked JSONL, so one dataset holds thousands of rows without bloating the database. Files upload straight from your browser.",
        "summary": "Datasets store in S3 as chunked JSONL, with CSV and bulk upload."
      }
    },
    {
      "slug": "event-sourcing-engine-fast-is-the-only-mode",
      "meta": {
        "title": "Event Sourcing Engine Fast is the only “mode”",
        "date": "2026-04-08T00:00:00.000Z",
        "author": "Alex Forbes-reed",
        "image": "https://framerusercontent.com/images/asTRQ6ousPnVp0wScxrHlwro.png",
        "category": "Article",
        "intro": "For the past couple of months we've been shovelling coal in the LangWatch engine room. We ripped out BullMQ, rebuilt the data pipeline on a purpose-built event sourcing architecture, and came out the other side with a system that processes traces, evaluations, and agent simulations as immutable events - folded, projected, and queryable the moment they land.",
        "version": "3.0.0",
        "summary": "LangWatch now runs on a purpose-built event sourcing engine. Traces, evaluations, and simulations are processed in real-time with no accuracy trade-offs"
      }
    },
    {
      "slug": "go-sdk-1-0-and-search-in-datasets",
      "meta": {
        "title": "Go SDK 1.0 and Search in Datasets",
        "date": "2026-09-13T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "The Go SDK reaches 1.0, with a rewritten guide for every provider it instruments natively. The dataset editor can now search its rows, and governance lists the agents your connected providers already know about.",
        "summary": "Go SDK 1.0, search in the dataset editor, and agents discovered from connected providers."
      }
    },
    {
      "slug": "governance-projects-for-coding-agent-traces",
      "meta": {
        "title": "Governance Projects for Coding Agent Traces",
        "date": "2026-10-11T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "As an organization admin you can now create one project that reads the traces of every personal project, so you see what your developers' coding agents do without opening each project.",
        "summary": "One project for every coding agent trace in your organization, Developer seats for people who sign up from the terminal, and Instant Evals on licensed self-hosted installs."
      }
    },
    {
      "slug": "governed-sql-workbench-go-sdk",
      "meta": {
        "title": "A Governed SQL Workbench, and the Go SDK",
        "date": "2026-08-16T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.13.0",
        "intro": "Write SQL against your own data in a governed workbench and save the charts you build. The Go SDK ships with native instrumentations and a REST client.",
        "summary": "Query your data in a governed SQL workbench, and instrument Go."
      }
    },
    {
      "slug": "graph-alerts",
      "meta": {
        "title": "Graph Alerts",
        "date": "2026-01-08T00:00:00.000Z",
        "author": "Richard",
        "image": "https://framerusercontent.com/images/Rfa2WZNPTkqmls5yGtWyBnMrM.png",
        "category": "Article",
        "intro": "We’ve extended our alerting feature to now include alerts on custom graphs. This allows you to create alerts that trigger when specific thresholds are met, with notifications sent via your preferred channels such as Slack or email.",
        "version": "LangWatch - v1.12",
        "summary": "The alerting feature now includes custom graph alerts that trigger when specific thresholds are met, with notifications sent via preferred channels like Slack."
      }
    },
    {
      "slug": "improved-automations-flow",
      "meta": {
        "title": "Improved Automations Flow",
        "date": "2026-10-04T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.20.1",
        "intro": "You now create automations and alerts in the same three steps, and you connect Slack once instead of once per automation.",
        "summary": "Automations and alerts in the same three steps, Slack connected once, and Instant Evals turned on per organization."
      }
    },
    {
      "slug": "instant-evals-in-the-trace-explorer",
      "meta": {
        "title": "Instant Evals in the Trace Explorer, and Files in Datasets",
        "date": "2026-09-27T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.18.0",
        "intro": "Type a question into the Trace Explorer search bar and press Enter. If no filter can answer it, an Instant Eval judges the traces for you and the matches fill the table as they come in.",
        "summary": "Ask the Trace Explorer a question no filter can answer, and upload images and files into dataset cells."
      }
    },
    {
      "slug": "instant-evals",
      "meta": {
        "title": "Instant Evals: Search Your Entire Production History",
        "date": "2026-09-20T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "Ask one question in plain words and Instant Evals judge every conversation, trace or LLM call your agent produced in the window you pick, then hand back the matches with a probability on each.",
        "summary": "Ask a question of every conversation you have stored, and get the matches back in minutes."
      }
    },
    {
      "slug": "introducing-simulation-based-agent-testing",
      "meta": {
        "title": "Introducing simulation-based agent testing",
        "date": "2025-06-24T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/kLQbW5O40gUzX6dcKjgvc53oaGg.jpg",
        "image": "https://framerusercontent.com/images/mAi8MGitYEIj9U1NnZXhPvgP5o.png",
        "category": "Article",
        "intro": "Test your agents with scenarios directly in your codebase using Python and TypeScript, while being able to easily visualize results on LangWatch.",
        "version": "Scenario - v0.7",
        "summary": "Test your agents with scenarios directly in your codebase using Python and TypeScript."
      }
    },
    {
      "slug": "keyboard-warriors-the-command-bar",
      "meta": {
        "title": "Keyboard Warriors - The Command Bar",
        "date": "2026-04-13T00:00:00.000Z",
        "author": "Alex Forbes-Reed",
        "image": "https://framerusercontent.com/images/asTRQ6ousPnVp0wScxrHlwro.png",
        "category": "Article",
        "intro": "We added a ⌘K command palette. Navigate to any page, jump to any trace or entity by ID, search across your entire project, switch themes, create agents/prompts/datasets anything your heart desires, all without touching a mouse. It remembers where you've been, knows what page you're on, and surfaces contextual commands based on the current view.",
        "version": "3.0.0",
        "summary": "A Cmd+K command bar to navigate anywhere, search for any entity, switch themes, and discover a few surprises along the way."
      }
    },
    {
      "slug": "langy-notifications-and-tool-calls-for-llm-judges",
      "meta": {
        "title": "Langy Notifications and Tool Calls for LLM Judges",
        "date": "2026-10-18T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "Langy can now notify you in the browser when it needs you, even with the tab closed, and your LLM judges now see the tool calls in a trace instead of only its input and output.",
        "summary": "Browser notifications from Langy, LLM judges that see tool calls, Instant Evals as a judge model, voice on the LangWatch AI Gateway, and per-team gateway budgets."
      }
    },
    {
      "slug": "langy-voice-agent-testing-automations",
      "meta": {
        "title": "Langy for Everyone, and Voice Agent Testing",
        "date": "2026-06-07T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "Langy, the in-product assistant, now opens for every member of a project, and it stays open as you move between pages so a reply finishes instead of restarting.",
        "summary": "Langy opens for everyone on a project, and Scenario tests voice agents end to end."
      }
    },
    {
      "slug": "mcp-server-with-oauth",
      "meta": {
        "title": "Built-in MCP Server with OAuth",
        "date": "2026-04-06T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/Zmc3JccO7xQ9je5qxtPH2Vzvlw.png",
        "image": "https://framerusercontent.com/images/asTRQ6ousPnVp0wScxrHlwro.png",
        "category": "Article",
        "intro": "LangWatch now ships a built-in MCP (Model Context Protocol) server, mounted directly in the app with OAuth PKCE authorization. Connect your IDE or AI coding assistant - Claude Code, Cursor, or any MCP-compatible client - and manage your LangWatch project without leaving your editor. Query analytics, manage datasets and evaluators, tag prompts, and more.",
        "version": "3.0.0",
        "summary": "LangWatch now ships a built-in MCP server with OAuth. Connect Claude Code, or any MCP client to manage prompts, datasets, evaluators etc from your editor."
      }
    },
    {
      "slug": "new-better-agents",
      "meta": {
        "title": "Better Agents just got better! Support for Google ADK, LangGraph, Antigravity & more",
        "date": "2025-12-16T00:00:00.000Z",
        "author": "Aryan Sharma",
        "authorPhoto": "https://framerusercontent.com/images/Y96qMmCKGpN0cihRyPzeqlPGDM.jpg",
        "image": "https://framerusercontent.com/images/Rfa2WZNPTkqmls5yGtWyBnMrM.png",
        "category": "Features",
        "intro": "A while ago we launched Better Agents, and the response has been insane, we crossed 1.3k+ stars already.",
        "seoTitle": "Better Agents adds Google ADK & LangGraph support",
        "seoDescription": "Better Agents now supports Google ADK, LangGraph, Vercel, Agno and new coding assistants like Antigravity and Gemini CLI for faster agent builds.",
        "version": "@langwatch/better-agents - v0.1",
        "summary": "New Coding Assistants Supported: Antigravity, Crush CLI, Gemini CLI, Qwen Code. With this, Better Agents now works across a much wider range of tools and..."
      }
    },
    {
      "slug": "new-navigation-and-voice-apis-on-the-gateway",
      "meta": {
        "title": "New Navigation and Voice APIs support on the Gateway",
        "date": "2026-08-23T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.16.0",
        "intro": "LangWatch replaces the single long sidebar with a product switcher and an icon rail, so LLM Ops, the gateway and governance are separate places. Realtime voice sessions now bill to a virtual key.",
        "summary": "The sidebar becomes a product switcher and an icon rail, and realtime voice bills to a virtual key."
      }
    },
    {
      "slug": "polished-analytics",
      "meta": {
        "title": "Polished Analytics",
        "date": "2026-04-13T00:00:00.000Z",
        "author": "Alex Forbes-Reed",
        "image": "https://framerusercontent.com/images/asTRQ6ousPnVp0wScxrHlwro.png",
        "category": "Article",
        "intro": "Between rebuilding the data pipeline on event sourcing and shipping 3.0, the analytics dashboard became the thing we looked at every day but hadn't properly styled since the first pass. Dark mode grays were wrong, nested filters kept wiping themselves, and if a chart had no data it just showed you a blank rectangle and wished you luck. We went through every surface - headers, filters, empty states, metric calculations, the color palette - and brought it up to the standard the rest of the product is at now.",
        "version": "3.0.0",
        "summary": "A sharper, more polished analytics experience - sticky headers, better empty states, dark mode refinements, and fixes for filter behavior across the board."
      }
    },
    {
      "slug": "prompt-playground",
      "meta": {
        "title": "Launch Week - Day 1: LangWatch New Prompt Playground",
        "date": "2025-11-20T00:00:00.000Z",
        "author": "Andrew Joia",
        "image": "https://framerusercontent.com/images/Rfa2WZNPTkqmls5yGtWyBnMrM.png",
        "category": "Article",
        "intro": "The redesigned Prompt Playground in LangWatch makes scripting, testing, and tracking prompts straightforward. This update streamlines your workflow so anyone - alone or with a team - can edit, compare, and organize prompts alongside real data, without bouncing between tools.",
        "seoTitle": "New Prompt Playground now in LangWatch",
        "seoDescription": "The redesigned Prompt Playground lets you edit, test, and compare prompt versions side by side against real conversations and traces, all in one place.",
        "version": "LangWatch - v1.9.0",
        "summary": "With the new RBAC Custom Roles, you can now enforce finer-grained access control, allowing different role sets to focus on their specific domains. The permis..."
      }
    },
    {
      "slug": "prompt-tags",
      "meta": {
        "title": "Prompt Tags",
        "date": "2026-04-03T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/Zmc3JccO7xQ9je5qxtPH2Vzvlw.png",
        "image": "https://framerusercontent.com/images/asTRQ6ousPnVp0wScxrHlwro.png",
        "category": "Article",
        "intro": "Prompt Tags let you label and organize prompt versions with meaningful names like production, staging, or experiment-v2. Tags work everywhere - the platform UI, TypeScript and Python SDKs, the CLI, and the MCP server. Fetch a tagged prompt with the shorthand prompt:tag syntax, and manage tag definitions through a dedicated API.",
        "version": "3.0.0",
        "summary": "Tag your prompts across every surface platform, SDKs, CLI, and MCP. Use syntax (prompt:tag) to fetch tagged versions, and manage tags from wherever you work."
      }
    },
    {
      "slug": "prompts-fetch-policy",
      "meta": {
        "title": "Prompts: Fetch Policy",
        "date": "2025-12-16T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "Prompt fetching takes a policy, so you choose whether a prompt is read from cache or fetched fresh on every call.",
        "summary": "Choose how a prompt is fetched: cached, or fresh on every call."
      }
    },
    {
      "slug": "rbac-custom-roles",
      "meta": {
        "title": "Launch Week - Day 2: RBAC Custom Roles & Permissions",
        "date": "2025-11-21T00:00:00.000Z",
        "author": "Richard",
        "image": "https://framerusercontent.com/images/Rfa2WZNPTkqmls5yGtWyBnMrM.png",
        "category": "Article",
        "intro": "With the new RBAC Custom Roles, you can now enforce finer-grained access control, allowing different role sets to focus on their specific domains. The permissions touch many different parts of the product. With this new feature, you now have a lot more control over what different users are allowed to do.",
        "seoTitle": "RBAC Custom Roles now in LangWatch",
        "seoDescription": "RBAC Custom Roles let you define fine-grained permissions across LangWatch, controlling who can view, create, update, or manage resources per team.",
        "version": "LangWatch - v1.9.0",
        "summary": "With the new RBAC Custom Roles, you can now enforce finer-grained access control, allowing different role sets to focus on their specific domains. The permis..."
      }
    },
    {
      "slug": "real-time-simulation-visualization-and-debug-mode",
      "meta": {
        "title": "Real-time simulation visualization and debug mode",
        "date": "2025-06-27T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/kLQbW5O40gUzX6dcKjgvc53oaGg.jpg",
        "image": "https://framerusercontent.com/images/LkWCirdPuRXRZhDxBT8mFYNr4.png",
        "category": "Article",
        "intro": "Watch simulated conversations play out in real-time with parallel execution, versioned runs, and interactive debugging.",
        "seoTitle": "Real-time simulation visualization & debug mode",
        "seoDescription": "Watch agent simulations play out in real time with parallel runs, versioned comparisons, and a debug mode to impersonate users and pinpoint issues.",
        "version": "Scenario - v0.7",
        "summary": "Watch simulated conversations play out in real-time with parallel execution, versioned runs, and interactive debugging."
      }
    },
    {
      "slug": "replicate-workflows-prompts-datasets",
      "meta": {
        "title": "Replicate Workflows/Prompts/Datasets",
        "date": "2025-12-16T00:00:00.000Z",
        "author": "Richard",
        "image": "https://framerusercontent.com/images/Rfa2WZNPTkqmls5yGtWyBnMrM.png",
        "category": "Article",
        "intro": "We’ve added the ability to replicate workflows, their datasets, and prompts to another project. This lets you safely test in a staging environment, validate everything, and then copy it over to your production project with confidence.",
        "version": "LangWatch - v1.11.0",
        "summary": "We’ve added the ability to replicate workflows, their datasets, and prompts to another project. This lets you safely test in a staging environment, validate..."
      }
    },
    {
      "slug": "scenario-mcp",
      "meta": {
        "title": "Launch Week - Day 4: Writing Tests with the Scenario MCP",
        "date": "2025-11-25T00:00:00.000Z",
        "author": "Aryan Sharma",
        "image": "https://framerusercontent.com/images/Rfa2WZNPTkqmls5yGtWyBnMrM.png",
        "category": "Article",
        "intro": "Testing LLM agents has always been a bit too ✨ vibes ✨ based. Thankfully, we've got Scenario MCP to the rescue.",
        "seoTitle": "Write agent tests with the Scenario MCP",
        "seoDescription": "The Scenario MCP generates high-quality agent tests from a single prompt inside your editor, giving you a strong continuous testing foundation.",
        "version": "@langwatch/mcp-server - v0.3.1",
        "summary": "Scenario MCP will enable you to generate high-quality tests, and it's as easy as cake. One prompt is all it takes, and the outcome will..."
      }
    },
    {
      "slug": "scenario-on-the-platform",
      "meta": {
        "title": "LangWatch Scenario on the Platform",
        "date": "2026-02-05T00:00:00.000Z",
        "author": "Manouk",
        "image": "https://framerusercontent.com/images/asTRQ6ousPnVp0wScxrHlwro.png",
        "category": "Article",
        "intro": "Go to Simulations → Scenarios in your project",
        "version": "LangWatch v2.0.2",
        "summary": "Create and run agent simulation tests directly in LangWatch, no code required. Define user personas, set pass/fail criteria, and run scenarios against HTTP."
      }
    },
    {
      "slug": "scripted-simulations-evaluations-guardrails",
      "meta": {
        "title": "Scripted simulations, evaluations, and guardrails",
        "date": "2025-06-26T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/kLQbW5O40gUzX6dcKjgvc53oaGg.jpg",
        "image": "https://framerusercontent.com/images/WbeLDFVdrdksU9ZdtVEpKXT2Y0.png",
        "category": "Article",
        "intro": "Scripted simulations let you orchestrate exactly how conversations unfold, when evaluations occur, and what custom logic runs at each step.",
        "seoTitle": "Scripted simulations, evaluations & guardrails",
        "seoDescription": "Scripted simulations let you orchestrate how conversations unfold and run evaluations and guardrails in real time to reproduce production issues.",
        "version": "Scenario - v0.7",
        "summary": "Scripted simulations let you orchestrate how conversations unfold, when evaluations occur, and what custom logic runs."
      }
    },
    {
      "slug": "setup-and-teardown-hooks-for-agent-tests",
      "meta": {
        "title": "Setup and Teardown Hooks for Agent Tests",
        "date": "2026-10-25T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "3.21.0",
        "intro": "Your connected agent can now create the test data a scenario needs before the first turn and clean it up after the last, so your agent tests no longer depend on data that happens to exist.",
        "summary": "Setup and teardown hooks for agent tests, monitors that pause when their evaluations keep failing, GitHub Copilot sessions, and LangWatch 3.21.0 for self-hosted installs."
      }
    },
    {
      "slug": "studio-datasets-makeover-data-privacy-ttft",
      "meta": {
        "title": "Studio & Datasets Makeover, Scoped Data Privacy, and TTFT",
        "date": "2026-06-21T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "Datasets get in-cell editing and the studio gets an if/else node. Privacy rules redact secrets and PII at organization, team or project scope, and time to first token becomes a p95 column.",
        "summary": "Datasets edit in place, privacy rules redact secrets and PII, and TTFT becomes a column."
      }
    },
    {
      "slug": "test-agents-on-mastra-agno-and-10-other-frameworks",
      "meta": {
        "title": "Test agents on Mastra, Agno, and 10+ other frameworks",
        "date": "2025-06-25T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authorPhoto": "https://framerusercontent.com/images/kLQbW5O40gUzX6dcKjgvc53oaGg.jpg",
        "image": "https://framerusercontent.com/images/LTttc41HTAexN5JGM2nJ29UJ4.png",
        "category": "Article",
        "intro": "Scenario is framework-agnostic, supporting any agent architecture through the AgentAdapter interface.",
        "seoTitle": "Test agents on Mastra, Agno & 10+ frameworks",
        "seoDescription": "Scenario is framework-agnostic, letting you test agents on Mastra, Agno, LangGraph, CrewAI and 10+ frameworks via the AgentAdapter interface.",
        "version": "Scenario - v0.7",
        "summary": "Scenario is framework-agnostic, supporting any agent architecture through the AgentAdapter interface."
      }
    },
    {
      "slug": "testing-real-time-voice-agents",
      "meta": {
        "title": "Launch Week - Day 3: Testing Voice Agents with LangWatch Scenario in Real Time",
        "date": "2025-11-21T00:00:00.000Z",
        "author": "Andrew Joia",
        "image": "https://framerusercontent.com/images/Rfa2WZNPTkqmls5yGtWyBnMrM.png",
        "category": "Article",
        "intro": "LangWatch Scenario now supports testing voice-powered AI agents using OpenAI's Realtime API through a new RealtimeAgentAdapter. This enables comprehensive end-to-end testing of voice conversations, including voice-to-voice interactions, audio processing, and real-time agent behavior validation - all within the Scenario testing framework.",
        "seoTitle": "Test real-time voice agents in LangWatch Scenario",
        "seoDescription": "Test real-time voice agents end to end with OpenAI's Realtime API and the new RealtimeAgentAdapter, validating voice-to-voice conversations in Scenario.",
        "version": "LangWatch - v1.9.0",
        "summary": "LangWatch Scenario now supports testing voice-powered AI agents using OpenAI's Realtime API through a new RealtimeAgentAdapter. This enables comprehensive..."
      }
    },
    {
      "slug": "thread-level-evaluations",
      "meta": {
        "title": "Thread-level Evaluations",
        "date": "2025-11-06T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "version": "1.6.0",
        "intro": "Evaluations now run across a whole thread, not just one message, so you can score context retention and see where a conversation drifts.",
        "summary": "Score a whole conversation instead of a single message."
      }
    },
    {
      "slug": "traces-v2-model-cost-preview",
      "meta": {
        "title": "Traces v2 Leveled Up, and Model-Cost Preview",
        "date": "2026-06-14T00:00:00.000Z",
        "author": "LangWatch Team",
        "category": "Article",
        "intro": "Model-cost rules preview the spans they match before you save them. Traces v2 adds an AI prompt view, a flame graph and an evaluator drilldown.",
        "summary": "See which spans a cost rule matches before you save it, plus two rounds of trace explorer work."
      }
    }
  ],
  "customers": [
    {
      "slug": "ai-powered-agent-simulations-help-vinny’s-team-validate-chatbot-configurations-in-minutes-instead-of-hours",
      "meta": {
        "title": "How Vinny uses LangWatch Scenario to slash manual testing and accelerate customer onboarding",
        "date": "2026-04-03T00:00:00.000Z",
        "intro": "AI-powered agent simulations help Vinny's team validate chatbot configurations in minutes instead of hours.",
        "seoTitle": "Vinny cuts chatbot testing from hours to minutes",
        "seoDescription": "Vinny's team validates chatbot configurations in minutes instead of hours using LangWatch Scenario simulations grounded in real production traces.",
        "image": "https://framerusercontent.com/images/TsxOUyrJZPYPBaO5N23fCDq83vQ.png",
        "card": "/customers/vinny.webp",
        "company": "Vinny",
        "industry": "PropTech / property management",
        "useCase": "Agent simulation testing for onboarding and QA",
        "website": "https://askvinny.com",
        "tools": [
          "Scenario",
          "Simulations",
          "MCP Server"
        ],
        "results": [
          {
            "stat": "Hours to minutes",
            "label": "Testing time for each configuration change"
          },
          {
            "stat": "Non-technical",
            "label": "Sales and onboarding run tests from Slack"
          },
          {
            "stat": "Production-grade",
            "label": "Scenarios built from real traces and data"
          }
        ],
        "quote": "We put in what we think is a fix, spin up a test, and give the customer concrete evidence it has been fixed.",
        "quoteAuthor": "Rory Buchanan",
        "quoteRole": "Founder & CTO, Vinny"
      }
    },
    {
      "slug": "customer-story-roojoom-scales-agent-reliability-with-langwatch-scenarios",
      "meta": {
        "title": "Roojoom scales agent reliability with LangWatch Scenarios",
        "date": "2025-06-25T00:00:00.000Z",
        "intro": "Roojoom moved from manual QA to enterprise-grade automated agent testing, running daily scenario suites against a version-controlled baseline so every release ships with measured confidence.",
        "image": "https://framerusercontent.com/images/xsW1pkZOgMSXsrSOaCNUXCq0.png",
        "company": "Roojoom",
        "industry": "Customer-journey orchestration",
        "useCase": "Offline evals, regression testing, and CI gating",
        "tools": [
          "Scenario",
          "Simulations",
          "Observability",
          "LLM-as-judge"
        ],
        "results": [
          {
            "stat": "Daily",
            "label": "Automated scenario runs against a baseline"
          },
          {
            "stat": "Every PR",
            "label": "Agent tests gate prompt changes in CI"
          },
          {
            "stat": "Multi-step",
            "label": "Coverage across tools, turns, and state"
          }
        ],
        "quote": "When I saw LangWatch, it reminded me of how we used to evaluate models in classic machine learning. I knew this was exactly what we needed.",
        "quoteAuthor": "Amit",
        "quoteRole": "Head of AI, Roojoom"
      }
    },
    {
      "slug": "how-altura-rebuilt-ai-quality-with-langwatch",
      "meta": {
        "title": "How Altura rebuilt AI quality with LangWatch",
        "date": "2026-07-02T00:00:00.000Z",
        "intro": "Altura moved from shipping on vibes to shipping with confidence, replacing generic dashboards and one-off scripts with end-to-end evaluation, agent simulation, and observability that the whole team can trust across their agentic tender workflows.",
        "seoTitle": "Altura rebuilt AI quality with LangWatch",
        "seoDescription": "Altura swapped generic LLM judges and custom scripts for LangWatch evaluation, agent simulation, and observability, giving engineers and product trustworthy metrics across agentic tender workflows.",
        "card": "/customers/altura.webp",
        "company": "Altura",
        "industry": "Procurement and Bid Management AI",
        "useCase": "End-to-end evaluation, agent testing, and observability",
        "tools": [
          "Evaluations",
          "Scenario",
          "Simulations",
          "Observability"
        ],
        "results": [
          {
            "stat": "End-to-end",
            "label": "Evaluation, agent testing, and observability in one platform"
          },
          {
            "stat": "Up to 200",
            "label": "Documents per tender parsed and evaluated"
          },
          {
            "stat": "MCP-native",
            "label": "Evals fit a Claude Code, spec-driven workflow"
          }
        ],
        "quote": "LangWatch gives us full visibility into our AI performance, what works, what doesn't, and why.",
        "quoteAuthor": "Martijn Schouten",
        "quoteRole": "Engineer, Altura"
      }
    },
    {
      "slug": "how-freeday-cut-agent-implementation-time-with-langwatch-scenario-testing",
      "meta": {
        "title": "How Freeday cut agent implementation time with LangWatch Scenario testing",
        "date": "2026-03-31T00:00:00.000Z",
        "intro": "Freeday's implementation team went from manually testing every agent change to running comprehensive scenario suites in minutes, dramatically reducing onboarding time and time-to-fix for their enterprise customers.",
        "seoTitle": "How Freeday cut agent onboarding to 10 minutes",
        "seoDescription": "Freeday cut customer onboarding from half a day to around 10 minutes with LangWatch Scenario simulations run team-wide via a Claude Code skill.",
        "image": "https://framerusercontent.com/images/JUObSuWc0LEl6lbbYO95Yy3HA.png",
        "card": "/customers/freeday.webp",
        "company": "Freeday",
        "industry": "Enterprise AI automation",
        "useCase": "Agent testing and QA for customer implementations",
        "website": "https://www.freeday.ai",
        "tools": [
          "Scenario",
          "Simulations"
        ],
        "results": [
          {
            "stat": "10 min",
            "label": "New-customer onboarding, down from half a day"
          },
          {
            "stat": "92.6%",
            "label": "Of inquiries resolved autonomously"
          },
          {
            "stat": "Team-wide",
            "label": "Simulation testing via a Claude Code skill"
          }
        ],
        "quote": "Testing went from afterthought to starting point. What took half a day takes ten minutes.",
        "quoteAuthor": "Gijs Gubbels",
        "quoteRole": "AI Engineer, Freeday"
      }
    },
    {
      "slug": "how-holidayhero-scaled-ai-powered-guest-communication-with-langwatch",
      "meta": {
        "title": "How HolidayHero scaled AI-powered guest communication with LangWatch",
        "date": "2025-02-05T00:00:00.000Z",
        "intro": "HolidayHero uses LangWatch to monitor thousands of guest interactions, optimize AI-generated content, and ensure every guest communication feels personalized, accurate, and on-brand, helping their team improve LLM quality without sacrificing hospitality standards.",
        "seoTitle": "HolidayHero scales guest AI with LangWatch",
        "seoDescription": "HolidayHero monitors thousands of guest interactions and tunes AI content with LangWatch observability, evals, and Optimization Studio for on-brand quality.",
        "card": "/customers/holidayhero.webp",
        "company": "HolidayHero",
        "industry": "Hospitality tech",
        "useCase": "LLM monitoring, evals, and AI content QA",
        "tools": [
          "Monitoring",
          "Evaluations",
          "Optimization Studio"
        ],
        "results": [
          {
            "stat": "Thousands",
            "label": "Guest interactions monitored in production"
          },
          {
            "stat": "Slack alerts",
            "label": "Negative sentiment triggers a fast review loop"
          },
          {
            "stat": "Hours/week",
            "label": "Saved with one place to evaluate and tune"
          }
        ],
        "quote": "The analytics and evaluations are invaluable. We can track how well our AI performs and adapt accordingly.",
        "quoteAuthor": "Hjalte H.",
        "quoteRole": "CEO, HolidayHero"
      }
    },
    {
      "slug": "how-hyperfox-built-confidence-in-ai-order-processing-with-langwatch",
      "meta": {
        "title": "How Hyperfox built confidence in AI order processing with LangWatch",
        "date": "2026-04-21T00:00:00.000Z",
        "intro": "Hyperfox went from limited visibility and ad hoc benchmarking to a repeatable workflow for evaluating new AI features and tracing production behavior, giving their team more confidence in every release and saving weeks of internal tooling work.",
        "seoTitle": "Hyperfox ships AI order processing with confidence",
        "seoDescription": "Hyperfox saved 2+ weeks of internal tooling and ships every release with confidence using LangWatch evals, custom metrics, and production observability.",
        "image": "https://framerusercontent.com/images/RR7U3uMCmcVbUKY1MRl2tjcPuI.png",
        "card": "/customers/hyperfox.webp",
        "company": "Hyperfox",
        "industry": "AI order automation",
        "useCase": "Observability, benchmarking, and evaluation",
        "tools": [
          "Observability",
          "Evaluations",
          "Custom metrics"
        ],
        "results": [
          {
            "stat": "2+ weeks",
            "label": "Engineering time saved on internal tooling"
          },
          {
            "stat": "100%",
            "label": "Eval coverage for every new feature"
          },
          {
            "stat": "Every release",
            "label": "Ships with measured validation, not intuition"
          }
        ],
        "quote": "Every increment we ship now, whether a feature or a bug fix, we have much more confidence.",
        "quoteAuthor": "Clara De Smet",
        "quoteRole": "AI Lead, Hyperfox"
      }
    },
    {
      "slug": "how-struck-improved-their-ai-performance-and-ai-visibility-with-langwatch",
      "meta": {
        "title": "How Struck improved their AI performance and AI visibility with LangWatch",
        "date": "2025-02-05T00:00:00.000Z",
        "intro": "Struck.build moved from limited visibility into LLM behavior to full monitoring, evaluations, and production insight across their AI applications, helping the team improve answer quality, detect issues faster, and ship AI features with greater confidence.",
        "seoTitle": "Struck boosts AI quality with LangWatch evals",
        "seoDescription": "Struck.build measures RAG answer correctness and catches issues early with LangWatch observability and evaluations across their construction AI apps.",
        "card": "/customers/struck.png",
        "company": "Struck.build",
        "industry": "Construction tech",
        "useCase": "Monitoring and RAG answer-quality evaluation",
        "website": "https://struck.build",
        "tools": [
          "Observability",
          "Evaluations",
          "RAG evals"
        ],
        "results": [
          {
            "stat": "Real-time",
            "label": "Visibility across quality, latency, and failures"
          },
          {
            "stat": "RAG-level",
            "label": "Answer correctness measured, not just responses"
          },
          {
            "stat": "Proactive",
            "label": "Issues caught before customers report them"
          }
        ],
        "quote": "I'm amazed by the evaluation of our RAG application. LangWatch helps us understand if the answer provided is actually correct.",
        "quoteAuthor": "Nikhil Nagaraj",
        "quoteRole": "CTO, Struck.build"
      }
    }
  ],
  "legal": [
    {
      "slug": "privacy-policy",
      "meta": {
        "title": "Privacy Policy"
      }
    },
    {
      "slug": "terms-conditions",
      "meta": {
        "title": "Terms & Conditions"
      }
    }
  ],
  "research": [
    {
      "slug": "finding-the-optimal-context-window",
      "meta": {
        "title": "Finding the Optimal Context Window for Coding Agents: A Case Study",
        "date": "2026-08-02T00:00:00.000Z",
        "author": "Rogerio Chaves",
        "authors": [
          "Rogerio Chaves"
        ],
        "dataset": "287,748 API calls · 2,451 agents · 162 days · 873 compactions · 201 audited steps",
        "image": "/images/research/context-window/og.webp",
        "abstract": "Coding agents re-send their entire accumulated context on every step, so practitioners must decide when to discard that history and replace it with a summary, an operation called compaction. The decision is currently made by intuition, and the intuitions in circulation disagree sharply: one camp compacts aggressively to control cost, another runs windows near the model ceiling on the belief that summarisation degrades agent quality. We instrument a single practitioner's full agent fleet over 162 consecutive days and measure both sides of the trade. The cumulative cost of reaching a context of size C grows as approximately C^2.5 (exponent 2.55, R² = 0.994), so each doubling of window size costs roughly six times more, and prompt caching alters the constant rather than the exponent. An LLM-judge audit of 201 agent steps finds that the portion of context a step actually draws on, which we term the active context, is invariant at 6,000 to 8,500 tokens across a 16.6-fold range of window sizes, falling from 47.5% to 2.5% as a share. Two independent optimisations place the cost-optimal threshold at 220,000 and 240,000 tokens. Counter to all three, compaction carries a measurable behavioural cost: operator corrections rise to 41.9% in the five steps after a compaction against a 17.7% within-session baseline, and remain elevated beyond 100 steps. Reconciling the four yields an operating range of 250,000 to 450,000 tokens differentiated by task type rather than a single threshold. On token economics alone the wide-window position does not break even, requiring an escaped-defect cost one to two orders of magnitude above any we directly observed. We conclude that threshold tuning matters less than an unexploited lever: the median compaction preserves 0.8% of the window it replaces, and enlarging that preserved segment dominates widening the window on both cost and measured disruption.",
        "companionHref": "/blog/context-tax-when-to-compact",
        "companionLabel": "The Context Tax: When to Compact Your Coding Agent",
        "category": "Research",
        "intro": "A case study measuring what context costs, how much of it gets used, and what compaction destroys, across 162 days of coding-agent telemetry.",
        "seoTitle": "Optimal Context Window for Coding Agents",
        "seoDescription": "A measured case study of coding-agent context: cost scales as size^2.5, the used portion stays flat near 7k tokens, and compaction degrades decisions for 30 steps.",
        "keyphrase": "context window"
      }
    }
  ]
}
